/**
 * Holds result values
 * @format int32
 */
export var ApiErrorBaseCode;
(function (ApiErrorBaseCode) {
    ApiErrorBaseCode[ApiErrorBaseCode["Value0"] = 0] = "Value0";
    ApiErrorBaseCode[ApiErrorBaseCode["Value2"] = 2] = "Value2";
    ApiErrorBaseCode[ApiErrorBaseCode["Value3"] = 3] = "Value3";
    ApiErrorBaseCode[ApiErrorBaseCode["Value4"] = 4] = "Value4";
    ApiErrorBaseCode[ApiErrorBaseCode["Value5"] = 5] = "Value5";
    ApiErrorBaseCode[ApiErrorBaseCode["Value6"] = 6] = "Value6";
    ApiErrorBaseCode[ApiErrorBaseCode["Value7"] = 7] = "Value7";
    ApiErrorBaseCode[ApiErrorBaseCode["Value8"] = 8] = "Value8";
    ApiErrorBaseCode[ApiErrorBaseCode["Value9"] = 9] = "Value9";
    ApiErrorBaseCode[ApiErrorBaseCode["Value10"] = 10] = "Value10";
    ApiErrorBaseCode[ApiErrorBaseCode["Value11"] = 11] = "Value11";
    ApiErrorBaseCode[ApiErrorBaseCode["Value12"] = 12] = "Value12";
    ApiErrorBaseCode[ApiErrorBaseCode["Value13"] = 13] = "Value13";
    ApiErrorBaseCode[ApiErrorBaseCode["Value14"] = 14] = "Value14";
    ApiErrorBaseCode[ApiErrorBaseCode["Value15"] = 15] = "Value15";
    ApiErrorBaseCode[ApiErrorBaseCode["Value17"] = 17] = "Value17";
    ApiErrorBaseCode[ApiErrorBaseCode["Value18"] = 18] = "Value18";
    ApiErrorBaseCode[ApiErrorBaseCode["Value19"] = 19] = "Value19";
    ApiErrorBaseCode[ApiErrorBaseCode["Value20"] = 20] = "Value20";
    ApiErrorBaseCode[ApiErrorBaseCode["Value21"] = 21] = "Value21";
    ApiErrorBaseCode[ApiErrorBaseCode["Value24"] = 24] = "Value24";
    ApiErrorBaseCode[ApiErrorBaseCode["Value25"] = 25] = "Value25";
    ApiErrorBaseCode[ApiErrorBaseCode["Value26"] = 26] = "Value26";
    ApiErrorBaseCode[ApiErrorBaseCode["Value27"] = 27] = "Value27";
    ApiErrorBaseCode[ApiErrorBaseCode["Value28"] = 28] = "Value28";
    ApiErrorBaseCode[ApiErrorBaseCode["Value29"] = 29] = "Value29";
    ApiErrorBaseCode[ApiErrorBaseCode["Value30"] = 30] = "Value30";
    ApiErrorBaseCode[ApiErrorBaseCode["Value33"] = 33] = "Value33";
    ApiErrorBaseCode[ApiErrorBaseCode["Value34"] = 34] = "Value34";
    ApiErrorBaseCode[ApiErrorBaseCode["Value43"] = 43] = "Value43";
    ApiErrorBaseCode[ApiErrorBaseCode["Value57"] = 57] = "Value57";
    ApiErrorBaseCode[ApiErrorBaseCode["Value61"] = 61] = "Value61";
    ApiErrorBaseCode[ApiErrorBaseCode["Value62"] = 62] = "Value62";
    ApiErrorBaseCode[ApiErrorBaseCode["Value63"] = 63] = "Value63";
    ApiErrorBaseCode[ApiErrorBaseCode["Value69"] = 69] = "Value69";
    ApiErrorBaseCode[ApiErrorBaseCode["Value71"] = 71] = "Value71";
    ApiErrorBaseCode[ApiErrorBaseCode["Value75"] = 75] = "Value75";
    ApiErrorBaseCode[ApiErrorBaseCode["Value76"] = 76] = "Value76";
    ApiErrorBaseCode[ApiErrorBaseCode["Value81"] = 81] = "Value81";
    ApiErrorBaseCode[ApiErrorBaseCode["Value84"] = 84] = "Value84";
    ApiErrorBaseCode[ApiErrorBaseCode["Value88"] = 88] = "Value88";
    ApiErrorBaseCode[ApiErrorBaseCode["Value92"] = 92] = "Value92";
    ApiErrorBaseCode[ApiErrorBaseCode["Value94"] = 94] = "Value94";
    ApiErrorBaseCode[ApiErrorBaseCode["Value95"] = 95] = "Value95";
    ApiErrorBaseCode[ApiErrorBaseCode["Value96"] = 96] = "Value96";
    ApiErrorBaseCode[ApiErrorBaseCode["Value99"] = 99] = "Value99";
    ApiErrorBaseCode[ApiErrorBaseCode["Value105"] = 105] = "Value105";
    ApiErrorBaseCode[ApiErrorBaseCode["Value108"] = 108] = "Value108";
    ApiErrorBaseCode[ApiErrorBaseCode["Value109"] = 109] = "Value109";
    ApiErrorBaseCode[ApiErrorBaseCode["Value110"] = 110] = "Value110";
    ApiErrorBaseCode[ApiErrorBaseCode["Value111"] = 111] = "Value111";
    ApiErrorBaseCode[ApiErrorBaseCode["Value112"] = 112] = "Value112";
    ApiErrorBaseCode[ApiErrorBaseCode["Value113"] = 113] = "Value113";
    ApiErrorBaseCode[ApiErrorBaseCode["Value114"] = 114] = "Value114";
    ApiErrorBaseCode[ApiErrorBaseCode["Value115"] = 115] = "Value115";
    ApiErrorBaseCode[ApiErrorBaseCode["Value116"] = 116] = "Value116";
    ApiErrorBaseCode[ApiErrorBaseCode["Value117"] = 117] = "Value117";
    ApiErrorBaseCode[ApiErrorBaseCode["Value118"] = 118] = "Value118";
    ApiErrorBaseCode[ApiErrorBaseCode["Value119"] = 119] = "Value119";
    ApiErrorBaseCode[ApiErrorBaseCode["Value120"] = 120] = "Value120";
    ApiErrorBaseCode[ApiErrorBaseCode["Value121"] = 121] = "Value121";
    ApiErrorBaseCode[ApiErrorBaseCode["Value122"] = 122] = "Value122";
    ApiErrorBaseCode[ApiErrorBaseCode["Value123"] = 123] = "Value123";
    ApiErrorBaseCode[ApiErrorBaseCode["Value124"] = 124] = "Value124";
    ApiErrorBaseCode[ApiErrorBaseCode["Value125"] = 125] = "Value125";
    ApiErrorBaseCode[ApiErrorBaseCode["Value126"] = 126] = "Value126";
    ApiErrorBaseCode[ApiErrorBaseCode["Value127"] = 127] = "Value127";
    ApiErrorBaseCode[ApiErrorBaseCode["Value128"] = 128] = "Value128";
    ApiErrorBaseCode[ApiErrorBaseCode["Value129"] = 129] = "Value129";
    ApiErrorBaseCode[ApiErrorBaseCode["Value130"] = 130] = "Value130";
    ApiErrorBaseCode[ApiErrorBaseCode["Value131"] = 131] = "Value131";
    ApiErrorBaseCode[ApiErrorBaseCode["Value132"] = 132] = "Value132";
    ApiErrorBaseCode[ApiErrorBaseCode["Value133"] = 133] = "Value133";
    ApiErrorBaseCode[ApiErrorBaseCode["Value134"] = 134] = "Value134";
    ApiErrorBaseCode[ApiErrorBaseCode["Value135"] = 135] = "Value135";
    ApiErrorBaseCode[ApiErrorBaseCode["Value136"] = 136] = "Value136";
    ApiErrorBaseCode[ApiErrorBaseCode["Value137"] = 137] = "Value137";
    ApiErrorBaseCode[ApiErrorBaseCode["Value138"] = 138] = "Value138";
    ApiErrorBaseCode[ApiErrorBaseCode["Value139"] = 139] = "Value139";
    ApiErrorBaseCode[ApiErrorBaseCode["Value140"] = 140] = "Value140";
    ApiErrorBaseCode[ApiErrorBaseCode["Value141"] = 141] = "Value141";
    ApiErrorBaseCode[ApiErrorBaseCode["Value142"] = 142] = "Value142";
    ApiErrorBaseCode[ApiErrorBaseCode["Value143"] = 143] = "Value143";
    ApiErrorBaseCode[ApiErrorBaseCode["Value144"] = 144] = "Value144";
    ApiErrorBaseCode[ApiErrorBaseCode["Value155"] = 155] = "Value155";
    ApiErrorBaseCode[ApiErrorBaseCode["Value156"] = 156] = "Value156";
    ApiErrorBaseCode[ApiErrorBaseCode["Value157"] = 157] = "Value157";
    ApiErrorBaseCode[ApiErrorBaseCode["Value158"] = 158] = "Value158";
    ApiErrorBaseCode[ApiErrorBaseCode["Value159"] = 159] = "Value159";
    ApiErrorBaseCode[ApiErrorBaseCode["Value160"] = 160] = "Value160";
    ApiErrorBaseCode[ApiErrorBaseCode["Value161"] = 161] = "Value161";
    ApiErrorBaseCode[ApiErrorBaseCode["Value162"] = 162] = "Value162";
    ApiErrorBaseCode[ApiErrorBaseCode["Value163"] = 163] = "Value163";
    ApiErrorBaseCode[ApiErrorBaseCode["Value164"] = 164] = "Value164";
    ApiErrorBaseCode[ApiErrorBaseCode["Value165"] = 165] = "Value165";
    ApiErrorBaseCode[ApiErrorBaseCode["Value166"] = 166] = "Value166";
    ApiErrorBaseCode[ApiErrorBaseCode["Value167"] = 167] = "Value167";
    ApiErrorBaseCode[ApiErrorBaseCode["Value168"] = 168] = "Value168";
    ApiErrorBaseCode[ApiErrorBaseCode["Value169"] = 169] = "Value169";
    ApiErrorBaseCode[ApiErrorBaseCode["Value170"] = 170] = "Value170";
    ApiErrorBaseCode[ApiErrorBaseCode["Value171"] = 171] = "Value171";
    ApiErrorBaseCode[ApiErrorBaseCode["Value172"] = 172] = "Value172";
    ApiErrorBaseCode[ApiErrorBaseCode["Value173"] = 173] = "Value173";
    ApiErrorBaseCode[ApiErrorBaseCode["Value174"] = 174] = "Value174";
    ApiErrorBaseCode[ApiErrorBaseCode["Value175"] = 175] = "Value175";
    ApiErrorBaseCode[ApiErrorBaseCode["Value176"] = 176] = "Value176";
    ApiErrorBaseCode[ApiErrorBaseCode["Value177"] = 177] = "Value177";
    ApiErrorBaseCode[ApiErrorBaseCode["Value178"] = 178] = "Value178";
    ApiErrorBaseCode[ApiErrorBaseCode["Value179"] = 179] = "Value179";
    ApiErrorBaseCode[ApiErrorBaseCode["Value180"] = 180] = "Value180";
    ApiErrorBaseCode[ApiErrorBaseCode["Value181"] = 181] = "Value181";
    ApiErrorBaseCode[ApiErrorBaseCode["Value182"] = 182] = "Value182";
    ApiErrorBaseCode[ApiErrorBaseCode["Value183"] = 183] = "Value183";
    ApiErrorBaseCode[ApiErrorBaseCode["Value184"] = 184] = "Value184";
    ApiErrorBaseCode[ApiErrorBaseCode["Value185"] = 185] = "Value185";
    ApiErrorBaseCode[ApiErrorBaseCode["Value186"] = 186] = "Value186";
    ApiErrorBaseCode[ApiErrorBaseCode["Value187"] = 187] = "Value187";
    ApiErrorBaseCode[ApiErrorBaseCode["Value188"] = 188] = "Value188";
    ApiErrorBaseCode[ApiErrorBaseCode["Value189"] = 189] = "Value189";
    ApiErrorBaseCode[ApiErrorBaseCode["Value190"] = 190] = "Value190";
    ApiErrorBaseCode[ApiErrorBaseCode["Value191"] = 191] = "Value191";
    ApiErrorBaseCode[ApiErrorBaseCode["Value192"] = 192] = "Value192";
    ApiErrorBaseCode[ApiErrorBaseCode["Value193"] = 193] = "Value193";
    ApiErrorBaseCode[ApiErrorBaseCode["Value194"] = 194] = "Value194";
    ApiErrorBaseCode[ApiErrorBaseCode["Value195"] = 195] = "Value195";
    ApiErrorBaseCode[ApiErrorBaseCode["Value196"] = 196] = "Value196";
    ApiErrorBaseCode[ApiErrorBaseCode["Value197"] = 197] = "Value197";
    ApiErrorBaseCode[ApiErrorBaseCode["Value198"] = 198] = "Value198";
    ApiErrorBaseCode[ApiErrorBaseCode["Value199"] = 199] = "Value199";
    ApiErrorBaseCode[ApiErrorBaseCode["Value200"] = 200] = "Value200";
    ApiErrorBaseCode[ApiErrorBaseCode["Value201"] = 201] = "Value201";
    ApiErrorBaseCode[ApiErrorBaseCode["Value202"] = 202] = "Value202";
    ApiErrorBaseCode[ApiErrorBaseCode["Value203"] = 203] = "Value203";
    ApiErrorBaseCode[ApiErrorBaseCode["Value204"] = 204] = "Value204";
    ApiErrorBaseCode[ApiErrorBaseCode["Value205"] = 205] = "Value205";
    ApiErrorBaseCode[ApiErrorBaseCode["Value206"] = 206] = "Value206";
    ApiErrorBaseCode[ApiErrorBaseCode["Value207"] = 207] = "Value207";
    ApiErrorBaseCode[ApiErrorBaseCode["Value208"] = 208] = "Value208";
    ApiErrorBaseCode[ApiErrorBaseCode["Value209"] = 209] = "Value209";
    ApiErrorBaseCode[ApiErrorBaseCode["Value210"] = 210] = "Value210";
    ApiErrorBaseCode[ApiErrorBaseCode["Value211"] = 211] = "Value211";
    ApiErrorBaseCode[ApiErrorBaseCode["Value212"] = 212] = "Value212";
    ApiErrorBaseCode[ApiErrorBaseCode["Value213"] = 213] = "Value213";
    ApiErrorBaseCode[ApiErrorBaseCode["Value214"] = 214] = "Value214";
    ApiErrorBaseCode[ApiErrorBaseCode["Value215"] = 215] = "Value215";
    ApiErrorBaseCode[ApiErrorBaseCode["Value216"] = 216] = "Value216";
    ApiErrorBaseCode[ApiErrorBaseCode["Value217"] = 217] = "Value217";
    ApiErrorBaseCode[ApiErrorBaseCode["Value218"] = 218] = "Value218";
    ApiErrorBaseCode[ApiErrorBaseCode["Value219"] = 219] = "Value219";
    ApiErrorBaseCode[ApiErrorBaseCode["Value220"] = 220] = "Value220";
    ApiErrorBaseCode[ApiErrorBaseCode["Value221"] = 221] = "Value221";
    ApiErrorBaseCode[ApiErrorBaseCode["Value222"] = 222] = "Value222";
    ApiErrorBaseCode[ApiErrorBaseCode["Value223"] = 223] = "Value223";
    ApiErrorBaseCode[ApiErrorBaseCode["Value224"] = 224] = "Value224";
    ApiErrorBaseCode[ApiErrorBaseCode["Value225"] = 225] = "Value225";
    ApiErrorBaseCode[ApiErrorBaseCode["Value226"] = 226] = "Value226";
    ApiErrorBaseCode[ApiErrorBaseCode["Value227"] = 227] = "Value227";
    ApiErrorBaseCode[ApiErrorBaseCode["Value228"] = 228] = "Value228";
    ApiErrorBaseCode[ApiErrorBaseCode["Value229"] = 229] = "Value229";
    ApiErrorBaseCode[ApiErrorBaseCode["Value230"] = 230] = "Value230";
    ApiErrorBaseCode[ApiErrorBaseCode["Value231"] = 231] = "Value231";
    ApiErrorBaseCode[ApiErrorBaseCode["Value232"] = 232] = "Value232";
    ApiErrorBaseCode[ApiErrorBaseCode["Value233"] = 233] = "Value233";
    ApiErrorBaseCode[ApiErrorBaseCode["Value234"] = 234] = "Value234";
    ApiErrorBaseCode[ApiErrorBaseCode["Value235"] = 235] = "Value235";
    ApiErrorBaseCode[ApiErrorBaseCode["Value236"] = 236] = "Value236";
    ApiErrorBaseCode[ApiErrorBaseCode["Value237"] = 237] = "Value237";
    ApiErrorBaseCode[ApiErrorBaseCode["Value238"] = 238] = "Value238";
    ApiErrorBaseCode[ApiErrorBaseCode["Value239"] = 239] = "Value239";
    ApiErrorBaseCode[ApiErrorBaseCode["Value240"] = 240] = "Value240";
    ApiErrorBaseCode[ApiErrorBaseCode["Value241"] = 241] = "Value241";
    ApiErrorBaseCode[ApiErrorBaseCode["Value242"] = 242] = "Value242";
    ApiErrorBaseCode[ApiErrorBaseCode["Value243"] = 243] = "Value243";
    ApiErrorBaseCode[ApiErrorBaseCode["Value244"] = 244] = "Value244";
    ApiErrorBaseCode[ApiErrorBaseCode["Value245"] = 245] = "Value245";
    ApiErrorBaseCode[ApiErrorBaseCode["Value246"] = 246] = "Value246";
    ApiErrorBaseCode[ApiErrorBaseCode["Value257"] = 257] = "Value257";
    ApiErrorBaseCode[ApiErrorBaseCode["Value258"] = 258] = "Value258";
    ApiErrorBaseCode[ApiErrorBaseCode["Value259"] = 259] = "Value259";
    ApiErrorBaseCode[ApiErrorBaseCode["Value260"] = 260] = "Value260";
    ApiErrorBaseCode[ApiErrorBaseCode["Value261"] = 261] = "Value261";
    ApiErrorBaseCode[ApiErrorBaseCode["Value262"] = 262] = "Value262";
    ApiErrorBaseCode[ApiErrorBaseCode["Value263"] = 263] = "Value263";
    ApiErrorBaseCode[ApiErrorBaseCode["Value270"] = 270] = "Value270";
    ApiErrorBaseCode[ApiErrorBaseCode["Value271"] = 271] = "Value271";
    ApiErrorBaseCode[ApiErrorBaseCode["Value272"] = 272] = "Value272";
    ApiErrorBaseCode[ApiErrorBaseCode["Value273"] = 273] = "Value273";
    ApiErrorBaseCode[ApiErrorBaseCode["Value274"] = 274] = "Value274";
    ApiErrorBaseCode[ApiErrorBaseCode["Value275"] = 275] = "Value275";
    ApiErrorBaseCode[ApiErrorBaseCode["Value276"] = 276] = "Value276";
    ApiErrorBaseCode[ApiErrorBaseCode["Value277"] = 277] = "Value277";
    ApiErrorBaseCode[ApiErrorBaseCode["Value278"] = 278] = "Value278";
    ApiErrorBaseCode[ApiErrorBaseCode["Value280"] = 280] = "Value280";
    ApiErrorBaseCode[ApiErrorBaseCode["Value281"] = 281] = "Value281";
    ApiErrorBaseCode[ApiErrorBaseCode["Value282"] = 282] = "Value282";
    ApiErrorBaseCode[ApiErrorBaseCode["Value283"] = 283] = "Value283";
    ApiErrorBaseCode[ApiErrorBaseCode["Value284"] = 284] = "Value284";
    ApiErrorBaseCode[ApiErrorBaseCode["Value285"] = 285] = "Value285";
    ApiErrorBaseCode[ApiErrorBaseCode["Value286"] = 286] = "Value286";
    ApiErrorBaseCode[ApiErrorBaseCode["Value287"] = 287] = "Value287";
    ApiErrorBaseCode[ApiErrorBaseCode["Value288"] = 288] = "Value288";
    ApiErrorBaseCode[ApiErrorBaseCode["Value289"] = 289] = "Value289";
    ApiErrorBaseCode[ApiErrorBaseCode["Value290"] = 290] = "Value290";
    ApiErrorBaseCode[ApiErrorBaseCode["Value291"] = 291] = "Value291";
    ApiErrorBaseCode[ApiErrorBaseCode["Value292"] = 292] = "Value292";
    ApiErrorBaseCode[ApiErrorBaseCode["Value293"] = 293] = "Value293";
    ApiErrorBaseCode[ApiErrorBaseCode["Value294"] = 294] = "Value294";
    ApiErrorBaseCode[ApiErrorBaseCode["Value295"] = 295] = "Value295";
    ApiErrorBaseCode[ApiErrorBaseCode["Value296"] = 296] = "Value296";
    ApiErrorBaseCode[ApiErrorBaseCode["Value297"] = 297] = "Value297";
    ApiErrorBaseCode[ApiErrorBaseCode["Value298"] = 298] = "Value298";
    ApiErrorBaseCode[ApiErrorBaseCode["Value299"] = 299] = "Value299";
    ApiErrorBaseCode[ApiErrorBaseCode["Value300"] = 300] = "Value300";
    ApiErrorBaseCode[ApiErrorBaseCode["Value301"] = 301] = "Value301";
    ApiErrorBaseCode[ApiErrorBaseCode["Value302"] = 302] = "Value302";
    ApiErrorBaseCode[ApiErrorBaseCode["Value303"] = 303] = "Value303";
    ApiErrorBaseCode[ApiErrorBaseCode["Value304"] = 304] = "Value304";
    ApiErrorBaseCode[ApiErrorBaseCode["Value305"] = 305] = "Value305";
    ApiErrorBaseCode[ApiErrorBaseCode["Value306"] = 306] = "Value306";
    ApiErrorBaseCode[ApiErrorBaseCode["Value307"] = 307] = "Value307";
    ApiErrorBaseCode[ApiErrorBaseCode["Value308"] = 308] = "Value308";
    ApiErrorBaseCode[ApiErrorBaseCode["Value309"] = 309] = "Value309";
    ApiErrorBaseCode[ApiErrorBaseCode["Value310"] = 310] = "Value310";
    ApiErrorBaseCode[ApiErrorBaseCode["Value311"] = 311] = "Value311";
    ApiErrorBaseCode[ApiErrorBaseCode["Value312"] = 312] = "Value312";
    ApiErrorBaseCode[ApiErrorBaseCode["Value313"] = 313] = "Value313";
    ApiErrorBaseCode[ApiErrorBaseCode["Value314"] = 314] = "Value314";
    ApiErrorBaseCode[ApiErrorBaseCode["Value315"] = 315] = "Value315";
    ApiErrorBaseCode[ApiErrorBaseCode["Value316"] = 316] = "Value316";
    ApiErrorBaseCode[ApiErrorBaseCode["Value317"] = 317] = "Value317";
    ApiErrorBaseCode[ApiErrorBaseCode["Value318"] = 318] = "Value318";
    ApiErrorBaseCode[ApiErrorBaseCode["Value319"] = 319] = "Value319";
    ApiErrorBaseCode[ApiErrorBaseCode["Value320"] = 320] = "Value320";
    ApiErrorBaseCode[ApiErrorBaseCode["Value321"] = 321] = "Value321";
    ApiErrorBaseCode[ApiErrorBaseCode["Value322"] = 322] = "Value322";
    ApiErrorBaseCode[ApiErrorBaseCode["Value323"] = 323] = "Value323";
    ApiErrorBaseCode[ApiErrorBaseCode["Value324"] = 324] = "Value324";
    ApiErrorBaseCode[ApiErrorBaseCode["Value325"] = 325] = "Value325";
    ApiErrorBaseCode[ApiErrorBaseCode["Value326"] = 326] = "Value326";
    ApiErrorBaseCode[ApiErrorBaseCode["Value327"] = 327] = "Value327";
    ApiErrorBaseCode[ApiErrorBaseCode["Value328"] = 328] = "Value328";
    ApiErrorBaseCode[ApiErrorBaseCode["Value329"] = 329] = "Value329";
    ApiErrorBaseCode[ApiErrorBaseCode["Value330"] = 330] = "Value330";
    ApiErrorBaseCode[ApiErrorBaseCode["Value331"] = 331] = "Value331";
    ApiErrorBaseCode[ApiErrorBaseCode["Value332"] = 332] = "Value332";
    ApiErrorBaseCode[ApiErrorBaseCode["Value333"] = 333] = "Value333";
    ApiErrorBaseCode[ApiErrorBaseCode["Value334"] = 334] = "Value334";
    ApiErrorBaseCode[ApiErrorBaseCode["Value335"] = 335] = "Value335";
    ApiErrorBaseCode[ApiErrorBaseCode["Value336"] = 336] = "Value336";
    ApiErrorBaseCode[ApiErrorBaseCode["Value337"] = 337] = "Value337";
    ApiErrorBaseCode[ApiErrorBaseCode["Value338"] = 338] = "Value338";
    ApiErrorBaseCode[ApiErrorBaseCode["Value339"] = 339] = "Value339";
    ApiErrorBaseCode[ApiErrorBaseCode["Value340"] = 340] = "Value340";
    ApiErrorBaseCode[ApiErrorBaseCode["Value341"] = 341] = "Value341";
    ApiErrorBaseCode[ApiErrorBaseCode["Value342"] = 342] = "Value342";
    ApiErrorBaseCode[ApiErrorBaseCode["Value343"] = 343] = "Value343";
    ApiErrorBaseCode[ApiErrorBaseCode["Value344"] = 344] = "Value344";
    ApiErrorBaseCode[ApiErrorBaseCode["Value345"] = 345] = "Value345";
    ApiErrorBaseCode[ApiErrorBaseCode["Value346"] = 346] = "Value346";
    ApiErrorBaseCode[ApiErrorBaseCode["Value347"] = 347] = "Value347";
    ApiErrorBaseCode[ApiErrorBaseCode["Value348"] = 348] = "Value348";
    ApiErrorBaseCode[ApiErrorBaseCode["Value349"] = 349] = "Value349";
    ApiErrorBaseCode[ApiErrorBaseCode["Value350"] = 350] = "Value350";
    ApiErrorBaseCode[ApiErrorBaseCode["Value351"] = 351] = "Value351";
    ApiErrorBaseCode[ApiErrorBaseCode["Value352"] = 352] = "Value352";
    ApiErrorBaseCode[ApiErrorBaseCode["Value353"] = 353] = "Value353";
    ApiErrorBaseCode[ApiErrorBaseCode["Value354"] = 354] = "Value354";
    ApiErrorBaseCode[ApiErrorBaseCode["Value355"] = 355] = "Value355";
    ApiErrorBaseCode[ApiErrorBaseCode["Value356"] = 356] = "Value356";
    ApiErrorBaseCode[ApiErrorBaseCode["Value357"] = 357] = "Value357";
    ApiErrorBaseCode[ApiErrorBaseCode["Value358"] = 358] = "Value358";
    ApiErrorBaseCode[ApiErrorBaseCode["Value359"] = 359] = "Value359";
    ApiErrorBaseCode[ApiErrorBaseCode["Value360"] = 360] = "Value360";
    ApiErrorBaseCode[ApiErrorBaseCode["Value361"] = 361] = "Value361";
    ApiErrorBaseCode[ApiErrorBaseCode["Value362"] = 362] = "Value362";
    ApiErrorBaseCode[ApiErrorBaseCode["Value363"] = 363] = "Value363";
    ApiErrorBaseCode[ApiErrorBaseCode["Value364"] = 364] = "Value364";
    ApiErrorBaseCode[ApiErrorBaseCode["Value365"] = 365] = "Value365";
    ApiErrorBaseCode[ApiErrorBaseCode["Value366"] = 366] = "Value366";
    ApiErrorBaseCode[ApiErrorBaseCode["Value367"] = 367] = "Value367";
    ApiErrorBaseCode[ApiErrorBaseCode["Value368"] = 368] = "Value368";
    ApiErrorBaseCode[ApiErrorBaseCode["Value369"] = 369] = "Value369";
    ApiErrorBaseCode[ApiErrorBaseCode["Value370"] = 370] = "Value370";
    ApiErrorBaseCode[ApiErrorBaseCode["Value371"] = 371] = "Value371";
    ApiErrorBaseCode[ApiErrorBaseCode["Value372"] = 372] = "Value372";
    ApiErrorBaseCode[ApiErrorBaseCode["Value373"] = 373] = "Value373";
    ApiErrorBaseCode[ApiErrorBaseCode["Value374"] = 374] = "Value374";
    ApiErrorBaseCode[ApiErrorBaseCode["Value375"] = 375] = "Value375";
    ApiErrorBaseCode[ApiErrorBaseCode["Value376"] = 376] = "Value376";
    ApiErrorBaseCode[ApiErrorBaseCode["Value377"] = 377] = "Value377";
    ApiErrorBaseCode[ApiErrorBaseCode["Value378"] = 378] = "Value378";
    ApiErrorBaseCode[ApiErrorBaseCode["Value379"] = 379] = "Value379";
    ApiErrorBaseCode[ApiErrorBaseCode["Value380"] = 380] = "Value380";
    ApiErrorBaseCode[ApiErrorBaseCode["Value381"] = 381] = "Value381";
    ApiErrorBaseCode[ApiErrorBaseCode["Value382"] = 382] = "Value382";
    ApiErrorBaseCode[ApiErrorBaseCode["Value383"] = 383] = "Value383";
    ApiErrorBaseCode[ApiErrorBaseCode["Value384"] = 384] = "Value384";
    ApiErrorBaseCode[ApiErrorBaseCode["Value385"] = 385] = "Value385";
    ApiErrorBaseCode[ApiErrorBaseCode["Value386"] = 386] = "Value386";
    ApiErrorBaseCode[ApiErrorBaseCode["Value387"] = 387] = "Value387";
    ApiErrorBaseCode[ApiErrorBaseCode["Value388"] = 388] = "Value388";
    ApiErrorBaseCode[ApiErrorBaseCode["Value389"] = 389] = "Value389";
    ApiErrorBaseCode[ApiErrorBaseCode["Value390"] = 390] = "Value390";
    ApiErrorBaseCode[ApiErrorBaseCode["Value391"] = 391] = "Value391";
    ApiErrorBaseCode[ApiErrorBaseCode["Value392"] = 392] = "Value392";
    ApiErrorBaseCode[ApiErrorBaseCode["Value393"] = 393] = "Value393";
    ApiErrorBaseCode[ApiErrorBaseCode["Value394"] = 394] = "Value394";
    ApiErrorBaseCode[ApiErrorBaseCode["Value395"] = 395] = "Value395";
    ApiErrorBaseCode[ApiErrorBaseCode["Value396"] = 396] = "Value396";
    ApiErrorBaseCode[ApiErrorBaseCode["Value397"] = 397] = "Value397";
    ApiErrorBaseCode[ApiErrorBaseCode["Value398"] = 398] = "Value398";
    ApiErrorBaseCode[ApiErrorBaseCode["Value399"] = 399] = "Value399";
    ApiErrorBaseCode[ApiErrorBaseCode["Value400"] = 400] = "Value400";
    ApiErrorBaseCode[ApiErrorBaseCode["Value401"] = 401] = "Value401";
    ApiErrorBaseCode[ApiErrorBaseCode["Value402"] = 402] = "Value402";
    ApiErrorBaseCode[ApiErrorBaseCode["Value403"] = 403] = "Value403";
    ApiErrorBaseCode[ApiErrorBaseCode["Value404"] = 404] = "Value404";
    ApiErrorBaseCode[ApiErrorBaseCode["Value405"] = 405] = "Value405";
    ApiErrorBaseCode[ApiErrorBaseCode["Value406"] = 406] = "Value406";
    ApiErrorBaseCode[ApiErrorBaseCode["Value407"] = 407] = "Value407";
    ApiErrorBaseCode[ApiErrorBaseCode["Value408"] = 408] = "Value408";
    ApiErrorBaseCode[ApiErrorBaseCode["Value409"] = 409] = "Value409";
    ApiErrorBaseCode[ApiErrorBaseCode["Value410"] = 410] = "Value410";
    ApiErrorBaseCode[ApiErrorBaseCode["Value411"] = 411] = "Value411";
    ApiErrorBaseCode[ApiErrorBaseCode["Value412"] = 412] = "Value412";
    ApiErrorBaseCode[ApiErrorBaseCode["Value413"] = 413] = "Value413";
    ApiErrorBaseCode[ApiErrorBaseCode["Value414"] = 414] = "Value414";
    ApiErrorBaseCode[ApiErrorBaseCode["Value415"] = 415] = "Value415";
    ApiErrorBaseCode[ApiErrorBaseCode["Value416"] = 416] = "Value416";
    ApiErrorBaseCode[ApiErrorBaseCode["Value417"] = 417] = "Value417";
    ApiErrorBaseCode[ApiErrorBaseCode["Value418"] = 418] = "Value418";
    ApiErrorBaseCode[ApiErrorBaseCode["Value419"] = 419] = "Value419";
    ApiErrorBaseCode[ApiErrorBaseCode["Value420"] = 420] = "Value420";
    ApiErrorBaseCode[ApiErrorBaseCode["Value421"] = 421] = "Value421";
    ApiErrorBaseCode[ApiErrorBaseCode["Value422"] = 422] = "Value422";
    ApiErrorBaseCode[ApiErrorBaseCode["Value423"] = 423] = "Value423";
    ApiErrorBaseCode[ApiErrorBaseCode["Value424"] = 424] = "Value424";
    ApiErrorBaseCode[ApiErrorBaseCode["Value425"] = 425] = "Value425";
    ApiErrorBaseCode[ApiErrorBaseCode["Value426"] = 426] = "Value426";
    ApiErrorBaseCode[ApiErrorBaseCode["Value427"] = 427] = "Value427";
    ApiErrorBaseCode[ApiErrorBaseCode["Value428"] = 428] = "Value428";
    ApiErrorBaseCode[ApiErrorBaseCode["Value429"] = 429] = "Value429";
    ApiErrorBaseCode[ApiErrorBaseCode["Value430"] = 430] = "Value430";
    ApiErrorBaseCode[ApiErrorBaseCode["Value431"] = 431] = "Value431";
    ApiErrorBaseCode[ApiErrorBaseCode["Value432"] = 432] = "Value432";
    ApiErrorBaseCode[ApiErrorBaseCode["Value433"] = 433] = "Value433";
    ApiErrorBaseCode[ApiErrorBaseCode["Value434"] = 434] = "Value434";
    ApiErrorBaseCode[ApiErrorBaseCode["Value435"] = 435] = "Value435";
    ApiErrorBaseCode[ApiErrorBaseCode["Value436"] = 436] = "Value436";
    ApiErrorBaseCode[ApiErrorBaseCode["Value437"] = 437] = "Value437";
    ApiErrorBaseCode[ApiErrorBaseCode["Value438"] = 438] = "Value438";
    ApiErrorBaseCode[ApiErrorBaseCode["Value439"] = 439] = "Value439";
    ApiErrorBaseCode[ApiErrorBaseCode["Value440"] = 440] = "Value440";
    ApiErrorBaseCode[ApiErrorBaseCode["Value441"] = 441] = "Value441";
    ApiErrorBaseCode[ApiErrorBaseCode["Value442"] = 442] = "Value442";
    ApiErrorBaseCode[ApiErrorBaseCode["Value443"] = 443] = "Value443";
    ApiErrorBaseCode[ApiErrorBaseCode["Value444"] = 444] = "Value444";
    ApiErrorBaseCode[ApiErrorBaseCode["Value445"] = 445] = "Value445";
    ApiErrorBaseCode[ApiErrorBaseCode["Value446"] = 446] = "Value446";
    ApiErrorBaseCode[ApiErrorBaseCode["Value447"] = 447] = "Value447";
    ApiErrorBaseCode[ApiErrorBaseCode["Value448"] = 448] = "Value448";
    ApiErrorBaseCode[ApiErrorBaseCode["Value449"] = 449] = "Value449";
    ApiErrorBaseCode[ApiErrorBaseCode["Value450"] = 450] = "Value450";
    ApiErrorBaseCode[ApiErrorBaseCode["Value451"] = 451] = "Value451";
    ApiErrorBaseCode[ApiErrorBaseCode["Value452"] = 452] = "Value452";
    ApiErrorBaseCode[ApiErrorBaseCode["Value453"] = 453] = "Value453";
    ApiErrorBaseCode[ApiErrorBaseCode["Value454"] = 454] = "Value454";
    ApiErrorBaseCode[ApiErrorBaseCode["Value455"] = 455] = "Value455";
    ApiErrorBaseCode[ApiErrorBaseCode["Value456"] = 456] = "Value456";
    ApiErrorBaseCode[ApiErrorBaseCode["Value457"] = 457] = "Value457";
    ApiErrorBaseCode[ApiErrorBaseCode["Value458"] = 458] = "Value458";
    ApiErrorBaseCode[ApiErrorBaseCode["Value459"] = 459] = "Value459";
    ApiErrorBaseCode[ApiErrorBaseCode["Value460"] = 460] = "Value460";
    ApiErrorBaseCode[ApiErrorBaseCode["Value461"] = 461] = "Value461";
    ApiErrorBaseCode[ApiErrorBaseCode["Value462"] = 462] = "Value462";
    ApiErrorBaseCode[ApiErrorBaseCode["Value463"] = 463] = "Value463";
    ApiErrorBaseCode[ApiErrorBaseCode["Value464"] = 464] = "Value464";
    ApiErrorBaseCode[ApiErrorBaseCode["Value465"] = 465] = "Value465";
    ApiErrorBaseCode[ApiErrorBaseCode["Value466"] = 466] = "Value466";
    ApiErrorBaseCode[ApiErrorBaseCode["Value467"] = 467] = "Value467";
    ApiErrorBaseCode[ApiErrorBaseCode["Value468"] = 468] = "Value468";
    ApiErrorBaseCode[ApiErrorBaseCode["Value469"] = 469] = "Value469";
    ApiErrorBaseCode[ApiErrorBaseCode["Value470"] = 470] = "Value470";
    ApiErrorBaseCode[ApiErrorBaseCode["Value471"] = 471] = "Value471";
    ApiErrorBaseCode[ApiErrorBaseCode["Value472"] = 472] = "Value472";
    ApiErrorBaseCode[ApiErrorBaseCode["Value473"] = 473] = "Value473";
    ApiErrorBaseCode[ApiErrorBaseCode["Value474"] = 474] = "Value474";
    ApiErrorBaseCode[ApiErrorBaseCode["Value475"] = 475] = "Value475";
    ApiErrorBaseCode[ApiErrorBaseCode["Value476"] = 476] = "Value476";
    ApiErrorBaseCode[ApiErrorBaseCode["Value477"] = 477] = "Value477";
    ApiErrorBaseCode[ApiErrorBaseCode["Value478"] = 478] = "Value478";
    ApiErrorBaseCode[ApiErrorBaseCode["Value479"] = 479] = "Value479";
    ApiErrorBaseCode[ApiErrorBaseCode["Value480"] = 480] = "Value480";
    ApiErrorBaseCode[ApiErrorBaseCode["Value481"] = 481] = "Value481";
    ApiErrorBaseCode[ApiErrorBaseCode["Value482"] = 482] = "Value482";
    ApiErrorBaseCode[ApiErrorBaseCode["Value483"] = 483] = "Value483";
    ApiErrorBaseCode[ApiErrorBaseCode["Value484"] = 484] = "Value484";
    ApiErrorBaseCode[ApiErrorBaseCode["Value485"] = 485] = "Value485";
    ApiErrorBaseCode[ApiErrorBaseCode["Value486"] = 486] = "Value486";
    ApiErrorBaseCode[ApiErrorBaseCode["Value487"] = 487] = "Value487";
    ApiErrorBaseCode[ApiErrorBaseCode["Value488"] = 488] = "Value488";
    ApiErrorBaseCode[ApiErrorBaseCode["Value489"] = 489] = "Value489";
    ApiErrorBaseCode[ApiErrorBaseCode["Value490"] = 490] = "Value490";
    ApiErrorBaseCode[ApiErrorBaseCode["Value491"] = 491] = "Value491";
    ApiErrorBaseCode[ApiErrorBaseCode["Value492"] = 492] = "Value492";
    ApiErrorBaseCode[ApiErrorBaseCode["Value493"] = 493] = "Value493";
    ApiErrorBaseCode[ApiErrorBaseCode["Value494"] = 494] = "Value494";
    ApiErrorBaseCode[ApiErrorBaseCode["Value495"] = 495] = "Value495";
    ApiErrorBaseCode[ApiErrorBaseCode["Value496"] = 496] = "Value496";
    ApiErrorBaseCode[ApiErrorBaseCode["Value497"] = 497] = "Value497";
    ApiErrorBaseCode[ApiErrorBaseCode["Value498"] = 498] = "Value498";
    ApiErrorBaseCode[ApiErrorBaseCode["Value499"] = 499] = "Value499";
    ApiErrorBaseCode[ApiErrorBaseCode["Value500"] = 500] = "Value500";
    ApiErrorBaseCode[ApiErrorBaseCode["Value501"] = 501] = "Value501";
    ApiErrorBaseCode[ApiErrorBaseCode["Value502"] = 502] = "Value502";
    ApiErrorBaseCode[ApiErrorBaseCode["Value503"] = 503] = "Value503";
    ApiErrorBaseCode[ApiErrorBaseCode["Value504"] = 504] = "Value504";
    ApiErrorBaseCode[ApiErrorBaseCode["Value505"] = 505] = "Value505";
    ApiErrorBaseCode[ApiErrorBaseCode["Value506"] = 506] = "Value506";
    ApiErrorBaseCode[ApiErrorBaseCode["Value507"] = 507] = "Value507";
    ApiErrorBaseCode[ApiErrorBaseCode["Value508"] = 508] = "Value508";
    ApiErrorBaseCode[ApiErrorBaseCode["Value509"] = 509] = "Value509";
    ApiErrorBaseCode[ApiErrorBaseCode["Value510"] = 510] = "Value510";
    ApiErrorBaseCode[ApiErrorBaseCode["Value511"] = 511] = "Value511";
    ApiErrorBaseCode[ApiErrorBaseCode["Value512"] = 512] = "Value512";
    ApiErrorBaseCode[ApiErrorBaseCode["Value513"] = 513] = "Value513";
    ApiErrorBaseCode[ApiErrorBaseCode["Value514"] = 514] = "Value514";
    ApiErrorBaseCode[ApiErrorBaseCode["Value515"] = 515] = "Value515";
    ApiErrorBaseCode[ApiErrorBaseCode["Value516"] = 516] = "Value516";
    ApiErrorBaseCode[ApiErrorBaseCode["Value517"] = 517] = "Value517";
    ApiErrorBaseCode[ApiErrorBaseCode["Value518"] = 518] = "Value518";
    ApiErrorBaseCode[ApiErrorBaseCode["Value519"] = 519] = "Value519";
    ApiErrorBaseCode[ApiErrorBaseCode["Value520"] = 520] = "Value520";
    ApiErrorBaseCode[ApiErrorBaseCode["Value521"] = 521] = "Value521";
    ApiErrorBaseCode[ApiErrorBaseCode["Value522"] = 522] = "Value522";
    ApiErrorBaseCode[ApiErrorBaseCode["Value523"] = 523] = "Value523";
    ApiErrorBaseCode[ApiErrorBaseCode["Value524"] = 524] = "Value524";
    ApiErrorBaseCode[ApiErrorBaseCode["Value525"] = 525] = "Value525";
    ApiErrorBaseCode[ApiErrorBaseCode["Value526"] = 526] = "Value526";
    ApiErrorBaseCode[ApiErrorBaseCode["Value527"] = 527] = "Value527";
})(ApiErrorBaseCode || (ApiErrorBaseCode = {}));
/** @format int32 */
export var ApiPhotoFilterType;
(function (ApiPhotoFilterType) {
    ApiPhotoFilterType[ApiPhotoFilterType["Value0"] = 0] = "Value0";
    ApiPhotoFilterType[ApiPhotoFilterType["Value1"] = 1] = "Value1";
    ApiPhotoFilterType[ApiPhotoFilterType["Value2"] = 2] = "Value2";
    ApiPhotoFilterType[ApiPhotoFilterType["Value3"] = 3] = "Value3";
})(ApiPhotoFilterType || (ApiPhotoFilterType = {}));
/** @format int32 */
export var ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType;
(function (ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType) {
    ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType[ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType["Value0"] = 0] = "Value0";
    ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType[ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType["Value1"] = 1] = "Value1";
})(ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType || (ApiSimpleRegistratorFeatureGetPhotoQueryPhotoType = {}));
/** @format int32 */
export var ArgosResult;
(function (ArgosResult) {
    ArgosResult[ArgosResult["Value0"] = 0] = "Value0";
    ArgosResult[ArgosResult["Value1"] = 1] = "Value1";
    ArgosResult[ArgosResult["Value2"] = 2] = "Value2";
    ArgosResult[ArgosResult["Value3"] = 3] = "Value3";
})(ArgosResult || (ArgosResult = {}));
/**
 * Supported Import service
 * @format int32
 */
export var BllOutsideService;
(function (BllOutsideService) {
    BllOutsideService[BllOutsideService["Value0"] = 0] = "Value0";
    BllOutsideService[BllOutsideService["Value1"] = 1] = "Value1";
    BllOutsideService[BllOutsideService["Value2"] = 2] = "Value2";
    BllOutsideService[BllOutsideService["Value3"] = 3] = "Value3";
    BllOutsideService[BllOutsideService["Value4"] = 4] = "Value4";
})(BllOutsideService || (BllOutsideService = {}));
/**
 * Door event direction
 * @format int32
 */
export var BllServicesEventConverterEventConverterServiceDirection;
(function (BllServicesEventConverterEventConverterServiceDirection) {
    BllServicesEventConverterEventConverterServiceDirection[BllServicesEventConverterEventConverterServiceDirection["Value0"] = 0] = "Value0";
    BllServicesEventConverterEventConverterServiceDirection[BllServicesEventConverterEventConverterServiceDirection["Value1"] = 1] = "Value1";
})(BllServicesEventConverterEventConverterServiceDirection || (BllServicesEventConverterEventConverterServiceDirection = {}));
/** @format int32 */
export var CoreArgosFeatureLockOperation;
(function (CoreArgosFeatureLockOperation) {
    CoreArgosFeatureLockOperation[CoreArgosFeatureLockOperation["Value0"] = 0] = "Value0";
    CoreArgosFeatureLockOperation[CoreArgosFeatureLockOperation["Value1"] = 1] = "Value1";
    CoreArgosFeatureLockOperation[CoreArgosFeatureLockOperation["Value2"] = 2] = "Value2";
    CoreArgosFeatureLockOperation[CoreArgosFeatureLockOperation["Value3"] = 3] = "Value3";
})(CoreArgosFeatureLockOperation || (CoreArgosFeatureLockOperation = {}));
/** @format int32 */
export var CoreEstonianLawFeatureEstonianLawParagraphs;
(function (CoreEstonianLawFeatureEstonianLawParagraphs) {
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value1"] = 1] = "Value1";
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value2"] = 2] = "Value2";
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value3"] = 3] = "Value3";
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value4"] = 4] = "Value4";
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value5"] = 5] = "Value5";
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value6"] = 6] = "Value6";
    CoreEstonianLawFeatureEstonianLawParagraphs[CoreEstonianLawFeatureEstonianLawParagraphs["Value7"] = 7] = "Value7";
})(CoreEstonianLawFeatureEstonianLawParagraphs || (CoreEstonianLawFeatureEstonianLawParagraphs = {}));
/** @format int32 */
export var CorePaginationFeatureOrderDirection;
(function (CorePaginationFeatureOrderDirection) {
    CorePaginationFeatureOrderDirection[CorePaginationFeatureOrderDirection["Value0"] = 0] = "Value0";
    CorePaginationFeatureOrderDirection[CorePaginationFeatureOrderDirection["Value1"] = 1] = "Value1";
})(CorePaginationFeatureOrderDirection || (CorePaginationFeatureOrderDirection = {}));
/** @format int32 */
export var CoreReportType;
(function (CoreReportType) {
    CoreReportType[CoreReportType["Value1"] = 1] = "Value1";
    CoreReportType[CoreReportType["Value2"] = 2] = "Value2";
    CoreReportType[CoreReportType["Value3"] = 3] = "Value3";
    CoreReportType[CoreReportType["Value4"] = 4] = "Value4";
    CoreReportType[CoreReportType["Value5"] = 5] = "Value5";
    CoreReportType[CoreReportType["Value6"] = 6] = "Value6";
})(CoreReportType || (CoreReportType = {}));
/** @format int32 */
export var CoreSplitByFeatureSplitBy;
(function (CoreSplitByFeatureSplitBy) {
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value0"] = 0] = "Value0";
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value1"] = 1] = "Value1";
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value2"] = 2] = "Value2";
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value3"] = 3] = "Value3";
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value4"] = 4] = "Value4";
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value5"] = 5] = "Value5";
    CoreSplitByFeatureSplitBy[CoreSplitByFeatureSplitBy["Value6"] = 6] = "Value6";
})(CoreSplitByFeatureSplitBy || (CoreSplitByFeatureSplitBy = {}));
/** @format int32 */
export var CoreTableHistoryFeatureTableHistoryType;
(function (CoreTableHistoryFeatureTableHistoryType) {
    CoreTableHistoryFeatureTableHistoryType[CoreTableHistoryFeatureTableHistoryType["Value1"] = 1] = "Value1";
    CoreTableHistoryFeatureTableHistoryType[CoreTableHistoryFeatureTableHistoryType["Value2"] = 2] = "Value2";
    CoreTableHistoryFeatureTableHistoryType[CoreTableHistoryFeatureTableHistoryType["Value3"] = 3] = "Value3";
})(CoreTableHistoryFeatureTableHistoryType || (CoreTableHistoryFeatureTableHistoryType = {}));
/** @format int32 */
export var CoreWorkTimeType;
(function (CoreWorkTimeType) {
    CoreWorkTimeType[CoreWorkTimeType["Value0"] = 0] = "Value0";
    CoreWorkTimeType[CoreWorkTimeType["Value1"] = 1] = "Value1";
    CoreWorkTimeType[CoreWorkTimeType["Value2"] = 2] = "Value2";
    CoreWorkTimeType[CoreWorkTimeType["Value3"] = 3] = "Value3";
    CoreWorkTimeType[CoreWorkTimeType["Value4"] = 4] = "Value4";
    CoreWorkTimeType[CoreWorkTimeType["Value5"] = 5] = "Value5";
})(CoreWorkTimeType || (CoreWorkTimeType = {}));
/**
 * Enum containing possible time rate system types
 * Given values have to also exist in the DB TimeRateSytem table
 * Todo: Move to another location
 * @format int32
 */
export var DTOOtherTimeRateSystemType;
(function (DTOOtherTimeRateSystemType) {
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value1"] = 1] = "Value1";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value2"] = 2] = "Value2";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value3"] = 3] = "Value3";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value4"] = 4] = "Value4";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value5"] = 5] = "Value5";
})(DTOOtherTimeRateSystemType || (DTOOtherTimeRateSystemType = {}));
/**
 * calendar events generation pattern type
 * @format int32
 */
export var DTORequestsCalendarEventsCalendarEventsGenerationType;
(function (DTORequestsCalendarEventsCalendarEventsGenerationType) {
    DTORequestsCalendarEventsCalendarEventsGenerationType[DTORequestsCalendarEventsCalendarEventsGenerationType["Value0"] = 0] = "Value0";
    DTORequestsCalendarEventsCalendarEventsGenerationType[DTORequestsCalendarEventsCalendarEventsGenerationType["Value1"] = 1] = "Value1";
    DTORequestsCalendarEventsCalendarEventsGenerationType[DTORequestsCalendarEventsCalendarEventsGenerationType["Value2"] = 2] = "Value2";
})(DTORequestsCalendarEventsCalendarEventsGenerationType || (DTORequestsCalendarEventsCalendarEventsGenerationType = {}));
/**
 * Import worktype values recognized by axapta
 * @format int32
 */
export var DalAxaptaConfigurationAxaptaWorkType;
(function (DalAxaptaConfigurationAxaptaWorkType) {
    DalAxaptaConfigurationAxaptaWorkType[DalAxaptaConfigurationAxaptaWorkType["Value1"] = 1] = "Value1";
    DalAxaptaConfigurationAxaptaWorkType[DalAxaptaConfigurationAxaptaWorkType["Value4"] = 4] = "Value4";
    DalAxaptaConfigurationAxaptaWorkType[DalAxaptaConfigurationAxaptaWorkType["Value7"] = 7] = "Value7";
})(DalAxaptaConfigurationAxaptaWorkType || (DalAxaptaConfigurationAxaptaWorkType = {}));
/**
 * Describes what event actions
 * @format int32
 */
export var DalCalendarEventLogRecordEventOperation;
(function (DalCalendarEventLogRecordEventOperation) {
    DalCalendarEventLogRecordEventOperation[DalCalendarEventLogRecordEventOperation["Value1"] = 1] = "Value1";
    DalCalendarEventLogRecordEventOperation[DalCalendarEventLogRecordEventOperation["Value2"] = 2] = "Value2";
    DalCalendarEventLogRecordEventOperation[DalCalendarEventLogRecordEventOperation["Value3"] = 3] = "Value3";
})(DalCalendarEventLogRecordEventOperation || (DalCalendarEventLogRecordEventOperation = {}));
/**
 * Defines possible company statuses
 * @format int32
 */
export var DalCompanyStatusType;
(function (DalCompanyStatusType) {
    DalCompanyStatusType[DalCompanyStatusType["Value1"] = 1] = "Value1";
    DalCompanyStatusType[DalCompanyStatusType["Value2"] = 2] = "Value2";
    DalCompanyStatusType[DalCompanyStatusType["Value3"] = 3] = "Value3";
})(DalCompanyStatusType || (DalCompanyStatusType = {}));
/**
 * When event is split between periods, what part of the event overtime can be changed
 * @format int32
 */
export var DalEventOverTimeLocation;
(function (DalEventOverTimeLocation) {
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value0"] = 0] = "Value0";
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value1"] = 1] = "Value1";
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value2"] = 2] = "Value2";
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value3"] = 3] = "Value3";
})(DalEventOverTimeLocation || (DalEventOverTimeLocation = {}));
/**
 * Different event types
 * @format int32
 */
export var DalEventType;
(function (DalEventType) {
    DalEventType[DalEventType["Value1"] = 1] = "Value1";
    DalEventType[DalEventType["Value2"] = 2] = "Value2";
})(DalEventType || (DalEventType = {}));
/**
 * Defines the owner of the filter
 * @format int32
 */
export var DalFormFilterOwnerType;
(function (DalFormFilterOwnerType) {
    DalFormFilterOwnerType[DalFormFilterOwnerType["Value1"] = 1] = "Value1";
    DalFormFilterOwnerType[DalFormFilterOwnerType["Value2"] = 2] = "Value2";
})(DalFormFilterOwnerType || (DalFormFilterOwnerType = {}));
/**
 * Who or what is creating job event.
 * This enum must directly correspond to JobEventCreatorType table in database.
 * @format int32
 */
export var DalJobEventCreatorType;
(function (DalJobEventCreatorType) {
    DalJobEventCreatorType[DalJobEventCreatorType["Value1"] = 1] = "Value1";
    DalJobEventCreatorType[DalJobEventCreatorType["Value2"] = 2] = "Value2";
    DalJobEventCreatorType[DalJobEventCreatorType["Value3"] = 3] = "Value3";
    DalJobEventCreatorType[DalJobEventCreatorType["Value4"] = 4] = "Value4";
    DalJobEventCreatorType[DalJobEventCreatorType["Value5"] = 5] = "Value5";
})(DalJobEventCreatorType || (DalJobEventCreatorType = {}));
/**
 * Supported languages
 * @format int32
 */
export var DalLanguage;
(function (DalLanguage) {
    DalLanguage[DalLanguage["Value0"] = 0] = "Value0";
    DalLanguage[DalLanguage["Value1"] = 1] = "Value1";
    DalLanguage[DalLanguage["Value2"] = 2] = "Value2";
    DalLanguage[DalLanguage["Value3"] = 3] = "Value3";
    DalLanguage[DalLanguage["Value4"] = 4] = "Value4";
    DalLanguage[DalLanguage["Value5"] = 5] = "Value5";
    DalLanguage[DalLanguage["Value6"] = 6] = "Value6";
})(DalLanguage || (DalLanguage = {}));
/**
 * Enum values for Laws
 * @format int32
 */
export var DalLawLawId;
(function (DalLawLawId) {
    DalLawLawId[DalLawLawId["Value1"] = 1] = "Value1";
    DalLawLawId[DalLawLawId["Value2"] = 2] = "Value2";
})(DalLawLawId || (DalLawLawId = {}));
/**
 * Defines when lunch calculation is applied
 * @format int32
 */
export var DalLunchCalculationType;
(function (DalLunchCalculationType) {
    DalLunchCalculationType[DalLunchCalculationType["Value1"] = 1] = "Value1";
    DalLunchCalculationType[DalLunchCalculationType["Value2"] = 2] = "Value2";
})(DalLunchCalculationType || (DalLunchCalculationType = {}));
/**
 * Defines order of data
 * @format int32
 */
export var DalOrderBy;
(function (DalOrderBy) {
    DalOrderBy[DalOrderBy["Value0"] = 0] = "Value0";
    DalOrderBy[DalOrderBy["Value1"] = 1] = "Value1";
    DalOrderBy[DalOrderBy["Value2"] = 2] = "Value2";
    DalOrderBy[DalOrderBy["Value3"] = 3] = "Value3";
    DalOrderBy[DalOrderBy["Value4"] = 4] = "Value4";
    DalOrderBy[DalOrderBy["Value5"] = 5] = "Value5";
})(DalOrderBy || (DalOrderBy = {}));
/**
 * PaymentCode Type
 * @format int32
 */
export var DalPaymentCodeBaseCodeType;
(function (DalPaymentCodeBaseCodeType) {
    DalPaymentCodeBaseCodeType[DalPaymentCodeBaseCodeType["Value1"] = 1] = "Value1";
    DalPaymentCodeBaseCodeType[DalPaymentCodeBaseCodeType["Value2"] = 2] = "Value2";
})(DalPaymentCodeBaseCodeType || (DalPaymentCodeBaseCodeType = {}));
/**
 * Payment time type
 * @format int32
 */
export var DalPaymentTimeType;
(function (DalPaymentTimeType) {
    DalPaymentTimeType[DalPaymentTimeType["Value0"] = 0] = "Value0";
    DalPaymentTimeType[DalPaymentTimeType["Value1"] = 1] = "Value1";
    DalPaymentTimeType[DalPaymentTimeType["Value2"] = 2] = "Value2";
})(DalPaymentTimeType || (DalPaymentTimeType = {}));
/**
 * Enum containing possible project association types
 * given values have to also exist in the DB AssociationType table
 * @format int32
 */
export var DalProjectAssociationType;
(function (DalProjectAssociationType) {
    DalProjectAssociationType[DalProjectAssociationType["Value2"] = 2] = "Value2";
    DalProjectAssociationType[DalProjectAssociationType["Value4"] = 4] = "Value4";
})(DalProjectAssociationType || (DalProjectAssociationType = {}));
/**
 * Project status
 * @format int32
 */
export var DalProjectStatus;
(function (DalProjectStatus) {
    DalProjectStatus[DalProjectStatus["Value0"] = 0] = "Value0";
    DalProjectStatus[DalProjectStatus["Value1"] = 1] = "Value1";
})(DalProjectStatus || (DalProjectStatus = {}));
/**
 * request confirmation type
 * @format int32
 */
export var DalRequestConfirmationType;
(function (DalRequestConfirmationType) {
    DalRequestConfirmationType[DalRequestConfirmationType["Value1"] = 1] = "Value1";
    DalRequestConfirmationType[DalRequestConfirmationType["Value2"] = 2] = "Value2";
})(DalRequestConfirmationType || (DalRequestConfirmationType = {}));
/**
 * request status type
 * @format int32
 */
export var DalRequestStatusType;
(function (DalRequestStatusType) {
    DalRequestStatusType[DalRequestStatusType["Value1"] = 1] = "Value1";
    DalRequestStatusType[DalRequestStatusType["Value2"] = 2] = "Value2";
    DalRequestStatusType[DalRequestStatusType["Value3"] = 3] = "Value3";
    DalRequestStatusType[DalRequestStatusType["Value4"] = 4] = "Value4";
})(DalRequestStatusType || (DalRequestStatusType = {}));
/**
 * Defines different right types.
 * Values must be the same as in the Table of RightType in database
 * @format int32
 */
export var DalRightType;
(function (DalRightType) {
    DalRightType[DalRightType["Value1"] = 1] = "Value1";
    DalRightType[DalRightType["Value2"] = 2] = "Value2";
    DalRightType[DalRightType["Value3"] = 3] = "Value3";
})(DalRightType || (DalRightType = {}));
/**
 * Rights ids
 * @format int32
 */
export var DalRightsId;
(function (DalRightsId) {
    DalRightsId[DalRightsId["Value1"] = 1] = "Value1";
    DalRightsId[DalRightsId["Value2"] = 2] = "Value2";
    DalRightsId[DalRightsId["Value3"] = 3] = "Value3";
    DalRightsId[DalRightsId["Value4"] = 4] = "Value4";
    DalRightsId[DalRightsId["Value7"] = 7] = "Value7";
    DalRightsId[DalRightsId["Value8"] = 8] = "Value8";
    DalRightsId[DalRightsId["Value9"] = 9] = "Value9";
    DalRightsId[DalRightsId["Value10"] = 10] = "Value10";
    DalRightsId[DalRightsId["Value13"] = 13] = "Value13";
    DalRightsId[DalRightsId["Value14"] = 14] = "Value14";
    DalRightsId[DalRightsId["Value15"] = 15] = "Value15";
    DalRightsId[DalRightsId["Value16"] = 16] = "Value16";
    DalRightsId[DalRightsId["Value18"] = 18] = "Value18";
    DalRightsId[DalRightsId["Value20"] = 20] = "Value20";
    DalRightsId[DalRightsId["Value21"] = 21] = "Value21";
    DalRightsId[DalRightsId["Value22"] = 22] = "Value22";
    DalRightsId[DalRightsId["Value23"] = 23] = "Value23";
    DalRightsId[DalRightsId["Value24"] = 24] = "Value24";
    DalRightsId[DalRightsId["Value25"] = 25] = "Value25";
    DalRightsId[DalRightsId["Value26"] = 26] = "Value26";
    DalRightsId[DalRightsId["Value27"] = 27] = "Value27";
    DalRightsId[DalRightsId["Value28"] = 28] = "Value28";
    DalRightsId[DalRightsId["Value29"] = 29] = "Value29";
    DalRightsId[DalRightsId["Value30"] = 30] = "Value30";
    DalRightsId[DalRightsId["Value31"] = 31] = "Value31";
    DalRightsId[DalRightsId["Value32"] = 32] = "Value32";
    DalRightsId[DalRightsId["Value33"] = 33] = "Value33";
    DalRightsId[DalRightsId["Value34"] = 34] = "Value34";
    DalRightsId[DalRightsId["Value35"] = 35] = "Value35";
    DalRightsId[DalRightsId["Value36"] = 36] = "Value36";
    DalRightsId[DalRightsId["Value37"] = 37] = "Value37";
    DalRightsId[DalRightsId["Value38"] = 38] = "Value38";
    DalRightsId[DalRightsId["Value39"] = 39] = "Value39";
    DalRightsId[DalRightsId["Value40"] = 40] = "Value40";
    DalRightsId[DalRightsId["Value41"] = 41] = "Value41";
    DalRightsId[DalRightsId["Value42"] = 42] = "Value42";
    DalRightsId[DalRightsId["Value43"] = 43] = "Value43";
    DalRightsId[DalRightsId["Value44"] = 44] = "Value44";
    DalRightsId[DalRightsId["Value45"] = 45] = "Value45";
    DalRightsId[DalRightsId["Value46"] = 46] = "Value46";
    DalRightsId[DalRightsId["Value47"] = 47] = "Value47";
    DalRightsId[DalRightsId["Value48"] = 48] = "Value48";
    DalRightsId[DalRightsId["Value49"] = 49] = "Value49";
    DalRightsId[DalRightsId["Value50"] = 50] = "Value50";
    DalRightsId[DalRightsId["Value51"] = 51] = "Value51";
    DalRightsId[DalRightsId["Value52"] = 52] = "Value52";
    DalRightsId[DalRightsId["Value53"] = 53] = "Value53";
    DalRightsId[DalRightsId["Value54"] = 54] = "Value54";
    DalRightsId[DalRightsId["Value55"] = 55] = "Value55";
    DalRightsId[DalRightsId["Value56"] = 56] = "Value56";
    DalRightsId[DalRightsId["Value57"] = 57] = "Value57";
    DalRightsId[DalRightsId["Value58"] = 58] = "Value58";
    DalRightsId[DalRightsId["Value59"] = 59] = "Value59";
    DalRightsId[DalRightsId["Value60"] = 60] = "Value60";
    DalRightsId[DalRightsId["Value61"] = 61] = "Value61";
    DalRightsId[DalRightsId["Value62"] = 62] = "Value62";
    DalRightsId[DalRightsId["Value63"] = 63] = "Value63";
    DalRightsId[DalRightsId["Value64"] = 64] = "Value64";
    DalRightsId[DalRightsId["Value65"] = 65] = "Value65";
    DalRightsId[DalRightsId["Value66"] = 66] = "Value66";
    DalRightsId[DalRightsId["Value67"] = 67] = "Value67";
    DalRightsId[DalRightsId["Value68"] = 68] = "Value68";
    DalRightsId[DalRightsId["Value69"] = 69] = "Value69";
    DalRightsId[DalRightsId["Value70"] = 70] = "Value70";
    DalRightsId[DalRightsId["Value71"] = 71] = "Value71";
    DalRightsId[DalRightsId["Value72"] = 72] = "Value72";
    DalRightsId[DalRightsId["Value73"] = 73] = "Value73";
    DalRightsId[DalRightsId["Value74"] = 74] = "Value74";
    DalRightsId[DalRightsId["Value75"] = 75] = "Value75";
    DalRightsId[DalRightsId["Value76"] = 76] = "Value76";
    DalRightsId[DalRightsId["Value77"] = 77] = "Value77";
    DalRightsId[DalRightsId["Value78"] = 78] = "Value78";
    DalRightsId[DalRightsId["Value79"] = 79] = "Value79";
    DalRightsId[DalRightsId["Value80"] = 80] = "Value80";
    DalRightsId[DalRightsId["Value81"] = 81] = "Value81";
    DalRightsId[DalRightsId["Value82"] = 82] = "Value82";
    DalRightsId[DalRightsId["Value83"] = 83] = "Value83";
    DalRightsId[DalRightsId["Value84"] = 84] = "Value84";
    DalRightsId[DalRightsId["Value85"] = 85] = "Value85";
    DalRightsId[DalRightsId["Value86"] = 86] = "Value86";
    DalRightsId[DalRightsId["Value87"] = 87] = "Value87";
    DalRightsId[DalRightsId["Value88"] = 88] = "Value88";
    DalRightsId[DalRightsId["Value89"] = 89] = "Value89";
    DalRightsId[DalRightsId["Value90"] = 90] = "Value90";
    DalRightsId[DalRightsId["Value91"] = 91] = "Value91";
    DalRightsId[DalRightsId["Value92"] = 92] = "Value92";
    DalRightsId[DalRightsId["Value93"] = 93] = "Value93";
    DalRightsId[DalRightsId["Value94"] = 94] = "Value94";
    DalRightsId[DalRightsId["Value95"] = 95] = "Value95";
    DalRightsId[DalRightsId["Value96"] = 96] = "Value96";
    DalRightsId[DalRightsId["Value97"] = 97] = "Value97";
    DalRightsId[DalRightsId["Value98"] = 98] = "Value98";
    DalRightsId[DalRightsId["Value99"] = 99] = "Value99";
    DalRightsId[DalRightsId["Value100"] = 100] = "Value100";
    DalRightsId[DalRightsId["Value101"] = 101] = "Value101";
    DalRightsId[DalRightsId["Value102"] = 102] = "Value102";
    DalRightsId[DalRightsId["Value103"] = 103] = "Value103";
    DalRightsId[DalRightsId["Value104"] = 104] = "Value104";
    DalRightsId[DalRightsId["Value105"] = 105] = "Value105";
})(DalRightsId || (DalRightsId = {}));
/**
 * Defines workday event type in workday events table
 * @format int32
 */
export var DalWorkDayEventType;
(function (DalWorkDayEventType) {
    DalWorkDayEventType[DalWorkDayEventType["Value1"] = 1] = "Value1";
    DalWorkDayEventType[DalWorkDayEventType["Value2"] = 2] = "Value2";
    DalWorkDayEventType[DalWorkDayEventType["Value3"] = 3] = "Value3";
})(DalWorkDayEventType || (DalWorkDayEventType = {}));
/** @format int32 */
export var NetHttpStatusCode;
(function (NetHttpStatusCode) {
    NetHttpStatusCode[NetHttpStatusCode["Value100"] = 100] = "Value100";
    NetHttpStatusCode[NetHttpStatusCode["Value101"] = 101] = "Value101";
    NetHttpStatusCode[NetHttpStatusCode["Value102"] = 102] = "Value102";
    NetHttpStatusCode[NetHttpStatusCode["Value103"] = 103] = "Value103";
    NetHttpStatusCode[NetHttpStatusCode["Value200"] = 200] = "Value200";
    NetHttpStatusCode[NetHttpStatusCode["Value201"] = 201] = "Value201";
    NetHttpStatusCode[NetHttpStatusCode["Value202"] = 202] = "Value202";
    NetHttpStatusCode[NetHttpStatusCode["Value203"] = 203] = "Value203";
    NetHttpStatusCode[NetHttpStatusCode["Value204"] = 204] = "Value204";
    NetHttpStatusCode[NetHttpStatusCode["Value205"] = 205] = "Value205";
    NetHttpStatusCode[NetHttpStatusCode["Value206"] = 206] = "Value206";
    NetHttpStatusCode[NetHttpStatusCode["Value207"] = 207] = "Value207";
    NetHttpStatusCode[NetHttpStatusCode["Value208"] = 208] = "Value208";
    NetHttpStatusCode[NetHttpStatusCode["Value226"] = 226] = "Value226";
    NetHttpStatusCode[NetHttpStatusCode["Value300"] = 300] = "Value300";
    NetHttpStatusCode[NetHttpStatusCode["Value301"] = 301] = "Value301";
    NetHttpStatusCode[NetHttpStatusCode["Value302"] = 302] = "Value302";
    NetHttpStatusCode[NetHttpStatusCode["Value303"] = 303] = "Value303";
    NetHttpStatusCode[NetHttpStatusCode["Value304"] = 304] = "Value304";
    NetHttpStatusCode[NetHttpStatusCode["Value305"] = 305] = "Value305";
    NetHttpStatusCode[NetHttpStatusCode["Value306"] = 306] = "Value306";
    NetHttpStatusCode[NetHttpStatusCode["Value307"] = 307] = "Value307";
    NetHttpStatusCode[NetHttpStatusCode["Value308"] = 308] = "Value308";
    NetHttpStatusCode[NetHttpStatusCode["Value400"] = 400] = "Value400";
    NetHttpStatusCode[NetHttpStatusCode["Value401"] = 401] = "Value401";
    NetHttpStatusCode[NetHttpStatusCode["Value402"] = 402] = "Value402";
    NetHttpStatusCode[NetHttpStatusCode["Value403"] = 403] = "Value403";
    NetHttpStatusCode[NetHttpStatusCode["Value404"] = 404] = "Value404";
    NetHttpStatusCode[NetHttpStatusCode["Value405"] = 405] = "Value405";
    NetHttpStatusCode[NetHttpStatusCode["Value406"] = 406] = "Value406";
    NetHttpStatusCode[NetHttpStatusCode["Value407"] = 407] = "Value407";
    NetHttpStatusCode[NetHttpStatusCode["Value408"] = 408] = "Value408";
    NetHttpStatusCode[NetHttpStatusCode["Value409"] = 409] = "Value409";
    NetHttpStatusCode[NetHttpStatusCode["Value410"] = 410] = "Value410";
    NetHttpStatusCode[NetHttpStatusCode["Value411"] = 411] = "Value411";
    NetHttpStatusCode[NetHttpStatusCode["Value412"] = 412] = "Value412";
    NetHttpStatusCode[NetHttpStatusCode["Value413"] = 413] = "Value413";
    NetHttpStatusCode[NetHttpStatusCode["Value414"] = 414] = "Value414";
    NetHttpStatusCode[NetHttpStatusCode["Value415"] = 415] = "Value415";
    NetHttpStatusCode[NetHttpStatusCode["Value416"] = 416] = "Value416";
    NetHttpStatusCode[NetHttpStatusCode["Value417"] = 417] = "Value417";
    NetHttpStatusCode[NetHttpStatusCode["Value421"] = 421] = "Value421";
    NetHttpStatusCode[NetHttpStatusCode["Value422"] = 422] = "Value422";
    NetHttpStatusCode[NetHttpStatusCode["Value423"] = 423] = "Value423";
    NetHttpStatusCode[NetHttpStatusCode["Value424"] = 424] = "Value424";
    NetHttpStatusCode[NetHttpStatusCode["Value426"] = 426] = "Value426";
    NetHttpStatusCode[NetHttpStatusCode["Value428"] = 428] = "Value428";
    NetHttpStatusCode[NetHttpStatusCode["Value429"] = 429] = "Value429";
    NetHttpStatusCode[NetHttpStatusCode["Value431"] = 431] = "Value431";
    NetHttpStatusCode[NetHttpStatusCode["Value451"] = 451] = "Value451";
    NetHttpStatusCode[NetHttpStatusCode["Value500"] = 500] = "Value500";
    NetHttpStatusCode[NetHttpStatusCode["Value501"] = 501] = "Value501";
    NetHttpStatusCode[NetHttpStatusCode["Value502"] = 502] = "Value502";
    NetHttpStatusCode[NetHttpStatusCode["Value503"] = 503] = "Value503";
    NetHttpStatusCode[NetHttpStatusCode["Value504"] = 504] = "Value504";
    NetHttpStatusCode[NetHttpStatusCode["Value505"] = 505] = "Value505";
    NetHttpStatusCode[NetHttpStatusCode["Value506"] = 506] = "Value506";
    NetHttpStatusCode[NetHttpStatusCode["Value507"] = 507] = "Value507";
    NetHttpStatusCode[NetHttpStatusCode["Value508"] = 508] = "Value508";
    NetHttpStatusCode[NetHttpStatusCode["Value510"] = 510] = "Value510";
    NetHttpStatusCode[NetHttpStatusCode["Value511"] = 511] = "Value511";
})(NetHttpStatusCode || (NetHttpStatusCode = {}));
/** @format int32 */
export var WorkTimeServiceDbEnumsSlipTimeCalculationMode;
(function (WorkTimeServiceDbEnumsSlipTimeCalculationMode) {
    WorkTimeServiceDbEnumsSlipTimeCalculationMode[WorkTimeServiceDbEnumsSlipTimeCalculationMode["Value0"] = 0] = "Value0";
    WorkTimeServiceDbEnumsSlipTimeCalculationMode[WorkTimeServiceDbEnumsSlipTimeCalculationMode["Value1"] = 1] = "Value1";
    WorkTimeServiceDbEnumsSlipTimeCalculationMode[WorkTimeServiceDbEnumsSlipTimeCalculationMode["Value2"] = 2] = "Value2";
})(WorkTimeServiceDbEnumsSlipTimeCalculationMode || (WorkTimeServiceDbEnumsSlipTimeCalculationMode = {}));
/** @format int32 */
export var WorkTimeServiceDbEnumsUserType;
(function (WorkTimeServiceDbEnumsUserType) {
    WorkTimeServiceDbEnumsUserType[WorkTimeServiceDbEnumsUserType["Value1"] = 1] = "Value1";
    WorkTimeServiceDbEnumsUserType[WorkTimeServiceDbEnumsUserType["Value2"] = 2] = "Value2";
})(WorkTimeServiceDbEnumsUserType || (WorkTimeServiceDbEnumsUserType = {}));
import axios from "axios";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/wtsApi-dev" });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title Worktime service documentation (v3.35.2624.4415)
 * @version v3.35.2624.4415
 * @baseUrl /wtsApi-dev
 */
export class Api extends HttpClient {
    v2 = {
        /**
         * No description
         *
         * @tags AggregationOperation
         * @name AggregationOperationSearchCreate
         * @request POST:/v2/AggregationOperation/Search
         */
        aggregationOperationSearchCreate: (data, params = {}) => this.request({
            path: `/v2/AggregationOperation/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags AggregationTarget
         * @name AggregationTargetSearchCreate
         * @request POST:/v2/AggregationTarget/Search
         */
        aggregationTargetSearchCreate: (data, params = {}) => this.request({
            path: `/v2/AggregationTarget/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Ams
         * @name AmsExportEmployeesCreate
         * @request POST:/v2/Ams/ExportEmployees
         */
        amsExportEmployeesCreate: (data, params = {}) => this.request({
            path: `/v2/Ams/ExportEmployees`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Ams
         * @name AmsExportAbsencesCreate
         * @request POST:/v2/Ams/ExportAbsences
         */
        amsExportAbsencesCreate: (data, params = {}) => this.request({
            path: `/v2/Ams/ExportAbsences`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Ams
         * @name AmsImportActualJobsCreate
         * @request POST:/v2/Ams/ImportActualJobs
         */
        amsImportActualJobsCreate: (data, params = {}) => this.request({
            path: `/v2/Ams/ImportActualJobs`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Ams
         * @name AmsImportPlannedJobsCreate
         * @request POST:/v2/Ams/ImportPlannedJobs
         */
        amsImportPlannedJobsCreate: (data, params = {}) => this.request({
            path: `/v2/Ams/ImportPlannedJobs`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Bonus
         * @name BonusSearchCreate
         * @request POST:/v2/Bonus/Search
         */
        bonusSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Bonus/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Bonus
         * @name BonusCreateUpdateCreate
         * @request POST:/v2/Bonus/CreateUpdate
         */
        bonusCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Bonus/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Bonus
         * @name BonusDeleteDelete
         * @request DELETE:/v2/Bonus/Delete
         */
        bonusDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Bonus/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags BonusEntry
         * @name BonusEntrySearchCreate
         * @request POST:/v2/BonusEntry/Search
         */
        bonusEntrySearchCreate: (data, params = {}) => this.request({
            path: `/v2/BonusEntry/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags BonusEntry
         * @name BonusEntryCreateUpdateCreate
         * @request POST:/v2/BonusEntry/CreateUpdate
         */
        bonusEntryCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/BonusEntry/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags BonusEntry
         * @name BonusEntryDeleteDelete
         * @request DELETE:/v2/BonusEntry/Delete
         */
        bonusEntryDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/BonusEntry/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Break
         * @name BreakSearchCreate
         * @request POST:/v2/Break/Search
         */
        breakSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Break/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Break
         * @name BreakCreateUpdateCreate
         * @request POST:/v2/Break/CreateUpdate
         */
        breakCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Break/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Break
         * @name BreakDeleteDelete
         * @request DELETE:/v2/Break/Delete
         */
        breakDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Break/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvent
         * @name CalendarEventSearchCreate
         * @request POST:/v2/CalendarEvent/Search
         */
        calendarEventSearchCreate: (data, params = {}) => this.request({
            path: `/v2/CalendarEvent/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Card
         * @name CardSearchCreate
         * @request POST:/v2/Card/Search
         */
        cardSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Card/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Card
         * @name CardCreateUpdateCreate
         * @request POST:/v2/Card/CreateUpdate
         */
        cardCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Card/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Card
         * @name CardDeleteDelete
         * @request DELETE:/v2/Card/Delete
         */
        cardDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Card/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CardType
         * @name CardTypeSearchCreate
         * @request POST:/v2/CardType/Search
         */
        cardTypeSearchCreate: (data, params = {}) => this.request({
            path: `/v2/CardType/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CardType
         * @name CardTypeCreateUpdateCreate
         * @request POST:/v2/CardType/CreateUpdate
         */
        cardTypeCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/CardType/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CardType
         * @name CardTypeDeleteDelete
         * @request DELETE:/v2/CardType/Delete
         */
        cardTypeDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/CardType/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Cc
         * @name CcJobsList
         * @request GET:/v2/Cc/Jobs
         */
        ccJobsList: (query, params = {}) => this.request({
            path: `/v2/Cc/Jobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Cc
         * @name CcUserGroupsList
         * @request GET:/v2/Cc/UserGroups
         */
        ccUserGroupsList: (query, params = {}) => this.request({
            path: `/v2/Cc/UserGroups`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Cc
         * @name CcUsersList
         * @request GET:/v2/Cc/Users
         */
        ccUsersList: (query, params = {}) => this.request({
            path: `/v2/Cc/Users`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Cc
         * @name CcDevicesList
         * @request GET:/v2/Cc/Devices
         */
        ccDevicesList: (query, params = {}) => this.request({
            path: `/v2/Cc/Devices`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CcSalesPoint
         * @name CcSalesPointSearchList
         * @request GET:/v2/CcSalesPoint/Search
         */
        ccSalesPointSearchList: (query, params = {}) => this.request({
            path: `/v2/CcSalesPoint/Search`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CcSalesPoint
         * @name CcSalesPointCreateCreate
         * @request POST:/v2/CcSalesPoint/Create
         */
        ccSalesPointCreateCreate: (data, params = {}) => this.request({
            path: `/v2/CcSalesPoint/Create`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CcSalesPoint
         * @name CcSalesPointDeleteDelete
         * @request DELETE:/v2/CcSalesPoint/Delete
         */
        ccSalesPointDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/CcSalesPoint/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CentralEntity
         * @name CentralEntityTypesList
         * @summary List of all possible entity types available use for feature queries.
         * @request GET:/v2/CentralEntity/Types
         */
        centralEntityTypesList: (query, params = {}) => this.request({
            path: `/v2/CentralEntity/Types`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CentralEntity
     * @name CentralEntityPropertiesList
     * @summary Get entity property info.
    Used for Values endpoints for optimized data size.
    Example for Type field: Int32, Bool, Array ; '?' - nullable
    Special type value 'Collection' - Contains no value but information for Collection endpoint.
                
    VALUE
    - Type: not Collection
    - RefEntity: null
    - RefProperty: null
                
    INSTANCE
    - Value: not null
    - Type: not Collection
    - RefEntity: {Entity}
                
    COLLECTION
    - Type: Collection
    - RefEntity: {Entity}
    - RefProperty: {Entity.Property}
     * @request GET:/v2/CentralEntity/Properties
     */
        centralEntityPropertiesList: (query, params = {}) => this.request({
            path: `/v2/CentralEntity/Properties`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CentralEntity
     * @name CentralEntityInstanceList
     * @summary Get entity with property info and values.
    -- Read more from Properties description --
     * @request GET:/v2/CentralEntity/Instance
     */
        centralEntityInstanceList: (query, params = {}) => this.request({
            path: `/v2/CentralEntity/Instance`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CentralEntity
     * @name CentralEntityInstanceValuesList
     * @summary Get entity with only values as dictionary.
    Use Properties endpoint for property info.
     * @request GET:/v2/CentralEntity/InstanceValues
     */
        centralEntityInstanceValuesList: (query, params = {}) => this.request({
            path: `/v2/CentralEntity/InstanceValues`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CentralEntity
     * @name CentralEntityCollectionList
     * @summary Get entities with property info and values.
    -- Read more from Properties description --
     * @request GET:/v2/CentralEntity/Collection
     */
        centralEntityCollectionList: (query, params = {}) => this.request({
            path: `/v2/CentralEntity/Collection`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CentralEntity
     * @name CentralEntityCollectionValuesList
     * @summary Get entities with only values as dictionary.
    Use Properties endpoint for property info.
     * @request GET:/v2/CentralEntity/CollectionValues
     */
        centralEntityCollectionValuesList: (query, params = {}) => this.request({
            path: `/v2/CentralEntity/CollectionValues`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comment
         * @name CommentGetDetail
         * @request GET:/v2/Comment/Get/{Id}
         */
        commentGetDetail: (id, params = {}) => this.request({
            path: `/v2/Comment/Get/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comment
         * @name CommentSearchCreate
         * @request POST:/v2/Comment/Search
         */
        commentSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Comment/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comment
         * @name CommentCreateUpdateCreate
         * @request POST:/v2/Comment/CreateUpdate
         */
        commentCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Comment/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comment
         * @name CommentDeleteDelete
         * @request DELETE:/v2/Comment/Delete
         */
        commentDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Comment/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Company
         * @name CompanySearchCreate
         * @request POST:/v2/Company/Search
         */
        companySearchCreate: (data, params = {}) => this.request({
            path: `/v2/Company/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Company
         * @name CompanyCreateUpdateCreate
         * @request POST:/v2/Company/CreateUpdate
         */
        companyCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Company/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Company
         * @name CompanyDeleteDelete
         * @request DELETE:/v2/Company/Delete
         */
        companyDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Company/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Company
         * @name CompanyCountUsersCreate
         * @request POST:/v2/Company/CountUsers
         */
        companyCountUsersCreate: (data, params = {}) => this.request({
            path: `/v2/Company/CountUsers`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Compensation
         * @name CompensationGetDetail
         * @request GET:/v2/Compensation/Get/{Id}
         */
        compensationGetDetail: (id, params = {}) => this.request({
            path: `/v2/Compensation/Get/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Compensation
         * @name CompensationSearchList
         * @request GET:/v2/Compensation/Search
         */
        compensationSearchList: (query, params = {}) => this.request({
            path: `/v2/Compensation/Search`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Compensation
         * @name CompensationCreateUpdateCreate
         * @request POST:/v2/Compensation/CreateUpdate
         */
        compensationCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Compensation/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Compensation
         * @name CompensationDeleteDelete
         * @request DELETE:/v2/Compensation/Delete
         */
        compensationDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Compensation/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkSearchCreate
         * @request POST:/v2/CompletedWork/Search
         */
        completedWorkSearchCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkSearchConfirmedCreate
         * @request POST:/v2/CompletedWork/SearchConfirmed
         */
        completedWorkSearchConfirmedCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/SearchConfirmed`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkSearchMixedConfirmedCreate
         * @request POST:/v2/CompletedWork/SearchMixedConfirmed
         */
        completedWorkSearchMixedConfirmedCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/SearchMixedConfirmed`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkExcelCreate
         * @request POST:/v2/CompletedWork/Excel
         */
        completedWorkExcelCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/Excel`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkCsvCreate
         * @request POST:/v2/CompletedWork/Csv
         */
        completedWorkCsvCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/Csv`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkMeritHoursCreate
         * @request POST:/v2/CompletedWork/MeritHours
         */
        completedWorkMeritHoursCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/MeritHours`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkMeritAbsencesCreate
         * @request POST:/v2/CompletedWork/MeritAbsences
         */
        completedWorkMeritAbsencesCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/MeritAbsences`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkDirectoCreate
         * @request POST:/v2/CompletedWork/Directo
         */
        completedWorkDirectoCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/Directo`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWork
         * @name CompletedWorkTaaviCreate
         * @request POST:/v2/CompletedWork/Taavi
         */
        completedWorkTaaviCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWork/Taavi`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWorkConfirmation
         * @name CompletedWorkConfirmationSetCreate
         * @request POST:/v2/CompletedWorkConfirmation/Set
         */
        completedWorkConfirmationSetCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWorkConfirmation/Set`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWorkConfirmation
         * @name CompletedWorkConfirmationRemoveCreate
         * @request POST:/v2/CompletedWorkConfirmation/Remove
         */
        completedWorkConfirmationRemoveCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWorkConfirmation/Remove`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWorkConfirmation
         * @name CompletedWorkConfirmationGetCreate
         * @request POST:/v2/CompletedWorkConfirmation/Get
         */
        completedWorkConfirmationGetCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWorkConfirmation/Get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWorkConfirmation
         * @name CompletedWorkConfirmationSearchCreate
         * @request POST:/v2/CompletedWorkConfirmation/Search
         */
        completedWorkConfirmationSearchCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWorkConfirmation/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompletedWorkConfirmation
         * @name CompletedWorkConfirmationGetExtendedCreate
         * @request POST:/v2/CompletedWorkConfirmation/GetExtended
         */
        completedWorkConfirmationGetExtendedCreate: (data, params = {}) => this.request({
            path: `/v2/CompletedWorkConfirmation/GetExtended`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configuration
         * @name ConfigurationSearchCreate
         * @request POST:/v2/Configuration/Search
         */
        configurationSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Configuration/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configuration
         * @name ConfigurationUpdateManyUpdate
         * @request PUT:/v2/Configuration/UpdateMany
         */
        configurationUpdateManyUpdate: (data, params = {}) => this.request({
            path: `/v2/Configuration/UpdateMany`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DateTimeDiameter
         * @name DateTimeDiameterSearchCreate
         * @request POST:/v2/DateTimeDiameter/Search
         */
        dateTimeDiameterSearchCreate: (data, params = {}) => this.request({
            path: `/v2/DateTimeDiameter/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DbVersion
         * @name DbVersionSearchCreate
         * @request POST:/v2/DbVersion/Search
         */
        dbVersionSearchCreate: (data, params = {}) => this.request({
            path: `/v2/DbVersion/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DbVersion
         * @name DbVersionUpdateCreate
         * @request POST:/v2/DbVersion/Update
         */
        dbVersionUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/DbVersion/Update`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DbVersion
         * @name DbVersionAvailableList
         * @request GET:/v2/DbVersion/Available
         */
        dbVersionAvailableList: (query, params = {}) => this.request({
            path: `/v2/DbVersion/Available`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Employee
         * @name EmployeeSearchCreate
         * @request POST:/v2/Employee/Search
         */
        employeeSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Employee/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Entity
         * @name EntityTypesList
         * @summary List of all possible entity types available use for feature queries.
         * @request GET:/v2/Entity/Types
         */
        entityTypesList: (query, params = {}) => this.request({
            path: `/v2/Entity/Types`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Entity
     * @name EntityPropertiesList
     * @summary Get entity property info.
    Used for Values endpoints for optimized data size.
    Example for Type field: Int32, Bool, Array ; '?' - nullable
    Special type value 'Collection' - Contains no value but information for Collection endpoint.
                
    VALUE
    - Type: not Collection
    - RefEntity: null
    - RefProperty: null
                
    INSTANCE
    - Value: not null
    - Type: not Collection
    - RefEntity: {Entity}
                
    COLLECTION
    - Type: Collection
    - RefEntity: {Entity}
    - RefProperty: {Entity.Property}
     * @request GET:/v2/Entity/Properties
     */
        entityPropertiesList: (query, params = {}) => this.request({
            path: `/v2/Entity/Properties`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Entity
     * @name EntityInstanceList
     * @summary Get entity with property info and values.
    -- Read more from Properties description --
     * @request GET:/v2/Entity/Instance
     */
        entityInstanceList: (query, params = {}) => this.request({
            path: `/v2/Entity/Instance`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Entity
     * @name EntityInstanceValuesList
     * @summary Get entity with only values as dictionary.
    Use Properties endpoint for property info.
     * @request GET:/v2/Entity/InstanceValues
     */
        entityInstanceValuesList: (query, params = {}) => this.request({
            path: `/v2/Entity/InstanceValues`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Entity
     * @name EntityCollectionList
     * @summary Get entities with property info and values.
    -- Read more from Properties description --
     * @request GET:/v2/Entity/Collection
     */
        entityCollectionList: (query, params = {}) => this.request({
            path: `/v2/Entity/Collection`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Entity
     * @name EntityCollectionValuesList
     * @summary Get entities with only values as dictionary.
    Use Properties endpoint for property info.
     * @request GET:/v2/Entity/CollectionValues
     */
        entityCollectionValuesList: (query, params = {}) => this.request({
            path: `/v2/Entity/CollectionValues`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EntityHistory
         * @name EntityHistoryGetList
         * @summary Get entity values at given time.
         * @request GET:/v2/EntityHistory/Get
         */
        entityHistoryGetList: (query, params = {}) => this.request({
            path: `/v2/EntityHistory/Get`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EntityHistory
         * @name EntityHistorySearchList
         * @summary Get entity history information in given range.
         * @request GET:/v2/EntityHistory/Search
         */
        entityHistorySearchList: (query, params = {}) => this.request({
            path: `/v2/EntityHistory/Search`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EntityTable
         * @name EntityTableSearchCreate
         * @request POST:/v2/EntityTable/Search
         */
        entityTableSearchCreate: (data, params = {}) => this.request({
            path: `/v2/EntityTable/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EntityTable
         * @name EntityTableTypesList
         * @request GET:/v2/EntityTable/Types
         */
        entityTableTypesList: (query, params = {}) => this.request({
            path: `/v2/EntityTable/Types`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EntityTable
         * @name EntityTablePropertiesCreate
         * @request POST:/v2/EntityTable/Properties
         */
        entityTablePropertiesCreate: (query, params = {}) => this.request({
            path: `/v2/EntityTable/Properties`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EntityTable
         * @name EntityTableParametersCreate
         * @request POST:/v2/EntityTable/Parameters
         */
        entityTableParametersCreate: (query, params = {}) => this.request({
            path: `/v2/EntityTable/Parameters`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ExportExpenses
         * @name ExportExpensesSearchCreate
         * @request POST:/v2/ExportExpenses/Search
         */
        exportExpensesSearchCreate: (query, params = {}) => this.request({
            path: `/v2/ExportExpenses/Search`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ExportExpenses
         * @name ExportExpensesFilteredCreate
         * @request POST:/v2/ExportExpenses/Filtered
         */
        exportExpensesFilteredCreate: (query, params = {}) => this.request({
            path: `/v2/ExportExpenses/Filtered`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ExternalAbsence
         * @name ExternalAbsenceColumbusImportCreate
         * @request POST:/v2/ExternalAbsence/ColumbusImport
         */
        externalAbsenceColumbusImportCreate: (data, params = {}) => this.request({
            path: `/v2/ExternalAbsence/ColumbusImport`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ExternalExpenses
         * @name ExternalExpensesSearchCreate
         * @request POST:/v2/ExternalExpenses/Search
         */
        externalExpensesSearchCreate: (query, params = {}) => this.request({
            path: `/v2/ExternalExpenses/Search`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags FreeTime
         * @name FreeTimeSearchCreate
         * @request POST:/v2/FreeTime/Search
         */
        freeTimeSearchCreate: (data, params = {}) => this.request({
            path: `/v2/FreeTime/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags FreeTime
         * @name FreeTimeCreateUpdateCreate
         * @request POST:/v2/FreeTime/CreateUpdate
         */
        freeTimeCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/FreeTime/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags FreeTime
         * @name FreeTimeDeleteDelete
         * @request DELETE:/v2/FreeTime/Delete
         */
        freeTimeDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/FreeTime/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobEvent
         * @name JobEventInitiateCreate
         * @request POST:/v2/JobEvent/Initiate
         */
        jobEventInitiateCreate: (data, params = {}) => this.request({
            path: `/v2/JobEvent/Initiate`,
            method: "POST",
            body: data,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LogicalOperator
         * @name LogicalOperatorSearchCreate
         * @request POST:/v2/LogicalOperator/Search
         */
        logicalOperatorSearchCreate: (data, params = {}) => this.request({
            path: `/v2/LogicalOperator/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LoginInfo
         * @name LoginInfoCompanyList
         * @request GET:/v2/LoginInfo/Company
         */
        loginInfoCompanyList: (query, params = {}) => this.request({
            path: `/v2/LoginInfo/Company`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Lunch
         * @name LunchGetLengthList
         * @request GET:/v2/Lunch/GetLength
         */
        lunchGetLengthList: (query, params = {}) => this.request({
            path: `/v2/Lunch/GetLength`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Lunch
         * @name LunchGetIntervalsCreate
         * @request POST:/v2/Lunch/GetIntervals
         */
        lunchGetIntervalsCreate: (data, params = {}) => this.request({
            path: `/v2/Lunch/GetIntervals`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LunchPolicy
         * @name LunchPolicyFlexibleLunchLengthList
         * @request GET:/v2/LunchPolicy/FlexibleLunchLength
         */
        lunchPolicyFlexibleLunchLengthList: (query, params = {}) => this.request({
            path: `/v2/LunchPolicy/FlexibleLunchLength`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LunchPolicy
         * @name LunchPolicySearchCreate
         * @request POST:/v2/LunchPolicy/Search
         */
        lunchPolicySearchCreate: (data, params = {}) => this.request({
            path: `/v2/LunchPolicy/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LunchPolicy
         * @name LunchPolicyCreateUpdateCreate
         * @request POST:/v2/LunchPolicy/CreateUpdate
         */
        lunchPolicyCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/LunchPolicy/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LunchPolicy
         * @name LunchPolicyCreateManyCreate
         * @request POST:/v2/LunchPolicy/CreateMany
         */
        lunchPolicyCreateManyCreate: (data, params = {}) => this.request({
            path: `/v2/LunchPolicy/CreateMany`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LunchPolicy
         * @name LunchPolicyDeleteDelete
         * @request DELETE:/v2/LunchPolicy/Delete
         */
        lunchPolicyDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/LunchPolicy/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags MachineTime
         * @name MachineTimeDeleteCreate
         * @request POST:/v2/MachineTime/Delete
         */
        machineTimeDeleteCreate: (data, params = {}) => this.request({
            path: `/v2/MachineTime/Delete`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Module
         * @name ModuleSearchCreate
         * @request POST:/v2/Module/Search
         */
        moduleSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Module/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Module
         * @name ModuleCreateCreate
         * @request POST:/v2/Module/Create
         */
        moduleCreateCreate: (data, params = {}) => this.request({
            path: `/v2/Module/Create`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Module
         * @name ModuleUpdateCreate
         * @request POST:/v2/Module/Update
         */
        moduleUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Module/Update`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Module
         * @name ModuleSoftDeleteDelete
         * @request DELETE:/v2/Module/SoftDelete
         */
        moduleSoftDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Module/SoftDelete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Person
         * @name PersonSearchCreate
         * @request POST:/v2/Person/Search
         */
        personSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Person/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PersonBonus
         * @name PersonBonusSearchCreate
         * @request POST:/v2/PersonBonus/Search
         */
        personBonusSearchCreate: (data, params = {}) => this.request({
            path: `/v2/PersonBonus/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PersonBonus
         * @name PersonBonusCreateUpdateCreate
         * @request POST:/v2/PersonBonus/CreateUpdate
         */
        personBonusCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/PersonBonus/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PersonBonus
         * @name PersonBonusDeleteDelete
         * @request DELETE:/v2/PersonBonus/Delete
         */
        personBonusDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/PersonBonus/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Pin
         * @name PinGetList
         * @request GET:/v2/Pin/Get
         */
        pinGetList: (query, params = {}) => this.request({
            path: `/v2/Pin/Get`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Pin
         * @name PinGenerateCreate
         * @request POST:/v2/Pin/Generate
         */
        pinGenerateCreate: (data, params = {}) => this.request({
            path: `/v2/Pin/Generate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannedAbsence
         * @name PlannedAbsenceSearchList
         * @request GET:/v2/PlannedAbsence/Search
         */
        plannedAbsenceSearchList: (query, params = {}) => this.request({
            path: `/v2/PlannedAbsence/Search`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannedAbsence
         * @name PlannedAbsenceCreateCreate
         * @request POST:/v2/PlannedAbsence/Create
         */
        plannedAbsenceCreateCreate: (data, params = {}) => this.request({
            path: `/v2/PlannedAbsence/Create`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannedAbsence
         * @name PlannedAbsenceDeleteDelete
         * @request DELETE:/v2/PlannedAbsence/Delete
         */
        plannedAbsenceDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/PlannedAbsence/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Planner
         * @name PlannerSearchCreate
         * @request POST:/v2/Planner/Search
         */
        plannerSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Planner/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Planner
         * @name PlannerAddJobsCreate
         * @request POST:/v2/Planner/AddJobs
         */
        plannerAddJobsCreate: (data, params = {}) => this.request({
            path: `/v2/Planner/AddJobs`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Planner
         * @name PlannerUpdateJobsUpdate
         * @request PUT:/v2/Planner/UpdateJobs
         */
        plannerUpdateJobsUpdate: (data, params = {}) => this.request({
            path: `/v2/Planner/UpdateJobs`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Planner
         * @name PlannerAddAbsencesCreate
         * @request POST:/v2/Planner/AddAbsences
         */
        plannerAddAbsencesCreate: (data, params = {}) => this.request({
            path: `/v2/Planner/AddAbsences`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Planner
         * @name PlannerUpdateAbsencesUpdate
         * @request PUT:/v2/Planner/UpdateAbsences
         */
        plannerUpdateAbsencesUpdate: (data, params = {}) => this.request({
            path: `/v2/Planner/UpdateAbsences`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Planner
         * @name PlannerGenerateCalendarEventsCreate
         * @request POST:/v2/Planner/GenerateCalendarEvents
         */
        plannerGenerateCalendarEventsCreate: (data, params = {}) => this.request({
            path: `/v2/Planner/GenerateCalendarEvents`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerPolicy
         * @name PlannerPolicySearchCreate
         * @request POST:/v2/PlannerPolicy/Search
         */
        plannerPolicySearchCreate: (data, params = {}) => this.request({
            path: `/v2/PlannerPolicy/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerPolicy
         * @name PlannerPolicyCreateUpdateCreate
         * @request POST:/v2/PlannerPolicy/CreateUpdate
         */
        plannerPolicyCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/PlannerPolicy/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerPolicy
         * @name PlannerPolicyDeleteDelete
         * @request DELETE:/v2/PlannerPolicy/Delete
         */
        plannerPolicyDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/PlannerPolicy/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerPolicy
         * @name PlannerPolicyEvaluateCreate
         * @request POST:/v2/PlannerPolicy/Evaluate
         */
        plannerPolicyEvaluateCreate: (data, params = {}) => this.request({
            path: `/v2/PlannerPolicy/Evaluate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerPolicy
         * @name PlannerPolicySuggestEventsCreate
         * @request POST:/v2/PlannerPolicy/SuggestEvents
         */
        plannerPolicySuggestEventsCreate: (data, params = {}) => this.request({
            path: `/v2/PlannerPolicy/SuggestEvents`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Product
         * @name ProductGetDetail
         * @request GET:/v2/Product/Get/{Id}
         */
        productGetDetail: (id, params = {}) => this.request({
            path: `/v2/Product/Get/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Product
         * @name ProductSearchCreate
         * @request POST:/v2/Product/Search
         */
        productSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Product/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Product
         * @name ProductCreateCreate
         * @request POST:/v2/Product/Create
         */
        productCreateCreate: (data, params = {}) => this.request({
            path: `/v2/Product/Create`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Product
         * @name ProductUpdateCreate
         * @request POST:/v2/Product/Update
         */
        productUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Product/Update`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Product
         * @name ProductDeleteDelete
         * @request DELETE:/v2/Product/Delete
         */
        productDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Product/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RecentEntity
         * @name RecentEntitySearchCreate
         * @request POST:/v2/RecentEntity/Search
         */
        recentEntitySearchCreate: (data, params = {}) => this.request({
            path: `/v2/RecentEntity/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RecentEntity
         * @name RecentEntitySearchPersonalCreate
         * @request POST:/v2/RecentEntity/SearchPersonal
         */
        recentEntitySearchPersonalCreate: (data, params = {}) => this.request({
            path: `/v2/RecentEntity/SearchPersonal`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Report
         * @name ReportGetList
         * @request GET:/v2/Report/Get
         */
        reportGetList: (query, params = {}) => this.request({
            path: `/v2/Report/Get`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Report
         * @name ReportSearchCreate
         * @request POST:/v2/Report/Search
         */
        reportSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Report/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Report
         * @name ReportCreateUpdateCreate
         * @request POST:/v2/Report/CreateUpdate
         */
        reportCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Report/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Report
         * @name ReportDeleteDelete
         * @request DELETE:/v2/Report/Delete
         */
        reportDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Report/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ResponseMessage
         * @name ResponseMessageSearchList
         * @request GET:/v2/ResponseMessage/Search
         */
        responseMessageSearchList: (query, params = {}) => this.request({
            path: `/v2/ResponseMessage/Search`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorGetList
         * @request GET:/v2/SimpleRegistrator/Get
         */
        simpleRegistratorGetList: (query, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/Get`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorGetUserList
         * @request GET:/v2/SimpleRegistrator/GetUser
         */
        simpleRegistratorGetUserList: (query, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/GetUser`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorGetPhotoList
         * @request GET:/v2/SimpleRegistrator/GetPhoto
         */
        simpleRegistratorGetPhotoList: (query, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/GetPhoto`,
            method: "GET",
            query: query,
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorSearchCreate
         * @request POST:/v2/SimpleRegistrator/Search
         */
        simpleRegistratorSearchCreate: (data, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorCreateCreate
         * @request POST:/v2/SimpleRegistrator/Create
         */
        simpleRegistratorCreateCreate: (data, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/Create`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorUpdateUpdate
         * @request PUT:/v2/SimpleRegistrator/Update
         */
        simpleRegistratorUpdateUpdate: (data, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/Update`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SimpleRegistrator
         * @name SimpleRegistratorClientSecretUpdate
         * @request PUT:/v2/SimpleRegistrator/ClientSecret
         */
        simpleRegistratorClientSecretUpdate: (data, params = {}) => this.request({
            path: `/v2/SimpleRegistrator/ClientSecret`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Skill
         * @name SkillSearchCreate
         * @request POST:/v2/Skill/Search
         */
        skillSearchCreate: (data, params = {}) => this.request({
            path: `/v2/Skill/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Skill
         * @name SkillCreateUpdateCreate
         * @request POST:/v2/Skill/CreateUpdate
         */
        skillCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/Skill/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Skill
         * @name SkillDeleteDelete
         * @request DELETE:/v2/Skill/Delete
         */
        skillDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/Skill/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScale
         * @name SkillScaleSearchCreate
         * @request POST:/v2/SkillScale/Search
         */
        skillScaleSearchCreate: (data, params = {}) => this.request({
            path: `/v2/SkillScale/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScale
         * @name SkillScaleCreateUpdateCreate
         * @request POST:/v2/SkillScale/CreateUpdate
         */
        skillScaleCreateUpdateCreate: (data, params = {}) => this.request({
            path: `/v2/SkillScale/CreateUpdate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScale
         * @name SkillScaleDeleteDelete
         * @request DELETE:/v2/SkillScale/Delete
         */
        skillScaleDeleteDelete: (query, params = {}) => this.request({
            path: `/v2/SkillScale/Delete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SpeedTest
         * @name SpeedTestLoggedInList
         * @request GET:/v2/SpeedTest/LoggedIn
         */
        speedTestLoggedInList: (params = {}) => this.request({
            path: `/v2/SpeedTest/LoggedIn`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SpeedTest
         * @name SpeedTestAnonymousList
         * @request GET:/v2/SpeedTest/Anonymous
         */
        speedTestAnonymousList: (params = {}) => this.request({
            path: `/v2/SpeedTest/Anonymous`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TableHistory
         * @name TableHistorySearchCreate
         * @summary Search TableHistory objects
         * @request POST:/v2/TableHistory/Search
         */
        tableHistorySearchCreate: (data, params = {}) => this.request({
            path: `/v2/TableHistory/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TableHistory
         * @name TableHistoryExcelList
         * @summary Returns Excel report for TableHistory
         * @request GET:/v2/TableHistory/Excel
         */
        tableHistoryExcelList: (query, params = {}) => this.request({
            path: `/v2/TableHistory/Excel`,
            method: "GET",
            query: query,
            ...params,
        }),
        /**
         * No description
         *
         * @tags TimeZone
         * @name TimeZoneSearchCreate
         * @request POST:/v2/TimeZone/Search
         */
        timeZoneSearchCreate: (data, params = {}) => this.request({
            path: `/v2/TimeZone/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags VirtualEvent
         * @name VirtualEventSearchCreate
         * @request POST:/v2/VirtualEvent/Search
         */
        virtualEventSearchCreate: (data, params = {}) => this.request({
            path: `/v2/VirtualEvent/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkTimeTable
         * @name WorkTimeTableSearchCreate
         * @request POST:/v2/WorkTimeTable/Search
         */
        workTimeTableSearchCreate: (data, params = {}) => this.request({
            path: `/v2/WorkTimeTable/Search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkTimeTable
         * @name WorkTimeTableSalesAndCostsCreate
         * @request POST:/v2/WorkTimeTable/SalesAndCosts
         */
        workTimeTableSalesAndCostsCreate: (data, params = {}) => this.request({
            path: `/v2/WorkTimeTable/SalesAndCosts`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    apiClients = {
        /**
         * No description
         *
         * @tags ApiClients
         * @name ApiClientsList
         * @summary Returns api clients
         * @request GET:/ApiClients
         */
        apiClientsList: (query, params = {}) => this.request({
            path: `/ApiClients`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ApiClients
         * @name ApiClientsCreate
         * @summary Creates api client object
         * @request POST:/ApiClients
         */
        apiClientsCreate: (data, params = {}) => this.request({
            path: `/ApiClients`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ApiClients
         * @name ApiClientsDelete
         * @summary Deletes api client object
         * @request DELETE:/ApiClients
         */
        apiClientsDelete: (query, params = {}) => this.request({
            path: `/ApiClients`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ApiClients
         * @name SecretUpdate
         * @summary Updates secret for api client
         * @request PUT:/ApiClients/Secret
         */
        secretUpdate: (data, params = {}) => this.request({
            path: `/ApiClients/Secret`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    argosLogs = {
        /**
         * No description
         *
         * @tags ArgosLogs
         * @name ArgosLogsList
         * @summary Returns argos log values
         * @request GET:/ArgosLogs
         */
        argosLogsList: (query, params = {}) => this.request({
            path: `/ArgosLogs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    calendarEvents = {
        /**
     * No description
     *
     * @tags CalendarEvents
     * @name CalendarEventsList
     * @summary Returns active (not soft-deleted) calendar events.
    Only dates are taken into account- time of the day is not.
     * @request GET:/CalendarEvents
     */
        calendarEventsList: (query, params = {}) => this.request({
            path: `/CalendarEvents`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name CalendarEventsCreate
         * @summary Takes calendar event and generates start and stop (if needed) marker
         * @request POST:/CalendarEvents
         */
        calendarEventsCreate: (data, params = {}) => this.request({
            path: `/CalendarEvents`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CalendarEvents
     * @name CalendarEventsUpdate
     * @summary Updates calendar event by generating new markers. If event is moved past its original end or start time
    we have to delete old event and new one is created instead. Old events markers are moved under new event.
                
    If this happens 2 event objects are returned. Old one with IsDeleted set to true and new event with
    new Id
     * @request PUT:/CalendarEvents
     */
        calendarEventsUpdate: (data, params = {}) => this.request({
            path: `/CalendarEvents`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name CalendarEventsDelete
         * @summary Updates calendar event by generating new markers
         * @request DELETE:/CalendarEvents
         */
        calendarEventsDelete: (query, params = {}) => this.request({
            path: `/CalendarEvents`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CalendarEvents
     * @name MultipleCreate
     * @summary Adds calendar events.
    If something happens in add process then whole patch is reset and canceled.
     * @request POST:/CalendarEvents/Multiple
     */
        multipleCreate: (data, params = {}) => this.request({
            path: `/CalendarEvents/Multiple`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CalendarEvents
     * @name MultipleUpdate
     * @summary Updates calendar events by generating new markers. If event is moved past its original end or start time
    we have to delete old event and new one is created instead. Old events markers are moved under new event.
                
    If this happens 2 event objects are returned. Old one with IsDeleted set to true and new event with
    new Id.
                
    If something happens in update process then whole patch is reset and canceled.
     * @request PUT:/CalendarEvents/Multiple
     */
        multipleUpdate: (data, params = {}) => this.request({
            path: `/CalendarEvents/Multiple`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name DeleteManyCreate
         * @summary Soft deletes multiple calendar events
         * @request POST:/CalendarEvents/DeleteMany
         */
        deleteManyCreate: (query, data, params = {}) => this.request({
            path: `/CalendarEvents/DeleteMany`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name EventsLogList
         * @summary Returns events that are related to calendar events.
         * @request GET:/CalendarEvents/EventsLog
         */
        eventsLogList: (query, params = {}) => this.request({
            path: `/CalendarEvents/EventsLog`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name EventsLogExcelList
         * @summary Returns events that are related to calendar events.
         * @request GET:/CalendarEvents/EventsLogExcel
         */
        eventsLogExcelList: (query, params = {}) => this.request({
            path: `/CalendarEvents/EventsLogExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name CurrentActivitiesList
         * @summary Returns current calendar events.
         * @request GET:/CalendarEvents/CurrentActivities
         */
        currentActivitiesList: (query, params = {}) => this.request({
            path: `/CalendarEvents/CurrentActivities`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name ByUserList
         * @summary Returns users with their calendar events.
         * @request GET:/CalendarEvents/ByUser
         */
        byUserList: (query, params = {}) => this.request({
            path: `/CalendarEvents/ByUser`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name GenerateCreate
         * @summary Generates calendar events for users according to the given job values
         * @request POST:/CalendarEvents/Generate
         */
        generateCreate: (data, params = {}) => this.request({
            path: `/CalendarEvents/Generate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CalendarEvents
     * @name GenerateFromPlannedList
     * @summary Generates calendar events for users according to their planned events.
    No events are planned for days with leave events.
     * @request GET:/CalendarEvents/GenerateFromPlanned
     */
        generateFromPlannedList: (query, params = {}) => this.request({
            path: `/CalendarEvents/GenerateFromPlanned`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name OpenEventsList
         * @summary Get open events for user(s) or department(s)
         * @request GET:/CalendarEvents/OpenEvents
         */
        openEventsList: (query, params = {}) => this.request({
            path: `/CalendarEvents/OpenEvents`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CalendarEvents
     * @name MultipleCalendarEventsCreate
     * @summary Adds or updates calendar events.
    If something happens in add process then whole patch is reset and canceled.
     * @request POST:/CalendarEvents/MultipleCalendarEvents
     */
        multipleCalendarEventsCreate: (data, params = {}) => this.request({
            path: `/CalendarEvents/MultipleCalendarEvents`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CalendarEvents
         * @name GetCalendarEventsWithPerDayTotalCreate
         * @summary Returns users with their calendar events and total per day.
         * @request POST:/CalendarEvents/GetCalendarEventsWithPerDayTotal
         */
        getCalendarEventsWithPerDayTotalCreate: (data, params = {}) => this.request({
            path: `/CalendarEvents/GetCalendarEventsWithPerDayTotal`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    cards = {
        /**
         * No description
         *
         * @tags Cards
         * @name CardsList
         * @summary Get cards that are in system
         * @request GET:/Cards
         */
        cardsList: (query, params = {}) => this.request({
            path: `/Cards`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description On 200 ResponseId must be checked. If not 0 then card was successfully added to database but not all devices received the data.
         *
         * @tags Cards
         * @name CardsCreate
         * @summary Add new card to user
         * @request POST:/Cards
         */
        cardsCreate: (data, params = {}) => this.request({
            path: `/Cards`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description On 200 ResponseId must be checked. If not 0 then card was successfully deleted from database but not all devices received the data.
         *
         * @tags Cards
         * @name CardsDelete
         * @summary Delete user card
         * @request DELETE:/Cards
         */
        cardsDelete: (query, params = {}) => this.request({
            path: `/Cards`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Cards
         * @name CardsUpdate
         * @summary Updates card object
         * @request PUT:/Cards
         */
        cardsUpdate: (data, params = {}) => this.request({
            path: `/Cards`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    cardTypes = {
        /**
         * No description
         *
         * @tags CardTypes
         * @name CardTypesList
         * @summary Get card types that are in system
         * @request GET:/CardTypes
         */
        cardTypesList: (query, params = {}) => this.request({
            path: `/CardTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    columbus = {
        /**
         * No description
         *
         * @tags Columbus
         * @name ExportWorkHoursCreate
         * @summary Export work hours from WTS to Columbus
         * @request POST:/Columbus/ExportWorkHours
         */
        exportWorkHoursCreate: (data, params = {}) => this.request({
            path: `/Columbus/ExportWorkHours`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Columbus
     * @name ExportAbsencesCreate
     * @summary Export absences from WTS to Columbus
    Only absences with the code "PT"
    Exports also unconfirmed data
    Exports only for employees with "summed by equal week" and "summed by working day" contracts
     * @request POST:/Columbus/ExportAbsences
     */
        exportAbsencesCreate: (data, params = {}) => this.request({
            path: `/Columbus/ExportAbsences`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Columbus
         * @name AbsencesList
         * @summary Query absences from Columbus
         * @request GET:/Columbus/Absences
         */
        absencesList: (query, params = {}) => this.request({
            path: `/Columbus/Absences`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Columbus
         * @name ClearAfterResignationEventsDelete
         * @summary Clear user events from certain date
         * @request DELETE:/Columbus/ClearAfterResignationEvents
         */
        clearAfterResignationEventsDelete: (query, params = {}) => this.request({
            path: `/Columbus/ClearAfterResignationEvents`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Columbus
         * @name ImportRateLinesList
         * @summary Export work hours from WTS to Columbus
         * @request GET:/Columbus/ImportRateLines
         */
        importRateLinesList: (query, params = {}) => this.request({
            path: `/Columbus/ImportRateLines`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    comments = {
        /**
         * No description
         *
         * @tags Comments
         * @name CommentsList
         * @request GET:/Comments
         */
        commentsList: (params = {}) => this.request({
            path: `/Comments`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comments
         * @name CommentsCreate
         * @request POST:/Comments
         */
        commentsCreate: (data, params = {}) => this.request({
            path: `/Comments`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comments
         * @name CommentsDelete
         * @request DELETE:/Comments/{CommentId}
         */
        commentsDelete: (commentId, params = {}) => this.request({
            path: `/Comments/${commentId}`,
            method: "DELETE",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Comments
         * @name CommentsUpdate
         * @request PUT:/Comments/{CommentId}
         */
        commentsUpdate: (commentId, data, params = {}) => this.request({
            path: `/Comments/${commentId}`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    companies = {
        /**
         * No description
         *
         * @tags Companies
         * @name CompaniesCreate
         * @summary Sets new company to database
         * @request POST:/Companies
         */
        companiesCreate: (data, params = {}) => this.request({
            path: `/Companies`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Companies
         * @name CompaniesUpdate
         * @summary Update company in database
         * @request PUT:/Companies
         */
        companiesUpdate: (data, params = {}) => this.request({
            path: `/Companies`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Companies
         * @name CompaniesList
         * @summary Gets companies from database
         * @request GET:/Companies
         */
        companiesList: (query, params = {}) => this.request({
            path: `/Companies`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Companies
         * @name CompaniesDelete
         * @summary Deletes company
         * @request DELETE:/Companies
         */
        companiesDelete: (query, params = {}) => this.request({
            path: `/Companies`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyConnectionStrings = {
        /**
         * No description
         *
         * @tags CompanyConnectionStrings
         * @name CompanyConnectionStringsList
         * @summary Returns companies connection strings
         * @request GET:/CompanyConnectionStrings
         */
        companyConnectionStringsList: (query, params = {}) => this.request({
            path: `/CompanyConnectionStrings`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyConnectionStrings
         * @name CompanyConnectionStringsCreate
         * @summary Sets companies connection string
         * @request POST:/CompanyConnectionStrings
         */
        companyConnectionStringsCreate: (data, params = {}) => this.request({
            path: `/CompanyConnectionStrings`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyConnectionStrings
         * @name CompanyConnectionStringsUpdate
         * @summary Updates companies connection string
         * @request PUT:/CompanyConnectionStrings
         */
        companyConnectionStringsUpdate: (data, params = {}) => this.request({
            path: `/CompanyConnectionStrings`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyConnectionStrings
         * @name CompanyConnectionStringsDelete
         * @summary Deletes companies connection string
         * @request DELETE:/CompanyConnectionStrings
         */
        companyConnectionStringsDelete: (query, params = {}) => this.request({
            path: `/CompanyConnectionStrings`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags CompanyConnectionStrings
     * @name PasswordBatchPartialUpdate
     * @summary Batch updates DatabasePassword for records matched by (SqlServer, DatabaseUser).
    If no record is found for an item, it is still reported as success.
    only changes records in database (not the actual sql password)
     * @request PATCH:/CompanyConnectionStrings/password/batch
     */
        passwordBatchPartialUpdate: (data, params = {}) => this.request({
            path: `/CompanyConnectionStrings/password/batch`,
            method: "PATCH",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    companyContractTypes = {
        /**
         * No description
         *
         * @tags CompanyContractTypes
         * @name CompanyContractTypesList
         * @summary Gets company contract types
         * @request GET:/CompanyContractTypes
         */
        companyContractTypesList: (query, params = {}) => this.request({
            path: `/CompanyContractTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyDepartments = {
        /**
         * No description
         *
         * @tags CompanyDepartments
         * @name CompanyDepartmentsList
         * @summary Gets company departments
         * @request GET:/CompanyDepartments
         */
        companyDepartmentsList: (query, params = {}) => this.request({
            path: `/CompanyDepartments`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyDevices = {
        /**
         * No description
         *
         * @tags CompanyDevices
         * @name CompanyDevicesCreate
         * @summary Sets new device to company database.
         * @request POST:/CompanyDevices
         */
        companyDevicesCreate: (query, data, params = {}) => this.request({
            path: `/CompanyDevices`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyDevices
         * @name CompanyDevicesUpdate
         * @summary Updates device to company database
         * @request PUT:/CompanyDevices
         */
        companyDevicesUpdate: (query, data, params = {}) => this.request({
            path: `/CompanyDevices`,
            method: "PUT",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyDevices
         * @name CompanyDevicesList
         * @summary Gets form devices to database
         * @request GET:/CompanyDevices
         */
        companyDevicesList: (query, params = {}) => this.request({
            path: `/CompanyDevices`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyDevices
         * @name CompanyDevicesDelete
         * @summary Deletes device from company database
         * @request DELETE:/CompanyDevices
         */
        companyDevicesDelete: (query, params = {}) => this.request({
            path: `/CompanyDevices`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyStatusTypes = {
        /**
         * No description
         *
         * @tags CompanyStatusTypes
         * @name CompanyStatusTypesList
         * @summary Returns company status types
         * @request GET:/CompanyStatusTypes
         */
        companyStatusTypesList: (params = {}) => this.request({
            path: `/CompanyStatusTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    companyTransfers = {
        /**
         * No description
         *
         * @tags CompanyTransfers
         * @name CompanyTransfersList
         * @summary Transfer data from central db
         * @request GET:/CompanyTransfers
         */
        companyTransfersList: (query, params = {}) => this.request({
            path: `/CompanyTransfers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyUserGroups = {
        /**
         * No description
         *
         * @tags CompanyUserGroups
         * @name CompanyUserGroupsList
         * @summary Gets company user groups
         * @request GET:/CompanyUserGroups
         */
        companyUserGroupsList: (query, params = {}) => this.request({
            path: `/CompanyUserGroups`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyUsers = {
        /**
         * No description
         *
         * @tags CompanyUsers
         * @name CompanyUsersList
         * @summary Gets company departments
         * @request GET:/CompanyUsers
         */
        companyUsersList: (query, params = {}) => this.request({
            path: `/CompanyUsers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CompanyUsers
         * @name CompanyUsersCreate
         * @summary Sets new user to company
         * @request POST:/CompanyUsers
         */
        companyUsersCreate: (query, data, params = {}) => this.request({
            path: `/CompanyUsers`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    companyWorkGroups = {
        /**
         * No description
         *
         * @tags CompanyWorkGroups
         * @name CompanyWorkGroupsList
         * @summary Get company work groups
         * @request GET:/CompanyWorkGroups
         */
        companyWorkGroupsList: (query, params = {}) => this.request({
            path: `/CompanyWorkGroups`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    companyWorkShifts = {
        /**
         * No description
         *
         * @tags CompanyWorkShifts
         * @name CompanyWorkShiftsList
         * @summary Get company work shifts
         * @request GET:/CompanyWorkShifts
         */
        companyWorkShiftsList: (query, params = {}) => this.request({
            path: `/CompanyWorkShifts`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    configurations = {
        /**
         * No description
         *
         * @tags Configurations
         * @name GeneralList
         * @summary Get general configuration
         * @request GET:/Configurations/General
         */
        generalList: (params = {}) => this.request({
            path: `/Configurations/General`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name GeneralUpdate
         * @summary Updates general configuration
         * @request PUT:/Configurations/General
         */
        generalUpdate: (data, params = {}) => this.request({
            path: `/Configurations/General`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name ConfirmationLevelsList
         * @summary Get Confirmation Levels configuration
         * @request GET:/Configurations/ConfirmationLevels
         */
        confirmationLevelsList: (params = {}) => this.request({
            path: `/Configurations/ConfirmationLevels`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name ConfirmationLevelsUpdate
         * @summary Updates confirmation levels configuration
         * @request PUT:/Configurations/ConfirmationLevels
         */
        confirmationLevelsUpdate: (data, params = {}) => this.request({
            path: `/Configurations/ConfirmationLevels`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name GetConfigurations
         * @summary Get web configuration
         * @request GET:/Configurations/Web
         */
        getConfigurations: (params = {}) => this.request({
            path: `/Configurations/Web`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name PutConfigurations
         * @summary Updates web configuration
         * @request PUT:/Configurations/Web
         */
        putConfigurations: (data, params = {}) => this.request({
            path: `/Configurations/Web`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name AxaptaList
         * @summary Get Axapta configuration
         * @request GET:/Configurations/Axapta
         */
        axaptaList: (params = {}) => this.request({
            path: `/Configurations/Axapta`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name AxaptaUpdate
         * @summary Updates Axapta configuration
         * @request PUT:/Configurations/Axapta
         */
        axaptaUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Axapta`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name LunchList
         * @summary Get lunch configuration
         * @request GET:/Configurations/Lunch
         */
        lunchList: (params = {}) => this.request({
            path: `/Configurations/Lunch`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name LunchUpdate
         * @summary Updates Lunch configuration
         * @request PUT:/Configurations/Lunch
         */
        lunchUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Lunch`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name BreakList
         * @summary Get break configuration
         * @request GET:/Configurations/Break
         */
        breakList: (params = {}) => this.request({
            path: `/Configurations/Break`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name BreakUpdate
         * @summary Updates break configuration
         * @request PUT:/Configurations/Break
         */
        breakUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Break`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name DefaultTimeRateList
         * @summary Get default timerate configuration
         * @request GET:/Configurations/DefaultTimeRate
         */
        defaultTimeRateList: (params = {}) => this.request({
            path: `/Configurations/DefaultTimeRate`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name DefaultTimeRateUpdate
         * @summary Updates default timerate configuration
         * @request PUT:/Configurations/DefaultTimeRate
         */
        defaultTimeRateUpdate: (data, params = {}) => this.request({
            path: `/Configurations/DefaultTimeRate`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name MeritList
         * @summary Get Merit configuration
         * @request GET:/Configurations/Merit
         */
        meritList: (params = {}) => this.request({
            path: `/Configurations/Merit`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name MeritUpdate
         * @summary Updates Merit configuration
         * @request PUT:/Configurations/Merit
         */
        meritUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Merit`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name PersonaList
         * @summary Get Persona configuration
         * @request GET:/Configurations/Persona
         */
        personaList: (params = {}) => this.request({
            path: `/Configurations/Persona`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name PersonaUpdate
         * @summary Updates Persona configuration
         * @request PUT:/Configurations/Persona
         */
        personaUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Persona`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name CentralDefaultClientRestrictionsList
         * @summary Get default client restrictions configuration
         * @request GET:/Configurations/Central/DefaultClientRestrictions
         */
        centralDefaultClientRestrictionsList: (params = {}) => this.request({
            path: `/Configurations/Central/DefaultClientRestrictions`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name CentralDefaultClientRestrictionsUpdate
         * @summary Updates default client restrictions configuration
         * @request PUT:/Configurations/Central/DefaultClientRestrictions
         */
        centralDefaultClientRestrictionsUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Central/DefaultClientRestrictions`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name DirectoList
         * @summary Get Directo configuration
         * @request GET:/Configurations/Directo
         */
        directoList: (params = {}) => this.request({
            path: `/Configurations/Directo`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Configurations
         * @name DirectoUpdate
         * @summary Updates Directo configuration
         * @request PUT:/Configurations/Directo
         */
        directoUpdate: (data, params = {}) => this.request({
            path: `/Configurations/Directo`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    confirmationDatas = {
        /**
     * No description
     *
     * @tags ConfirmationDatas
     * @name ListFromCacheCreate
     * @summary Inserts confirmations to reports list confirmable data fields that are in cache.
    All the reports have to be stored in one cache.
     * @request POST:/ConfirmationDatas/ListFromCache
     */
        listFromCacheCreate: (query, params = {}) => this.request({
            path: `/ConfirmationDatas/ListFromCache`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationDatas
         * @name FromCacheCreate
         * @summary Inserts confirmation to report that is in cache
         * @request POST:/ConfirmationDatas/FromCache
         */
        fromCacheCreate: (query, params = {}) => this.request({
            path: `/ConfirmationDatas/FromCache`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationDatas
         * @name ConfirmationStatusList
         * @summary Get confirmation status for persons in given period
         * @request GET:/ConfirmationDatas/ConfirmationStatus
         */
        confirmationStatusList: (query, params = {}) => this.request({
            path: `/ConfirmationDatas/ConfirmationStatus`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationDatas
         * @name GetMainReportConfirmationsCreate
         * @summary Get confirmations as a dict for persons in given period
         * @request POST:/ConfirmationDatas/GetMainReportConfirmations
         */
        getMainReportConfirmationsCreate: (data, params = {}) => this.request({
            path: `/ConfirmationDatas/GetMainReportConfirmations`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationDatas
         * @name ConfirmMainReportUsersList
         * @summary Get confirmation status for persons in given period
         * @request GET:/ConfirmationDatas/ConfirmMainReportUsers
         */
        confirmMainReportUsersList: (query, params = {}) => this.request({
            path: `/ConfirmationDatas/ConfirmMainReportUsers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    confirmationUsers = {
        /**
         * No description
         *
         * @tags ConfirmationUsers
         * @name ConfirmationUsersList
         * @summary Get the possible confirming persons, filtered by userIds, reportIds and/or report levels.
         * @request GET:/ConfirmationUsers
         */
        confirmationUsersList: (query, params = {}) => this.request({
            path: `/ConfirmationUsers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationUsers
         * @name ConfirmationUsersCreate
         * @summary Creates confirmation user object
         * @request POST:/ConfirmationUsers
         */
        confirmationUsersCreate: (data, params = {}) => this.request({
            path: `/ConfirmationUsers`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationUsers
         * @name ConfirmationUsersUpdate
         * @summary Updates Confirmation User object
         * @request PUT:/ConfirmationUsers
         */
        confirmationUsersUpdate: (data, params = {}) => this.request({
            path: `/ConfirmationUsers`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ConfirmationUsers
         * @name ConfirmationUsersDelete
         * @summary Deletes confirmation user object
         * @request DELETE:/ConfirmationUsers
         */
        confirmationUsersDelete: (query, params = {}) => this.request({
            path: `/ConfirmationUsers`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    connectionTypes = {
        /**
         * No description
         *
         * @tags ConnectionTypes
         * @name ConnectionTypesList
         * @summary Gets list of supported connection types
         * @request GET:/ConnectionTypes
         */
        connectionTypesList: (params = {}) => this.request({
            path: `/ConnectionTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    contractTypes = {
        /**
         * No description
         *
         * @tags ContractTypes
         * @name ContractTypesList
         * @summary Returns contract types
         * @request GET:/ContractTypes
         */
        contractTypesList: (params = {}) => this.request({
            path: `/ContractTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    demos = {
        /**
         * No description
         *
         * @tags Demos
         * @name SendDemoRequestCreate
         * @summary Send demo request message
         * @request POST:/Demos/SendDemoRequest
         */
        sendDemoRequestCreate: (data, params = {}) => this.request({
            path: `/Demos/SendDemoRequest`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    departments = {
        /**
         * No description
         *
         * @tags Departments
         * @name WithJobsList
         * @summary Returns departments with related job ids.
         * @request GET:/Departments/WithJobs
         */
        withJobsList: (query, params = {}) => this.request({
            path: `/Departments/WithJobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Departments
         * @name DepartmentsList
         * @summary Returns departments.
         * @request GET:/Departments
         */
        departmentsList: (query, params = {}) => this.request({
            path: `/Departments`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Departments
         * @name DepartmentsUpdate
         * @summary Updates department object
         * @request PUT:/Departments
         */
        departmentsUpdate: (data, params = {}) => this.request({
            path: `/Departments`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Departments
         * @name DepartmentsCreate
         * @summary Insert new department into database and return inserted departmentId
         * @request POST:/Departments
         */
        departmentsCreate: (data, params = {}) => this.request({
            path: `/Departments`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Departments
         * @name DepartmentsDelete
         * @summary Deletes department object
         * @request DELETE:/Departments
         */
        departmentsDelete: (query, params = {}) => this.request({
            path: `/Departments`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    android = {
        /**
         * No description
         *
         * @tags Departments
         * @name GetDepartmentsList
         * @summary Gets departments
         * @request GET:/android/GetDepartments
         */
        getDepartmentsList: (query, params = {}) => this.request({
            path: `/android/GetDepartments`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Devices
         * @name GetConfList
         * @summary Get configuration for devices
         * @request GET:/android/GetConf
         */
        getConfList: (query, params = {}) => this.request({
            path: `/android/GetConf`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description If the calling device has a non-empty `AllowedDepartmentIds` in its `configuration`, that list overrides the incoming departmentIds so the terminal only ever sees jobs for the configured departments. Devices with no/empty/invalid configuration (and non-device callers) keep the current behavior.
         *
         * @tags JobDepartments
         * @name GetDepartmentJobsList
         * @summary Returns all jobs related to given departments
         * @request GET:/android/GetDepartmentJobs
         */
        getDepartmentJobsList: (query, params = {}) => this.request({
            path: `/android/GetDepartmentJobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUsers
         * @name GetUserJobsInPeriodList
         * @summary Gets user jobs in period
         * @request GET:/android/GetUserJobsInPeriod
         */
        getUserJobsInPeriodList: (query, params = {}) => this.request({
            path: `/android/GetUserJobsInPeriod`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUsers
         * @name GetUserJobsInPeriodWithTotalsList
         * @summary Gets user jobs in period with totals
         * @request GET:/android/getUserJobsInPeriodWithTotals
         */
        getUserJobsInPeriodWithTotalsList: (query, params = {}) => this.request({
            path: `/android/getUserJobsInPeriodWithTotals`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Time
         * @name GetTimeList
         * @summary Returns server time
         * @request GET:/android/GetTime
         */
        getTimeList: (params = {}) => this.request({
            path: `/android/GetTime`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name GetDepartmentUsersList
         * @summary Gets department users with their events
         * @request GET:/android/GetDepartmentUsers
         */
        getDepartmentUsersList: (query, params = {}) => this.request({
            path: `/android/GetDepartmentUsers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    deviceLogs = {
        /**
         * No description
         *
         * @tags DeviceLogs
         * @name DeviceLogsCreate
         * @summary Creates log file on server.
         * @request POST:/DeviceLogs
         */
        deviceLogsCreate: (data, params = {}) => this.request({
            path: `/DeviceLogs`,
            method: "POST",
            body: data,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
    };
    devices = {
        /**
         * No description
         *
         * @tags Devices
         * @name DevicesList
         * @summary Gets devices from database
         * @request GET:/Devices
         */
        devicesList: (query, params = {}) => this.request({
            path: `/Devices`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Devices
         * @name UpdateFileListList
         * @summary Returns updatefile list for device type
         * @request GET:/Devices/UpdateFileList
         */
        updateFileListList: (query, params = {}) => this.request({
            path: `/Devices/UpdateFileList`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Devices
         * @name UpdateFileList
         * @summary Returns updatefile list for device type
         * @request GET:/Devices/UpdateFile
         */
        updateFileList: (query, params = {}) => this.request({
            path: `/Devices/UpdateFile`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    deviceStatusActions = {
        /**
         * No description
         *
         * @tags DeviceStatusActions
         * @name DeviceStatusActionsList
         * @summary Gets device status actions from database
         * @request GET:/DeviceStatusActions
         */
        deviceStatusActionsList: (query, params = {}) => this.request({
            path: `/DeviceStatusActions`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    deviceStatuses = {
        /**
         * No description
         *
         * @tags DeviceStatuses
         * @name DeviceStatusesCreate
         * @summary Sets new device status to database
         * @request POST:/DeviceStatuses
         */
        deviceStatusesCreate: (data, params = {}) => this.request({
            path: `/DeviceStatuses`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceStatuses
         * @name DeviceStatusesList
         * @summary Gets device status actions from database
         * @request GET:/DeviceStatuses
         */
        deviceStatusesList: (query, params = {}) => this.request({
            path: `/DeviceStatuses`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    deviceTypes = {
        /**
         * No description
         *
         * @tags DeviceTypes
         * @name DeviceTypesCreate
         * @summary Sets new device type to database
         * @request POST:/DeviceTypes
         */
        deviceTypesCreate: (data, params = {}) => this.request({
            path: `/DeviceTypes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceTypes
         * @name DeviceTypesUpdate
         * @summary Updates device type to database
         * @request PUT:/DeviceTypes
         */
        deviceTypesUpdate: (data, params = {}) => this.request({
            path: `/DeviceTypes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceTypes
         * @name DeviceTypesList
         * @summary Gets device types from database
         * @request GET:/DeviceTypes
         */
        deviceTypesList: (query, params = {}) => this.request({
            path: `/DeviceTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceTypes
         * @name DeviceTypesDelete
         * @summary Deletes device type
         * @request DELETE:/DeviceTypes
         */
        deviceTypesDelete: (query, params = {}) => this.request({
            path: `/DeviceTypes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    deviceVersions = {
        /**
         * No description
         *
         * @tags DeviceVersions
         * @name DeviceVersionsCreate
         * @summary Sets new device version to database (.apk only)
         * @request POST:/DeviceVersions
         */
        deviceVersionsCreate: (query, data, params = {}) => this.request({
            path: `/DeviceVersions`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceVersions
         * @name DeviceVersionsList
         * @summary Gets device versions
         * @request GET:/DeviceVersions
         */
        deviceVersionsList: (query, params = {}) => this.request({
            path: `/DeviceVersions`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceVersions
         * @name DeviceVersionsDelete
         * @summary Deletes device version object and file
         * @request DELETE:/DeviceVersions
         */
        deviceVersionsDelete: (query, params = {}) => this.request({
            path: `/DeviceVersions`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags DeviceVersions
         * @name DeviceVersionsDetail
         * @summary Download device version files
         * @request GET:/DeviceVersions/{versionId}/{fileName}
         */
        deviceVersionsDetail: (versionId, fileName, params = {}) => this.request({
            path: `/DeviceVersions/${versionId}/${fileName}`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    events = {
        /**
         * No description
         *
         * @tags Events
         * @name ForMultipleUsersCreate
         * @summary Inserts planned events for multiple users.
         * @request POST:/Events/ForMultipleUsers
         */
        forMultipleUsersCreate: (query, data, params = {}) => this.request({
            path: `/Events/ForMultipleUsers`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name ForMultipleUsersUpdate
         * @summary Update planned events for multiple users.
         * @request PUT:/Events/ForMultipleUsers
         */
        forMultipleUsersUpdate: (data, params = {}) => this.request({
            path: `/Events/ForMultipleUsers`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * @description One of the filters must be selected otherwise error is returned.
     *
     * @tags Events
     * @name EventsList
     * @summary Returns user events in period.
    Department or user must be selected.
     * @request GET:/Events
     */
        eventsList: (query, params = {}) => this.request({
            path: `/Events`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name EventsDelete
         * @summary Deletes event
         * @request DELETE:/Events
         */
        eventsDelete: (query, params = {}) => this.request({
            path: `/Events`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name JobsSummaryList
         * @summary Returns planned times by jobs in period
         * @request GET:/Events/JobsSummary
         */
        jobsSummaryList: (query, params = {}) => this.request({
            path: `/Events/JobsSummary`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name LeavesForCalendarList
         * @summary Returns defined leaves in calendar event format for selected departments or users.
         * @request GET:/Events/LeavesForCalendar
         */
        leavesForCalendarList: (query, params = {}) => this.request({
            path: `/Events/LeavesForCalendar`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name ExternalEventsCreate
         * @summary Stores imported leave events
         * @request POST:/Events/ExternalEvents
         */
        externalEventsCreate: (query, data, params = {}) => this.request({
            path: `/Events/ExternalEvents`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name SetEventOverTimeUpdate
         * @summary Event overtime storing endpoint
         * @request PUT:/Events/SetEventOverTime
         */
        setEventOverTimeUpdate: (data, params = {}) => this.request({
            path: `/Events/SetEventOverTime`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name ByJobsInPeriodList
         * @summary Get planned job summary values separated by workshifts and into selected time lengths
         * @request GET:/Events/ByJobsInPeriod
         */
        byJobsInPeriodList: (query, params = {}) => this.request({
            path: `/Events/ByJobsInPeriod`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name SetPublishUpdate
         * @summary Update planned events visibility/restrictions for multiple users.
         * @request PUT:/Events/SetPublish
         */
        setPublishUpdate: (data, params = {}) => this.request({
            path: `/Events/SetPublish`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    argos = {
        /**
         * No description
         *
         * @tags Events
         * @name EventsList
         * @summary Retrieve argos event log values from argos database as event list
         * @request GET:/Argos/Events
         */
        eventsList: (query, params = {}) => this.request({
            path: `/Argos/Events`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name EventsDownloadFromControllersList
         * @summary Download argos event values to argos database
         * @request GET:/Argos/Events/DownloadFromControllers
         */
        eventsDownloadFromControllersList: (query, params = {}) => this.request({
            path: `/Argos/Events/DownloadFromControllers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Events
         * @name EventsArgosEventTypesList
         * @summary Get Argos EventType values
         * @request GET:/Argos/Events/ArgosEventTypes
         */
        eventsArgosEventTypesList: (params = {}) => this.request({
            path: `/Argos/Events/ArgosEventTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Locks
         * @name LocksList
         * @summary Get Argos Lock values
         * @request GET:/Argos/Locks
         */
        locksList: (query, params = {}) => this.request({
            path: `/Argos/Locks`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Locks
         * @name LocksChangeStateList
         * @summary Perform lock or open operation on selected locks.
         * @request GET:/Argos/Locks/ChangeState
         */
        locksChangeStateList: (query, params = {}) => this.request({
            path: `/Argos/Locks/ChangeState`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Maintenance
         * @name MaintenanceSetClockList
         * @summary Set clock in argos controllers
         * @request GET:/Argos/Maintenance/SetClock
         */
        maintenanceSetClockList: (query, params = {}) => this.request({
            path: `/Argos/Maintenance/SetClock`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    eventsExports = {
        /**
         * No description
         *
         * @tags EventsExports
         * @name EventsExportsList
         * @summary Returns file with user events in period. One of department, user, workshift or userdepartment must be selected.
         * @request GET:/EventsExports
         */
        eventsExportsList: (query, params = {}) => this.request({
            path: `/EventsExports`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EventsExports
         * @name ScheduleList
         * @summary Retrieves the schedule data based on a specified period and additional optional filters.
         * @request GET:/EventsExports/Schedule
         */
        scheduleList: (query, params = {}) => this.request({
            path: `/EventsExports/Schedule`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags EventsExports
         * @name MailPlannedEventsList
         * @summary Mail planned events to listed user(s)
         * @request GET:/EventsExports/MailPlannedEvents
         */
        mailPlannedEventsList: (query, params = {}) => this.request({
            path: `/EventsExports/MailPlannedEvents`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    exports = {
        /**
         * No description
         *
         * @tags Exports
         * @name WorkHoursCreate
         * @summary Exports work hours to external source
         * @request POST:/Exports/WorkHours
         */
        workHoursCreate: (query, params = {}) => this.request({
            path: `/Exports/WorkHours`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Only dates from period are used. End date is included.
         *
         * @tags Exports
         * @name ExportWorkHoursToAxaptaCreate
         * @summary Exports work hours from main report to external source
         * @request POST:/Exports/ExportWorkHoursToAxapta
         */
        exportWorkHoursToAxaptaCreate: (query, params = {}) => this.request({
            path: `/Exports/ExportWorkHoursToAxapta`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Exports
         * @name ArgosCardsCreate
         * @summary Exports user cards in Argos database to central controllers
         * @request POST:/Exports/ArgosCards
         */
        argosCardsCreate: (params = {}) => this.request({
            path: `/Exports/ArgosCards`,
            method: "POST",
            format: "json",
            ...params,
        }),
    };
    fingerprints = {
        /**
     * No description
     *
     * @tags Fingerprints
     * @name FingerprintsList
     * @summary Returns fingerprints. If lastRowVersion is set - all fingerprints that have
    creator row version (also softDeleted M:WorkTimeService.Api.Controllers.FingerprintsController.Delete(System.Int32)) are returned. Otherwise all active
    fingerprints are returned
     * @request GET:/Fingerprints
     */
        fingerprintsList: (query, params = {}) => this.request({
            path: `/Fingerprints`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Fingerprints
     * @name FingerprintsCreate
     * @summary Sets new fingerprints for user. If there are existing
    fingerprints for user in database - these are removed and
    new ones are inserted. If there is no existing ones new ones are
    inserted.
     * @request POST:/Fingerprints
     */
        fingerprintsCreate: (data, params = {}) => this.request({
            path: `/Fingerprints`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Fingerprints
         * @name FingerprintsDelete
         * @summary Soft deletes user fingerprints
         * @request DELETE:/Fingerprints
         */
        fingerprintsDelete: (query, params = {}) => this.request({
            path: `/Fingerprints`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    formFilters = {
        /**
         * No description
         *
         * @tags FormFilters
         * @name FormFiltersCreate
         * @summary Sets new form filters to database
         * @request POST:/FormFilters
         */
        formFiltersCreate: (data, params = {}) => this.request({
            path: `/FormFilters`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags FormFilters
         * @name FormFiltersUpdate
         * @summary Updates form filters to database
         * @request PUT:/FormFilters
         */
        formFiltersUpdate: (data, params = {}) => this.request({
            path: `/FormFilters`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags FormFilters
         * @name FormFiltersList
         * @summary Gets form filters to database
         * @request GET:/FormFilters
         */
        formFiltersList: (query, params = {}) => this.request({
            path: `/FormFilters`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags FormFilters
         * @name FormFiltersDelete
         * @summary Deletes form filters
         * @request DELETE:/FormFilters
         */
        formFiltersDelete: (query, params = {}) => this.request({
            path: `/FormFilters`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    graphs = {
        /**
         * No description
         *
         * @tags Graphs
         * @name GraphsList
         * @summary Gets all graphs by device.
         * @request GET:/Graphs
         */
        graphsList: (query, params = {}) => this.request({
            path: `/Graphs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Graphs
         * @name GraphsUpdate
         * @summary Update graphs main configuration
         * @request PUT:/Graphs
         */
        graphsUpdate: (query, data, params = {}) => this.request({
            path: `/Graphs`,
            method: "PUT",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Graphs
         * @name LinesCreate
         * @summary Insert new graph line to the graph
         * @request POST:/Graphs/Lines
         */
        linesCreate: (data, params = {}) => this.request({
            path: `/Graphs/Lines`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Graphs
         * @name LinesUpdate
         * @summary Update graph line on the graph
         * @request PUT:/Graphs/Lines
         */
        linesUpdate: (data, params = {}) => this.request({
            path: `/Graphs/Lines`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Graphs
         * @name LinesDelete
         * @summary Deletes line from graph
         * @request DELETE:/Graphs/Lines
         */
        linesDelete: (query, params = {}) => this.request({
            path: `/Graphs/Lines`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    identityUserCompanies = {
        /**
         * No description
         *
         * @tags IdentityUserCompanies
         * @name IdentityUserCompaniesList
         * @summary Get user companies
         * @request GET:/IdentityUserCompanies
         */
        identityUserCompaniesList: (query, params = {}) => this.request({
            path: `/IdentityUserCompanies`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags IdentityUserCompanies
         * @name IdentityUserCompaniesCreate
         * @summary Set user company
         * @request POST:/IdentityUserCompanies
         */
        identityUserCompaniesCreate: (data, params = {}) => this.request({
            path: `/IdentityUserCompanies`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags IdentityUserCompanies
         * @name IdentityUserCompaniesDelete
         * @summary Update user company
         * @request DELETE:/IdentityUserCompanies
         */
        identityUserCompaniesDelete: (query, params = {}) => this.request({
            path: `/IdentityUserCompanies`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    imports = {
        /**
         * No description
         *
         * @tags Imports
         * @name UsersList
         * @summary Imports users from external source
         * @request GET:/Imports/Users
         */
        usersList: (query, params = {}) => this.request({
            path: `/Imports/Users`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Imports
     * @name UpdateUsersList
     * @summary Update user(s) from external source - one of the parameters, either departmentIds or userIds has to have value
    otherwise error is returned.
     * @request GET:/Imports/UpdateUsers
     */
        updateUsersList: (query, params = {}) => this.request({
            path: `/Imports/UpdateUsers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name AbsencesList
         * @summary Imports absences from external source
         * @request GET:/Imports/Absences
         */
        absencesList: (query, params = {}) => this.request({
            path: `/Imports/Absences`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ImportEventsList
         * @summary Import external events to database.
         * @request GET:/Imports/ImportEvents
         */
        importEventsList: (query, params = {}) => this.request({
            path: `/Imports/ImportEvents`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name LoadUserExcelCreate
         * @summary Imports users from external source
         * @request POST:/Imports/LoadUserExcel
         */
        loadUserExcelCreate: (data, params = {}) => this.request({
            path: `/Imports/LoadUserExcel`,
            method: "POST",
            body: data,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name LoadContractExcelCreate
         * @summary Imports users contracts from external source
         * @request POST:/Imports/LoadContractExcel
         */
        loadContractExcelCreate: (data, params = {}) => this.request({
            path: `/Imports/LoadContractExcel`,
            method: "POST",
            body: data,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name StoreUserExcelCreate
         * @summary Imports users from external source
         * @request POST:/Imports/StoreUserExcel
         */
        storeUserExcelCreate: (data, params = {}) => this.request({
            path: `/Imports/StoreUserExcel`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name StoreContractExcelCreate
         * @summary Stores imported contracts from cache
         * @request POST:/Imports/StoreContractExcel
         */
        storeContractExcelCreate: (data, params = {}) => this.request({
            path: `/Imports/StoreContractExcel`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ImportUsersCreate
         * @summary Imports users array from external source
         * @request POST:/Imports/ImportUsers
         */
        importUsersCreate: (data, params = {}) => this.request({
            path: `/Imports/ImportUsers`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ImportContractsCreate
         * @summary Imports users array from external source
         * @request POST:/Imports/ImportContracts
         */
        importContractsCreate: (data, params = {}) => this.request({
            path: `/Imports/ImportContracts`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ImportCardTypesCreate
         * @summary Imports card types array from external source
         * @request POST:/Imports/ImportCardTypes
         */
        importCardTypesCreate: (data, params = {}) => this.request({
            path: `/Imports/ImportCardTypes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ImportCardsCreate
         * @summary Imports cards array from external source
         * @request POST:/Imports/ImportCards
         */
        importCardsCreate: (data, params = {}) => this.request({
            path: `/Imports/ImportCards`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    jobDepartments = {
        /**
         * No description
         *
         * @tags JobDepartments
         * @name JobDepartmentsDelete
         * @summary Delete job from a Department
         * @request DELETE:/JobDepartments
         */
        jobDepartmentsDelete: (query, params = {}) => this.request({
            path: `/JobDepartments`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobDepartments
         * @name JobDepartmentsCreate
         * @summary Insert new department into database and return inserted departmentId
         * @request POST:/JobDepartments
         */
        jobDepartmentsCreate: (data, params = {}) => this.request({
            path: `/JobDepartments`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobDepartments
         * @name MultipleCreate
         * @summary Sets multiple jobs to multiple departments associations.
         * @request POST:/JobDepartments/Multiple
         */
        multipleCreate: (data, params = {}) => this.request({
            path: `/JobDepartments/Multiple`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobDepartments
         * @name MultipleDelete
         * @summary Delete jobs from departments
         * @request DELETE:/JobDepartments/Multiple
         */
        multipleDelete: (query, params = {}) => this.request({
            path: `/JobDepartments/Multiple`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    jobEvents = {
        /**
         * No description
         *
         * @tags JobEvents
         * @name JobEventsCreate
         * @summary Adds JobEvent
         * @request POST:/JobEvents
         */
        jobEventsCreate: (data, params = {}) => this.request({
            path: `/JobEvents`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobEvents
         * @name ArgosEventCreate
         * @summary Adds argos event
         * @request POST:/JobEvents/ArgosEvent
         */
        argosEventCreate: (data, params = {}) => this.request({
            path: `/JobEvents/ArgosEvent`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobEvents
         * @name ArgosEventExtCreate
         * @summary Adds argos event
         * @request POST:/JobEvents/ArgosEventExt
         */
        argosEventExtCreate: (data, params = {}) => this.request({
            path: `/JobEvents/ArgosEventExt`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    jobProfiles = {
        /**
         * No description
         *
         * @tags JobProfiles
         * @name JobProfilesCreate
         * @summary Creates job profile object
         * @request POST:/JobProfiles
         */
        jobProfilesCreate: (data, params = {}) => this.request({
            path: `/JobProfiles`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobProfiles
         * @name JobProfilesList
         * @summary Returns job profiles
         * @request GET:/JobProfiles
         */
        jobProfilesList: (query, params = {}) => this.request({
            path: `/JobProfiles`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobProfiles
         * @name JobProfilesUpdate
         * @summary Updates job profile object
         * @request PUT:/JobProfiles
         */
        jobProfilesUpdate: (data, params = {}) => this.request({
            path: `/JobProfiles`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobProfiles
         * @name JobProfilesDelete
         * @summary Deletes job profile
         * @request DELETE:/JobProfiles
         */
        jobProfilesDelete: (query, params = {}) => this.request({
            path: `/JobProfiles`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    jobReplace = {
        /**
         * No description
         *
         * @tags JobReplace
         * @name JobReplaceList
         * @summary Returns job replace
         * @request GET:/JobReplace
         */
        jobReplaceList: (query, params = {}) => this.request({
            path: `/JobReplace`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobReplace
         * @name JobReplaceCreate
         * @summary Creates job replace object
         * @request POST:/JobReplace
         */
        jobReplaceCreate: (data, params = {}) => this.request({
            path: `/JobReplace`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobReplace
         * @name JobReplaceDelete
         * @summary Deletes job replace object
         * @request DELETE:/JobReplace
         */
        jobReplaceDelete: (query, params = {}) => this.request({
            path: `/JobReplace`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    jobs = {
        /**
         * No description
         *
         * @tags Jobs
         * @name JobsList
         * @summary Returns jobs.
         * @request GET:/Jobs
         */
        jobsList: (query, params = {}) => this.request({
            path: `/Jobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Jobs
         * @name JobsDelete
         * @summary Soft deletes job object
         * @request DELETE:/Jobs
         */
        jobsDelete: (query, params = {}) => this.request({
            path: `/Jobs`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Jobs
         * @name JobsCreate
         * @summary Adds new job object
         * @request POST:/Jobs
         */
        jobsCreate: (query, data, params = {}) => this.request({
            path: `/Jobs`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Jobs
         * @name JobsUpdate
         * @summary Updates job object
         * @request PUT:/Jobs
         */
        jobsUpdate: (data, params = {}) => this.request({
            path: `/Jobs`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Jobs
         * @name BasicList
         * @summary Returns collection of jobs objects that contain only basic information
         * @request GET:/Jobs/Basic
         */
        basicList: (query, params = {}) => this.request({
            path: `/Jobs/Basic`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Jobs
         * @name ConditionalDeleteDelete
         * @summary Conditional delete of job object
         * @request DELETE:/Jobs/ConditionalDelete
         */
        conditionalDeleteDelete: (query, params = {}) => this.request({
            path: `/Jobs/ConditionalDelete`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    jobSwaps = {
        /**
         * No description
         *
         * @tags JobSwaps
         * @name JobSwapsList
         * @summary Returns job swaps
         * @request GET:/JobSwaps
         */
        jobSwapsList: (query, params = {}) => this.request({
            path: `/JobSwaps`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobSwaps
         * @name JobSwapsCreate
         * @summary Creates job swap object
         * @request POST:/JobSwaps
         */
        jobSwapsCreate: (data, params = {}) => this.request({
            path: `/JobSwaps`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobSwaps
         * @name JobSwapsDelete
         * @summary Deletes job swap object
         * @request DELETE:/JobSwaps
         */
        jobSwapsDelete: (query, params = {}) => this.request({
            path: `/JobSwaps`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    jobUser = {
        /**
         * No description
         *
         * @tags JobUser
         * @name JobUserCreate
         * @summary Sets new job user association
         * @request POST:/JobUser
         */
        jobUserCreate: (data, params = {}) => this.request({
            path: `/JobUser`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUser
         * @name JobUserDelete
         * @summary Deletes job user association
         * @request DELETE:/JobUser
         */
        jobUserDelete: (query, params = {}) => this.request({
            path: `/JobUser`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUser
         * @name JobUserList
         * @summary Get job user associations list
         * @request GET:/JobUser
         */
        jobUserList: (query, params = {}) => this.request({
            path: `/JobUser`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUser
         * @name JobUserUpdate
         * @summary Updates job user association
         * @request PUT:/JobUser
         */
        jobUserUpdate: (data, params = {}) => this.request({
            path: `/JobUser`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUser
         * @name MultipleCreate
         * @summary Sets multiple user multiple jobs associations.
         * @request POST:/JobUser/Multiple
         */
        multipleCreate: (data, params = {}) => this.request({
            path: `/JobUser/Multiple`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags JobUser
         * @name MultipleDelete
         * @summary Delete jobs from users
         * @request DELETE:/JobUser/Multiple
         */
        multipleDelete: (query, params = {}) => this.request({
            path: `/JobUser/Multiple`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    lawParagraphConfs = {
        /**
         * No description
         *
         * @tags LawParagraphConfs
         * @name LawParagraphConfsList
         * @summary Get law paragraph configuration values
         * @request GET:/LawParagraphConfs
         */
        lawParagraphConfsList: (query, params = {}) => this.request({
            path: `/LawParagraphConfs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LawParagraphConfs
         * @name LawParagraphConfsCreate
         * @summary Insert new law paragraph configuration
         * @request POST:/LawParagraphConfs
         */
        lawParagraphConfsCreate: (data, params = {}) => this.request({
            path: `/LawParagraphConfs`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LawParagraphConfs
         * @name LawParagraphConfsUpdate
         * @summary Update law paragraph configuration
         * @request PUT:/LawParagraphConfs
         */
        lawParagraphConfsUpdate: (data, params = {}) => this.request({
            path: `/LawParagraphConfs`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LawParagraphConfs
         * @name LawParagraphConfsDelete
         * @summary Delete law paragraph configuration
         * @request DELETE:/LawParagraphConfs
         */
        lawParagraphConfsDelete: (query, params = {}) => this.request({
            path: `/LawParagraphConfs`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    lawParagraphs = {
        /**
         * No description
         *
         * @tags LawParagraphs
         * @name LawParagraphsList
         * @summary Returns list of available law paragraphs
         * @request GET:/LawParagraphs
         */
        lawParagraphsList: (query, params = {}) => this.request({
            path: `/LawParagraphs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    laws = {
        /**
         * No description
         *
         * @tags Laws
         * @name LawsList
         * @summary Returns list of available law structures
         * @request GET:/Laws
         */
        lawsList: (query, params = {}) => this.request({
            path: `/Laws`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    loggedInUser = {
        /**
         * No description
         *
         * @tags LoggedInUser
         * @name LoggedInUserList
         * @summary Gets logged in user information
         * @request GET:/LoggedInUser
         */
        loggedInUserList: (params = {}) => this.request({
            path: `/LoggedInUser`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags LoggedInUser
         * @name LoggedInUserUpdate
         * @summary Gets logged in user information
         * @request PUT:/LoggedInUser
         */
        loggedInUserUpdate: (query, params = {}) => this.request({
            path: `/LoggedInUser`,
            method: "PUT",
            query: query,
            format: "json",
            ...params,
        }),
    };
    machineTimes = {
        /**
         * @description Record is deemed faulty if user, job, wcc or mo type is not matched in system. In return structure it is shown with null object Id e.g User->Id = null
         *
         * @tags MachineTimes
         * @name MachineTimesList
         * @summary Gets machine times and counts total time and quantities by units.
         * @request GET:/MachineTimes
         */
        machineTimesList: (query, params = {}) => this.request({
            path: `/MachineTimes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags MachineTimes
         * @name MachineTimesCreate
         * @summary Sets new machine times
         * @request POST:/MachineTimes
         */
        machineTimesCreate: (data, params = {}) => this.request({
            path: `/MachineTimes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Record is deemed faulty if user, job, wcc or mo type is not matched in system. In return structure it is shown with null object Id e.g User->Id = null
         *
         * @tags MachineTimes
         * @name MachineTimesExcelList
         * @summary Gets machinetimes and counts total time and quantities by units.
         * @request GET:/MachineTimes/MachineTimesExcel
         */
        machineTimesExcelList: (query, params = {}) => this.request({
            path: `/MachineTimes/MachineTimesExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    manufacturingOrderTypes = {
        /**
         * No description
         *
         * @tags ManufacturingOrderTypes
         * @name ManufacturingOrderTypesList
         * @summary Gets manufacturing order types from database
         * @request GET:/ManufacturingOrderTypes
         */
        manufacturingOrderTypesList: (query, params = {}) => this.request({
            path: `/ManufacturingOrderTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    mu4 = {
        /**
         * No description
         *
         * @tags MU4
         * @name UserRightsList
         * @summary Gets logged in user information
         * @request GET:/MU4/userRights
         */
        userRightsList: (params = {}) => this.request({
            path: `/MU4/userRights`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    passingGroups = {
        /**
         * No description
         *
         * @tags PassingGroups
         * @name PassingGroupsList
         * @summary Gets passing groups from database
         * @request GET:/PassingGroups
         */
        passingGroupsList: (params = {}) => this.request({
            path: `/PassingGroups`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    paymentCodes = {
        /**
         * No description
         *
         * @tags PaymentCodes
         * @name PaymentCodesList
         * @summary Returns payment codes
         * @request GET:/PaymentCodes
         */
        paymentCodesList: (query, params = {}) => this.request({
            path: `/PaymentCodes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PaymentCodes
         * @name PaymentCodesCreate
         * @summary Sets payment code
         * @request POST:/PaymentCodes
         */
        paymentCodesCreate: (data, params = {}) => this.request({
            path: `/PaymentCodes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PaymentCodes
         * @name PaymentCodesUpdate
         * @summary Updates payment code.
         * @request PUT:/PaymentCodes
         */
        paymentCodesUpdate: (data, params = {}) => this.request({
            path: `/PaymentCodes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PaymentCodes
         * @name PaymentCodesDelete
         * @summary Deletes payment code.
         * @request DELETE:/PaymentCodes
         */
        paymentCodesDelete: (query, params = {}) => this.request({
            path: `/PaymentCodes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    periodSurpluses = {
        /**
         * No description
         *
         * @tags PeriodSurpluses
         * @name PeriodSurplusesCreate
         * @summary Creates new period surplus association.
         * @request POST:/PeriodSurpluses
         */
        periodSurplusesCreate: (data, params = {}) => this.request({
            path: `/PeriodSurpluses`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PeriodSurpluses
         * @name PeriodSurplusesUpdate
         * @summary Updates period surplus association.
         * @request PUT:/PeriodSurpluses
         */
        periodSurplusesUpdate: (data, params = {}) => this.request({
            path: `/PeriodSurpluses`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    pilvepalk = {
        /**
         * No description
         *
         * @tags Pilvepalk
         * @name ExportWorkHoursCreate
         * @summary Export work hours from WTS to Pilvepalk
         * @request POST:/Pilvepalk/ExportWorkHours
         */
        exportWorkHoursCreate: (data, params = {}) => this.request({
            path: `/Pilvepalk/ExportWorkHours`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Pilvepalk
         * @name AbsencesList
         * @summary Query absences from Pilvepalk
         * @request GET:/Pilvepalk/Absences
         */
        absencesList: (query, params = {}) => this.request({
            path: `/Pilvepalk/Absences`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    plannerRequests = {
        /**
         * No description
         *
         * @tags PlannerRequests
         * @name PlannerRequestsCreate
         * @summary Sets new planner request to database
         * @request POST:/PlannerRequests
         */
        plannerRequestsCreate: (data, params = {}) => this.request({
            path: `/PlannerRequests`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequests
         * @name PlannerRequestsUpdate
         * @summary Updates planner request to database
         * @request PUT:/PlannerRequests
         */
        plannerRequestsUpdate: (data, params = {}) => this.request({
            path: `/PlannerRequests`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequests
         * @name PlannerRequestsList
         * @summary Gets planned requests from database
         * @request GET:/PlannerRequests
         */
        plannerRequestsList: (query, params = {}) => this.request({
            path: `/PlannerRequests`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequests
         * @name PlannerRequestsDelete
         * @summary Deletes planner requests
         * @request DELETE:/PlannerRequests
         */
        plannerRequestsDelete: (query, params = {}) => this.request({
            path: `/PlannerRequests`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequests
         * @name MultiUpdateUpdate
         * @summary Updates multiple planner requests
         * @request PUT:/PlannerRequests/MultiUpdate
         */
        multiUpdateUpdate: (data, params = {}) => this.request({
            path: `/PlannerRequests/MultiUpdate`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequests
         * @name SetConfirmationCreate
         * @summary Confirms/rejects or removes confirmation from planner requests
         * @request POST:/PlannerRequests/SetConfirmation
         */
        setConfirmationCreate: (data, params = {}) => this.request({
            path: `/PlannerRequests/SetConfirmation`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    plannerRequestTypes = {
        /**
         * No description
         *
         * @tags PlannerRequestTypes
         * @name PlannerRequestTypesCreate
         * @summary Sets new planner request type to database
         * @request POST:/PlannerRequestTypes
         */
        plannerRequestTypesCreate: (data, params = {}) => this.request({
            path: `/PlannerRequestTypes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequestTypes
         * @name PlannerRequestTypesUpdate
         * @summary Updates planner request type to database
         * @request PUT:/PlannerRequestTypes
         */
        plannerRequestTypesUpdate: (data, params = {}) => this.request({
            path: `/PlannerRequestTypes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequestTypes
         * @name PlannerRequestTypesList
         * @summary Gets planner request types from database
         * @request GET:/PlannerRequestTypes
         */
        plannerRequestTypesList: (query, params = {}) => this.request({
            path: `/PlannerRequestTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags PlannerRequestTypes
         * @name PlannerRequestTypesDelete
         * @summary Deletes planner request type
         * @request DELETE:/PlannerRequestTypes
         */
        plannerRequestTypesDelete: (query, params = {}) => this.request({
            path: `/PlannerRequestTypes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    professions = {
        /**
         * No description
         *
         * @tags Professions
         * @name ProfessionsList
         * @summary Returns professions
         * @request GET:/Professions
         */
        professionsList: (query, params = {}) => this.request({
            path: `/Professions`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Professions
         * @name ProfessionsCreate
         * @summary Add profession object
         * @request POST:/Professions
         */
        professionsCreate: (data, params = {}) => this.request({
            path: `/Professions`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Professions
         * @name ProfessionsUpdate
         * @summary Updates profession object
         * @request PUT:/Professions
         */
        professionsUpdate: (data, params = {}) => this.request({
            path: `/Professions`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Professions
         * @name ProfessionsDelete
         * @summary Deletes profession object
         * @request DELETE:/Professions
         */
        professionsDelete: (query, params = {}) => this.request({
            path: `/Professions`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    projectAssociations = {
        /**
         * No description
         *
         * @tags ProjectAssociations
         * @name ProjectAssociationsCreate
         * @summary Creates project associations objects.
         * @request POST:/ProjectAssociations
         */
        projectAssociationsCreate: (data, params = {}) => this.request({
            path: `/ProjectAssociations`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags ProjectAssociations
         * @name ProjectAssociationsDelete
         * @summary Deletes project associations
         * @request DELETE:/ProjectAssociations
         */
        projectAssociationsDelete: (query, params = {}) => this.request({
            path: `/ProjectAssociations`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    projects = {
        /**
         * No description
         *
         * @tags Projects
         * @name ProjectsCreate
         * @summary Creates new project
         * @request POST:/Projects
         */
        projectsCreate: (data, params = {}) => this.request({
            path: `/Projects`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Projects
         * @name ProjectsUpdate
         * @summary Update project data in database
         * @request PUT:/Projects
         */
        projectsUpdate: (data, params = {}) => this.request({
            path: `/Projects`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Projects
         * @name ProjectsList
         * @summary Get projects from database
         * @request GET:/Projects
         */
        projectsList: (query, params = {}) => this.request({
            path: `/Projects`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Projects
         * @name ProjectsDelete
         * @summary Set project as deleted.
         * @request DELETE:/Projects
         */
        projectsDelete: (query, params = {}) => this.request({
            path: `/Projects`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    recurringTypes = {
        /**
         * No description
         *
         * @tags RecurringTypes
         * @name RecurringTypesList
         * @summary Returns recurring types
         * @request GET:/RecurringTypes
         */
        recurringTypesList: (params = {}) => this.request({
            path: `/RecurringTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    reports = {
        /**
         * @description Only dates from period are used. End date is included.
         *
         * @tags Reports
         * @name WorkingHoursExportValuesList
         * @summary Returns working hours export values
         * @request GET:/Reports/WorkingHoursExportValues
         */
        workingHoursExportValuesList: (query, params = {}) => this.request({
            path: `/Reports/WorkingHoursExportValues`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name TotalWorkInPeriodList
         * @summary Returns total work in period grouped by user
         * @request GET:/Reports/TotalWorkInPeriod
         */
        totalWorkInPeriodList: (query, params = {}) => this.request({
            path: `/Reports/TotalWorkInPeriod`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name DepartmentsWorkTimesByJobsList
     * @summary Returns data about worktimes done in departments divided by jobs.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/DepartmentsWorkTimesByJobs
     */
        departmentsWorkTimesByJobsList: (query, params = {}) => this.request({
            path: `/Reports/DepartmentsWorkTimesByJobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name DepartmentsWorkTimesByJobsExcelList
     * @summary Returns excel report about worktimes done in departments divided by jobs.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/DepartmentsWorkTimesByJobsExcel
     */
        departmentsWorkTimesByJobsExcelList: (query, params = {}) => this.request({
            path: `/Reports/DepartmentsWorkTimesByJobsExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimeSummaryList
     * @summary Returns data about summary work time done for each user by month.
    One of the confirmed months or not confirmed months MUST be set.
     * @request GET:/Reports/WorkTimeSummary
     */
        workTimeSummaryList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimeSummary`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimeSummaryExcelExportList
     * @summary Returns excel report about summary work time done for each user by month.
    One of the confirmed months or not confirmed months MUST be set.
     * @request GET:/Reports/WorkTimeSummaryExcelExport
     */
        workTimeSummaryExcelExportList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimeSummaryExcelExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimeSummaryExcelExportV2List
     * @summary Returns excel report about summary work time done for each user by month.
    One of the confirmed months or not confirmed months MUST be set. Divides the user info into separate columns.
     * @request GET:/Reports/WorkTimeSummaryExcelExport-v2
     */
        workTimeSummaryExcelExportV2List: (query, params = {}) => this.request({
            path: `/Reports/WorkTimeSummaryExcelExport-v2`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimesInOtherDepartmentsList
     * @summary Returns data about worktimes done in other departments.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/WorkTimesInOtherDepartments
     */
        workTimesInOtherDepartmentsList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesInOtherDepartments`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimesInOtherDepartmentsExcelList
     * @summary Returns excel report about worktimes done in other departments.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/WorkTimesInOtherDepartmentsExcel
     */
        workTimesInOtherDepartmentsExcelList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesInOtherDepartmentsExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimesInPeriodByJobsList
     * @summary Returns data about worktimes done in other departments.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/WorkTimesInPeriodByJobs
     */
        workTimesInPeriodByJobsList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesInPeriodByJobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name WorkTimesInPeriodByJobsExcelList
     * @summary Returns data about worktimes done in other departments.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/WorkTimesInPeriodByJobsExcel
     */
        workTimesInPeriodByJobsExcelList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesInPeriodByJobsExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name SendReportsList
         * @summary Sends specified report(s) about user to user email.
         * @request GET:/Reports/SendReports
         */
        sendReportsList: (query, params = {}) => this.request({
            path: `/Reports/SendReports`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportList
         * @summary Main report
         * @request GET:/Reports/MainReport
         */
        mainReportList: (query, params = {}) => this.request({
            path: `/Reports/MainReport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportCsvExportList
         * @summary Returns csv report about confirmed users work hours by types.
         * @request GET:/Reports/MainReportCsvExport
         */
        mainReportCsvExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportCsvExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportCsvExport2List
         * @summary Returns csv v2 report about confirmed users work hours by types.
         * @request GET:/Reports/MainReportCsvExport2
         */
        mainReportCsvExport2List: (query, params = {}) => this.request({
            path: `/Reports/MainReportCsvExport2`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportTaaviCsvExportList
         * @summary Returns taavi csv report about users work hours by types.
         * @request GET:/Reports/MainReportTaaviCsvExport
         */
        mainReportTaaviCsvExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportTaaviCsvExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportPersonaCsvExportList
         * @summary Returns csv report about users work hours by types for Persona
         * @request GET:/Reports/MainReportPersonaCsvExport
         */
        mainReportPersonaCsvExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportPersonaCsvExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportMeritHoursCsvExportList
         * @summary Returns csv report with fields required for Merit Export about users work hours by types.
         * @request GET:/Reports/MainReportMeritHoursCsvExport
         */
        mainReportMeritHoursCsvExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportMeritHoursCsvExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportMeritLeavesCsvExportList
         * @summary Returns csv report with fields required for Merit Export user leaves export.
         * @request GET:/Reports/MainReportMeritLeavesCsvExport
         */
        mainReportMeritLeavesCsvExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportMeritLeavesCsvExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportDirectoExcelExportList
         * @summary Returns csv report with fields required for directo.
         * @request GET:/Reports/MainReportDirectoExcelExport
         */
        mainReportDirectoExcelExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportDirectoExcelExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportExcelExportList
         * @summary Returns csv report about confirmed users work hours by types.
         * @request GET:/Reports/MainReportExcelExport
         */
        mainReportExcelExportList: (query, params = {}) => this.request({
            path: `/Reports/MainReportExcelExport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name MainReportExcelExportV2List
         * @summary Returns csv report about confirmed users work hours by types. V2 separates users' info to multiple columns.
         * @request GET:/Reports/MainReportExcelExport-v2
         */
        mainReportExcelExportV2List: (query, params = {}) => this.request({
            path: `/Reports/MainReportExcelExport-v2`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name ProjectsByJobsList
         * @summary Projects report by jobs and departments
         * @request GET:/Reports/ProjectsByJobs
         */
        projectsByJobsList: (query, params = {}) => this.request({
            path: `/Reports/ProjectsByJobs`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags Reports
     * @name ProjectsWorkTimesByJobsExcelList
     * @summary Returns excel report about worktimes done in projects divided by jobs and departments.
    If periods endDate is greater than currentDateTime then currentDateTime value is used
    as a end dateTime for not ended jobs.
     * @request GET:/Reports/ProjectsWorkTimesByJobsExcel
     */
        projectsWorkTimesByJobsExcelList: (query, params = {}) => this.request({
            path: `/Reports/ProjectsWorkTimesByJobsExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name ByJobsInPeriodExcelList
         * @summary Get Excel report for planned job summary values separated by workshifts and into selected time lengths
         * @request GET:/Reports/ByJobsInPeriodExcel
         */
        byJobsInPeriodExcelList: (query, params = {}) => this.request({
            path: `/Reports/ByJobsInPeriodExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name WorkTimesInPeriodList
         * @summary Get report about registered events and how they fall into planned events, separated by user, job and planned workshifts
         * @request GET:/Reports/WorkTimesInPeriod
         */
        workTimesInPeriodList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesInPeriod`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name WorkTimesInPeriodExcelList
         * @summary Get Excel report about registered events and how they fall into planned events, separated by user, job and planned workshifts
         * @request GET:/Reports/WorkTimesInPeriodExcel
         */
        workTimesInPeriodExcelList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesInPeriodExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name WorkTimesByUsersList
         * @summary Get report about registered events by user
         * @request GET:/Reports/WorkTimesByUsers
         */
        workTimesByUsersList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesByUsers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name WorkTimesByDaysList
         * @summary Get report about registered events of user by day
         * @request GET:/Reports/WorkTimesByDays
         */
        workTimesByDaysList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesByDays`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name WorkTimesByUsersExcelList
         * @summary Get Excel report about registered events by users
         * @request GET:/Reports/WorkTimesByUsersExcel
         */
        workTimesByUsersExcelList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesByUsersExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name WorkTimesByDaysExcelList
         * @summary Get Excel report about registered events of user by day
         * @request GET:/Reports/WorkTimesByDaysExcel
         */
        workTimesByDaysExcelList: (query, params = {}) => this.request({
            path: `/Reports/WorkTimesByDaysExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name DetailedSummaryReportList
         * @summary Detailed summary report
         * @request GET:/Reports/DetailedSummaryReport
         */
        detailedSummaryReportList: (query, params = {}) => this.request({
            path: `/Reports/DetailedSummaryReport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name DetailedSummaryReportExcelList
         * @summary Returns Excel report for DetailedSummaryReport
         * @request GET:/Reports/DetailedSummaryReportExcel
         */
        detailedSummaryReportExcelList: (query, params = {}) => this.request({
            path: `/Reports/DetailedSummaryReportExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name OffScheduleReportList
         * @summary Off Schedule Report - event based, separated into different events on the date change
         * @request GET:/Reports/OffScheduleReport
         */
        offScheduleReportList: (query, params = {}) => this.request({
            path: `/Reports/OffScheduleReport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name OffScheduleReportExcelList
         * @summary Returns Excel report for OffScheduleReport
         * @request GET:/Reports/OffScheduleReportExcel
         */
        offScheduleReportExcelList: (query, params = {}) => this.request({
            path: `/Reports/OffScheduleReportExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Reports
         * @name OverHoursFromMainReportList
         * @summary Get over hours value form main report - when user is not confirmed
         * @request GET:/Reports/OverHoursFromMainReport
         */
        overHoursFromMainReportList: (query, params = {}) => this.request({
            path: `/Reports/OverHoursFromMainReport`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    requests = {
        /**
         * No description
         *
         * @tags Requests
         * @name RequestsList
         * @summary Gets requests from database
         * @request GET:/Requests
         */
        requestsList: (query, params = {}) => this.request({
            path: `/Requests`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Requests
         * @name RequestWithLinesCreate
         * @summary Sets new request and request lines to database
         * @request POST:/Requests/RequestWithLines
         */
        requestWithLinesCreate: (data, params = {}) => this.request({
            path: `/Requests/RequestWithLines`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Requests
         * @name RequestWithLinesUpdate
         * @summary Updates request and request lines to database
         * @request PUT:/Requests/RequestWithLines
         */
        requestWithLinesUpdate: (data, params = {}) => this.request({
            path: `/Requests/RequestWithLines`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Requests
         * @name RequestWithLinesDelete
         * @summary Deletes request and attached request lines
         * @request DELETE:/Requests/RequestWithLines
         */
        requestWithLinesDelete: (query, params = {}) => this.request({
            path: `/Requests/RequestWithLines`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    requestStatus = {
        /**
         * No description
         *
         * @tags RequestStatus
         * @name RequestStatusCreate
         * @summary Sets new request status to database
         * @request POST:/RequestStatus
         */
        requestStatusCreate: (data, params = {}) => this.request({
            path: `/RequestStatus`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RequestStatus
         * @name UpdateRequestStatusUpdate
         * @summary Update request status in database
         * @request PUT:/RequestStatus/UpdateRequestStatus
         */
        updateRequestStatusUpdate: (data, params = {}) => this.request({
            path: `/RequestStatus/UpdateRequestStatus`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RequestStatus
         * @name UpdateRequestLineStatusUpdate
         * @summary Update request line status in database
         * @request PUT:/RequestStatus/UpdateRequestLineStatus
         */
        updateRequestLineStatusUpdate: (data, params = {}) => this.request({
            path: `/RequestStatus/UpdateRequestLineStatus`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    requestSubTypes = {
        /**
         * No description
         *
         * @tags RequestSubTypes
         * @name RequestSubTypesCreate
         * @summary Sets new request sub type in database
         * @request POST:/RequestSubTypes
         */
        requestSubTypesCreate: (data, params = {}) => this.request({
            path: `/RequestSubTypes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RequestSubTypes
         * @name RequestSubTypesUpdate
         * @summary Updates request sub type in database
         * @request PUT:/RequestSubTypes
         */
        requestSubTypesUpdate: (data, params = {}) => this.request({
            path: `/RequestSubTypes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RequestSubTypes
         * @name RequestSubTypesList
         * @summary Gets request sub types from database
         * @request GET:/RequestSubTypes
         */
        requestSubTypesList: (query, params = {}) => this.request({
            path: `/RequestSubTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RequestSubTypes
         * @name RequestSubTypesDelete
         * @summary Sets Request sub type as deleted.
         * @request DELETE:/RequestSubTypes
         */
        requestSubTypesDelete: (query, params = {}) => this.request({
            path: `/RequestSubTypes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    requestTypes = {
        /**
         * No description
         *
         * @tags RequestTypes
         * @name RequestTypesList
         * @summary Gets request types from database
         * @request GET:/RequestTypes
         */
        requestTypesList: (query, params = {}) => this.request({
            path: `/RequestTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    restrictedClients = {
        /**
         * No description
         *
         * @tags RestrictedClients
         * @name RestrictedClientsCreate
         * @summary Sets new restricted client to database and check service
         * @request POST:/RestrictedClients
         */
        restrictedClientsCreate: (data, params = {}) => this.request({
            path: `/RestrictedClients`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RestrictedClients
         * @name RestrictedClientsUpdate
         * @summary Updates restricted client in database and check service
         * @request PUT:/RestrictedClients
         */
        restrictedClientsUpdate: (data, params = {}) => this.request({
            path: `/RestrictedClients`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RestrictedClients
         * @name RestrictedClientsList
         * @summary Gets restricted clients from database
         * @request GET:/RestrictedClients
         */
        restrictedClientsList: (query, params = {}) => this.request({
            path: `/RestrictedClients`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags RestrictedClients
         * @name RestrictedClientsDelete
         * @summary Deletes restricted client
         * @request DELETE:/RestrictedClients
         */
        restrictedClientsDelete: (query, params = {}) => this.request({
            path: `/RestrictedClients`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    rights = {
        /**
         * No description
         *
         * @tags Rights
         * @name RightsList
         * @summary Returns all defined rights by type and default values
         * @request GET:/Rights
         */
        rightsList: (params = {}) => this.request({
            path: `/Rights`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    servers = {
        /**
         * No description
         *
         * @tags Servers
         * @name ServersCreate
         * @summary Sets new server to database
         * @request POST:/Servers
         */
        serversCreate: (data, params = {}) => this.request({
            path: `/Servers`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Servers
         * @name ServersUpdate
         * @summary Updates server to database
         * @request PUT:/Servers
         */
        serversUpdate: (data, params = {}) => this.request({
            path: `/Servers`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Servers
         * @name ServersList
         * @summary Gets servers from database
         * @request GET:/Servers
         */
        serversList: (query, params = {}) => this.request({
            path: `/Servers`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Servers
         * @name ServersDelete
         * @summary Deletes server
         * @request DELETE:/Servers
         */
        serversDelete: (query, params = {}) => this.request({
            path: `/Servers`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    skills = {
        /**
         * No description
         *
         * @tags Skills
         * @name SkillsCreate
         * @summary Creates new skill
         * @request POST:/Skills
         */
        skillsCreate: (data, params = {}) => this.request({
            path: `/Skills`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Skills
         * @name SkillsUpdate
         * @summary Update skill data in database
         * @request PUT:/Skills
         */
        skillsUpdate: (data, params = {}) => this.request({
            path: `/Skills`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Skills
         * @name SkillsList
         * @summary Get skills from database
         * @request GET:/Skills
         */
        skillsList: (query, params = {}) => this.request({
            path: `/Skills`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Skills
         * @name SkillsDelete
         * @summary Delete skill.
         * @request DELETE:/Skills
         */
        skillsDelete: (query, params = {}) => this.request({
            path: `/Skills`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    skillScaleLevels = {
        /**
         * No description
         *
         * @tags SkillScaleLevels
         * @name SkillScaleLevelsCreate
         * @summary Creates new skill scale level
         * @request POST:/SkillScaleLevels
         */
        skillScaleLevelsCreate: (data, params = {}) => this.request({
            path: `/SkillScaleLevels`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScaleLevels
         * @name SkillScaleLevelsUpdate
         * @summary Update skill scale level data in database
         * @request PUT:/SkillScaleLevels
         */
        skillScaleLevelsUpdate: (data, params = {}) => this.request({
            path: `/SkillScaleLevels`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScaleLevels
         * @name SkillScaleLevelsList
         * @summary Get skill scale levels  from database
         * @request GET:/SkillScaleLevels
         */
        skillScaleLevelsList: (query, params = {}) => this.request({
            path: `/SkillScaleLevels`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScaleLevels
         * @name SkillScaleLevelsDelete
         * @summary Set skill scale level is deleted.
         * @request DELETE:/SkillScaleLevels
         */
        skillScaleLevelsDelete: (query, params = {}) => this.request({
            path: `/SkillScaleLevels`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    skillScales = {
        /**
         * No description
         *
         * @tags SkillScales
         * @name SkillScalesCreate
         * @summary Creates new skill scale
         * @request POST:/SkillScales
         */
        skillScalesCreate: (data, params = {}) => this.request({
            path: `/SkillScales`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScales
         * @name SkillScalesUpdate
         * @summary Update skill scale data in database
         * @request PUT:/SkillScales
         */
        skillScalesUpdate: (data, params = {}) => this.request({
            path: `/SkillScales`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScales
         * @name SkillScalesList
         * @summary Get skill scales from database
         * @request GET:/SkillScales
         */
        skillScalesList: (query, params = {}) => this.request({
            path: `/SkillScales`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SkillScales
         * @name SkillScalesDelete
         * @summary Delete skill scale and its levels.
         * @request DELETE:/SkillScales
         */
        skillScalesDelete: (query, params = {}) => this.request({
            path: `/SkillScales`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    slipTimeAssociations = {
        /**
         * No description
         *
         * @tags SlipTimeAssociations
         * @name SlipTimeAssociationsList
         * @summary Returns slip time associations
         * @request GET:/SlipTimeAssociations
         */
        slipTimeAssociationsList: (query, params = {}) => this.request({
            path: `/SlipTimeAssociations`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SlipTimeAssociations
         * @name SlipTimeAssociationsCreate
         * @summary Creates slip time association object.
         * @request POST:/SlipTimeAssociations
         */
        slipTimeAssociationsCreate: (data, params = {}) => this.request({
            path: `/SlipTimeAssociations`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SlipTimeAssociations
         * @name SlipTimeAssociationsDelete
         * @summary Deletes slip time association object
         * @request DELETE:/SlipTimeAssociations
         */
        slipTimeAssociationsDelete: (query, params = {}) => this.request({
            path: `/SlipTimeAssociations`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    slipTimes = {
        /**
         * No description
         *
         * @tags SlipTimes
         * @name SlipTimesList
         * @summary Returns slip times
         * @request GET:/SlipTimes
         */
        slipTimesList: (query, params = {}) => this.request({
            path: `/SlipTimes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SlipTimes
         * @name SlipTimesCreate
         * @summary Creates slip time object
         * @request POST:/SlipTimes
         */
        slipTimesCreate: (data, params = {}) => this.request({
            path: `/SlipTimes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SlipTimes
         * @name SlipTimesUpdate
         * @summary Updates slip time object
         * @request PUT:/SlipTimes
         */
        slipTimesUpdate: (data, params = {}) => this.request({
            path: `/SlipTimes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags SlipTimes
         * @name SlipTimesDelete
         * @summary Deletes slip time object
         * @request DELETE:/SlipTimes
         */
        slipTimesDelete: (query, params = {}) => this.request({
            path: `/SlipTimes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    timeRateSystems = {
        /**
         * No description
         *
         * @tags TimeRateSystems
         * @name TimeRateSystemsList
         * @summary Returns time rate systems. Output can be filtered by ids.
         * @request GET:/TimeRateSystems
         */
        timeRateSystemsList: (query, params = {}) => this.request({
            path: `/TimeRateSystems`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    trackingEvents = {
        /**
         * No description
         *
         * @tags TrackingEvents
         * @name TrackingEventsList
         * @summary Gets Argos events from database
         * @request GET:/TrackingEvents
         */
        trackingEventsList: (query, params = {}) => this.request({
            path: `/TrackingEvents`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingEvents
         * @name TypesList
         * @summary Gets Argos event types from database
         * @request GET:/TrackingEvents/Types
         */
        typesList: (query, params = {}) => this.request({
            path: `/TrackingEvents/Types`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    trackingFloorPlans = {
        /**
         * No description
         *
         * @tags TrackingFloorPlans
         * @name TrackingFloorPlansCreate
         * @summary Sets new floor plan to database
         * @request POST:/TrackingFloorPlans
         */
        trackingFloorPlansCreate: (data, params = {}) => this.request({
            path: `/TrackingFloorPlans`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingFloorPlans
         * @name TrackingFloorPlansUpdate
         * @summary Update floor in database
         * @request PUT:/TrackingFloorPlans
         */
        trackingFloorPlansUpdate: (data, params = {}) => this.request({
            path: `/TrackingFloorPlans`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingFloorPlans
         * @name TrackingFloorPlansList
         * @summary Gets floor plans from database
         * @request GET:/TrackingFloorPlans
         */
        trackingFloorPlansList: (query, params = {}) => this.request({
            path: `/TrackingFloorPlans`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingFloorPlans
         * @name TrackingFloorPlansDelete
         * @summary Deletes floor plan
         * @request DELETE:/TrackingFloorPlans
         */
        trackingFloorPlansDelete: (query, params = {}) => this.request({
            path: `/TrackingFloorPlans`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingFloorPlans
         * @name CompanyList
         * @summary Gets company data with floor plans from database
         * @request GET:/TrackingFloorPlans/Company
         */
        companyList: (query, params = {}) => this.request({
            path: `/TrackingFloorPlans/Company`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    trackingLockData = {
        /**
         * No description
         *
         * @tags TrackingLockData
         * @name TrackingLockDataCreate
         * @summary Sets new lock data to database
         * @request POST:/TrackingLockData
         */
        trackingLockDataCreate: (data, params = {}) => this.request({
            path: `/TrackingLockData`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingLockData
         * @name TrackingLockDataUpdate
         * @summary Update lock data in database
         * @request PUT:/TrackingLockData
         */
        trackingLockDataUpdate: (data, params = {}) => this.request({
            path: `/TrackingLockData`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingLockData
         * @name TrackingLockDataList
         * @summary Gets lock data from database
         * @request GET:/TrackingLockData
         */
        trackingLockDataList: (query, params = {}) => this.request({
            path: `/TrackingLockData`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingLockData
         * @name TrackingLockDataDelete
         * @summary Deletes lock data
         * @request DELETE:/TrackingLockData
         */
        trackingLockDataDelete: (query, params = {}) => this.request({
            path: `/TrackingLockData`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    trackingRoomData = {
        /**
         * No description
         *
         * @tags TrackingRoomData
         * @name TrackingRoomDataCreate
         * @summary Sets new room to database
         * @request POST:/TrackingRoomData
         */
        trackingRoomDataCreate: (data, params = {}) => this.request({
            path: `/TrackingRoomData`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingRoomData
         * @name TrackingRoomDataUpdate
         * @summary Update room data in database
         * @request PUT:/TrackingRoomData
         */
        trackingRoomDataUpdate: (data, params = {}) => this.request({
            path: `/TrackingRoomData`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingRoomData
         * @name TrackingRoomDataList
         * @summary Gets room data from database
         * @request GET:/TrackingRoomData
         */
        trackingRoomDataList: (query, params = {}) => this.request({
            path: `/TrackingRoomData`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingRoomData
         * @name TrackingRoomDataDelete
         * @summary Deletes room data
         * @request DELETE:/TrackingRoomData
         */
        trackingRoomDataDelete: (query, params = {}) => this.request({
            path: `/TrackingRoomData`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags TrackingRoomData
         * @name SetAsEmptyList
         * @summary Deletes room data
         * @request GET:/TrackingRoomData/SetAsEmpty
         */
        setAsEmptyList: (query, params = {}) => this.request({
            path: `/TrackingRoomData/SetAsEmpty`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    translations = {
        /**
     * No description
     *
     * @tags Translations
     * @name TranslationsList
     * @summary Returns translations. If no base is defined all translations are returned.
    If no languages are defined - translations in all languages are returned
     * @request GET:/Translations
     */
        translationsList: (query, params = {}) => this.request({
            path: `/Translations`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    userContracts = {
        /**
         * No description
         *
         * @tags UserContracts
         * @name UserContractsList
         * @summary Returns user contracts
         * @request GET:/UserContracts
         */
        userContractsList: (query, params = {}) => this.request({
            path: `/UserContracts`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserContracts
         * @name UserContractsCreate
         * @summary Creates user contract
         * @request POST:/UserContracts
         */
        userContractsCreate: (data, params = {}) => this.request({
            path: `/UserContracts`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserContracts
         * @name UserContractsUpdate
         * @summary Updates user contract
         * @request PUT:/UserContracts
         */
        userContractsUpdate: (data, params = {}) => this.request({
            path: `/UserContracts`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserContracts
         * @name WithRowsCreate
         * @summary Creates user contract with rows
         * @request POST:/UserContracts/WithRows
         */
        withRowsCreate: (data, params = {}) => this.request({
            path: `/UserContracts/WithRows`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserContracts
         * @name WithRowsUpdate
         * @summary Updates user contract with rows
         * @request PUT:/UserContracts/WithRows/{Id}
         */
        withRowsUpdate: (id, data, params = {}) => this.request({
            path: `/UserContracts/WithRows/${id}`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserContracts
         * @name MultipleUpdate
         * @summary Updates multiple users contracts
         * @request PUT:/UserContracts/Multiple
         */
        multipleUpdate: (data, params = {}) => this.request({
            path: `/UserContracts/Multiple`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    userGroupRights = {
        /**
     * No description
     *
     * @tags UserGroupRights
     * @name UserGroupRightsList
     * @summary Returns user groups with their rights and associated jobs. If the user group doesn't have any rights only the name
    and id of the user group is returned with empty rights collection.
     * @request GET:/UserGroupRights
     */
        userGroupRightsList: (query, params = {}) => this.request({
            path: `/UserGroupRights`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserGroupRights
         * @name UserGroupRightsUpdate
         * @summary Adds or Updates user group and its rights and associated jobs
         * @request PUT:/UserGroupRights
         */
        userGroupRightsUpdate: (data, params = {}) => this.request({
            path: `/UserGroupRights`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserGroupRights
         * @name UserGroupRightsCreate
         * @summary Adds or Updates user group and its rights and associated jobs
         * @request POST:/UserGroupRights
         */
        userGroupRightsCreate: (data, params = {}) => this.request({
            path: `/UserGroupRights`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserGroupRights
         * @name ToExcelList
         * @summary Get all user groups in excel format
         * @request GET:/UserGroupRights/ToExcel
         */
        toExcelList: (query, params = {}) => this.request({
            path: `/UserGroupRights/ToExcel`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    userGroups = {
        /**
         * @description This operation can be done only when group doesn't contain any active members
         *
         * @tags UserGroups
         * @name UserGroupsDelete
         * @summary Delete user group and associated jobs.
         * @request DELETE:/UserGroups
         */
        userGroupsDelete: (query, params = {}) => this.request({
            path: `/UserGroups`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    userPlanningConfirmations = {
        /**
         * No description
         *
         * @tags UserPlanningConfirmations
         * @name MultipleCreate
         * @summary Sets confirmations to multiple users
         * @request POST:/UserPlanningConfirmations/Multiple
         */
        multipleCreate: (data, params = {}) => this.request({
            path: `/UserPlanningConfirmations/Multiple`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserPlanningConfirmations
         * @name UserPlanningConfirmationsList
         * @summary Gets user planner confirmations
         * @request GET:/UserPlanningConfirmations
         */
        userPlanningConfirmationsList: (query, params = {}) => this.request({
            path: `/UserPlanningConfirmations`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    users = {
        /**
         * No description
         *
         * @tags Users
         * @name UsersList
         * @summary Returns users. Output can be filtered by by users, jobs and departments.
         * @request GET:/Users
         */
        usersList: (query, params = {}) => this.request({
            path: `/Users`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name UsersCreate
         * @summary Add new user
         * @request POST:/Users
         */
        usersCreate: (data, params = {}) => this.request({
            path: `/Users`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name UsersUpdate
         * @summary Update user
         * @request PUT:/Users
         */
        usersUpdate: (data, params = {}) => this.request({
            path: `/Users`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name UsersDelete
         * @summary Removes user from active list
         * @request DELETE:/Users
         */
        usersDelete: (query, params = {}) => this.request({
            path: `/Users`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name GetUserInfoList
         * @summary Get user info
         * @request GET:/Users/GetUserInfo
         */
        getUserInfoList: (query, params = {}) => this.request({
            path: `/Users/GetUserInfo`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name MultipleUpdate
         * @summary Update multiple users
         * @request PUT:/Users/Multiple
         */
        multipleUpdate: (data, params = {}) => this.request({
            path: `/Users/Multiple`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name PicturesCreate
         * @summary Uploads picture
         * @request POST:/Users/Pictures
         */
        picturesCreate: (query, data, params = {}) => this.request({
            path: `/Users/Pictures`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name PicturesDelete
         * @summary Delete picture
         * @request DELETE:/Users/Pictures
         */
        picturesDelete: (query, params = {}) => this.request({
            path: `/Users/Pictures`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name GetFullInfoList
         * @summary Get users full info
         * @request GET:/Users/GetFullInfo
         */
        getFullInfoList: (query, params = {}) => this.request({
            path: `/Users/GetFullInfo`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name AddWebUsersCreate
         * @summary Creates web users for requested users
         * @request POST:/Users/AddWebUsers
         */
        addWebUsersCreate: (data, params = {}) => this.request({
            path: `/Users/AddWebUsers`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name ChangePasswordUpdate
         * @summary Updates web users password
         * @request PUT:/Users/ChangePassword
         */
        changePasswordUpdate: (data, params = {}) => this.request({
            path: `/Users/ChangePassword`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name DisableWebUserUpdate
         * @summary Disables web user
         * @request PUT:/Users/DisableWebUser
         */
        disableWebUserUpdate: (params = {}) => this.request({
            path: `/Users/DisableWebUser`,
            method: "PUT",
            format: "json",
            ...params,
        }),
    };
    userSkills = {
        /**
         * No description
         *
         * @tags UserSkills
         * @name UserSkillsCreate
         * @summary Creates new user skill object
         * @request POST:/UserSkills
         */
        userSkillsCreate: (data, params = {}) => this.request({
            path: `/UserSkills`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserSkills
         * @name UserSkillsUpdate
         * @summary Update user skill data in database
         * @request PUT:/UserSkills
         */
        userSkillsUpdate: (data, params = {}) => this.request({
            path: `/UserSkills`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserSkills
         * @name UserSkillsList
         * @summary Get user skills from database
         * @request GET:/UserSkills
         */
        userSkillsList: (query, params = {}) => this.request({
            path: `/UserSkills`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags UserSkills
         * @name UserSkillsDelete
         * @summary Delete user skill
         * @request DELETE:/UserSkills
         */
        userSkillsDelete: (query, params = {}) => this.request({
            path: `/UserSkills`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    vacations = {
        /**
         * No description
         *
         * @tags Vacations
         * @name VacationsList
         * @summary Vacation events requesting
         * @request GET:/Vacations
         */
        vacationsList: (query, params = {}) => this.request({
            path: `/Vacations`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    verifications = {
        /**
         * No description
         *
         * @tags Verifications
         * @name VerificationsList
         * @summary Verifies period data against wanted verifiables.
         * @request GET:/Verifications
         */
        verificationsList: (query, params = {}) => this.request({
            path: `/Verifications`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    versions = {
        /**
         * No description
         *
         * @tags Versions
         * @name VersionsList
         * @summary Returns versions
         * @request GET:/Versions
         */
        versionsList: (params = {}) => this.request({
            path: `/Versions`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    workCenterCodes = {
        /**
         * No description
         *
         * @tags WorkCenterCodes
         * @name WorkCenterCodesList
         * @summary Returns workcenter codes
         * @request GET:/WorkCenterCodes
         */
        workCenterCodesList: (query, params = {}) => this.request({
            path: `/WorkCenterCodes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkCenterCodes
         * @name WorkCenterCodesCreate
         * @summary Sets workcenter code
         * @request POST:/WorkCenterCodes
         */
        workCenterCodesCreate: (data, params = {}) => this.request({
            path: `/WorkCenterCodes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkCenterCodes
         * @name WorkCenterCodesUpdate
         * @summary Updates workcenter code
         * @request PUT:/WorkCenterCodes
         */
        workCenterCodesUpdate: (data, params = {}) => this.request({
            path: `/WorkCenterCodes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkCenterCodes
         * @name WorkCenterCodesDelete
         * @summary Soft-deletes workcenter code
         * @request DELETE:/WorkCenterCodes
         */
        workCenterCodesDelete: (query, params = {}) => this.request({
            path: `/WorkCenterCodes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    workDayEvents = {
        /**
         * No description
         *
         * @tags WorkDayEvents
         * @name WorkDayEventsList
         * @summary Returns workday events
         * @request GET:/WorkDayEvents
         */
        workDayEventsList: (query, params = {}) => this.request({
            path: `/WorkDayEvents`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkDayEvents
         * @name WorkDayEventsCreate
         * @summary Creates workday event object
         * @request POST:/WorkDayEvents
         */
        workDayEventsCreate: (data, params = {}) => this.request({
            path: `/WorkDayEvents`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkDayEvents
         * @name WorkDayEventsUpdate
         * @summary Updates workday event object
         * @request PUT:/WorkDayEvents
         */
        workDayEventsUpdate: (data, params = {}) => this.request({
            path: `/WorkDayEvents`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * No description
     *
     * @tags WorkDayEvents
     * @name WorkDayEventsDelete
     * @summary Deletes workday event object.
    If event is onetime event and its date is in future or today then event is hard-deleted
    else soft-deleted.
    If event is recurring and its date date is in future or today then event is hard-deleted
    else it is soft-deleted and its stopDate is set to day before today.
     * @request DELETE:/WorkDayEvents
     */
        workDayEventsDelete: (query, params = {}) => this.request({
            path: `/WorkDayEvents`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    workDayEventTypes = {
        /**
         * No description
         *
         * @tags WorkDayEventTypes
         * @name WorkDayEventTypesList
         * @summary Returns workday event types
         * @request GET:/WorkDayEventTypes
         */
        workDayEventTypesList: (params = {}) => this.request({
            path: `/WorkDayEventTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    workDays = {
        /**
         * No description
         *
         * @tags WorkDays
         * @name WorkDaysList
         * @summary Returns workdays for given period of time with working hours
         * @request GET:/WorkDays
         */
        workDaysList: (query, params = {}) => this.request({
            path: `/WorkDays`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    workEffortTypes = {
        /**
         * No description
         *
         * @tags WorkEffortTypes
         * @name WorkEffortTypesList
         * @summary Returns work effort types
         * @request GET:/WorkEffortTypes
         */
        workEffortTypesList: (params = {}) => this.request({
            path: `/WorkEffortTypes`,
            method: "GET",
            format: "json",
            ...params,
        }),
    };
    workGroups = {
        /**
         * No description
         *
         * @tags WorkGroups
         * @name WorkGroupsList
         * @summary Returns workgroups. Output can be filtered by ids.
         * @request GET:/WorkGroups
         */
        workGroupsList: (query, params = {}) => this.request({
            path: `/WorkGroups`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkGroups
         * @name WorkGroupsCreate
         * @summary Inserts new workgroup.
         * @request POST:/WorkGroups
         */
        workGroupsCreate: (data, params = {}) => this.request({
            path: `/WorkGroups`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkGroups
         * @name WorkGroupsUpdate
         * @summary Updates workgroup.
         * @request PUT:/WorkGroups
         */
        workGroupsUpdate: (data, params = {}) => this.request({
            path: `/WorkGroups`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkGroups
         * @name WorkGroupsDelete
         * @summary Deletes workgroup.
         * @request DELETE:/WorkGroups
         */
        workGroupsDelete: (query, params = {}) => this.request({
            path: `/WorkGroups`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    workShiftDepartments = {
        /**
         * No description
         *
         * @tags WorkShiftDepartments
         * @name MultipleCreate
         * @summary Sets multiple work shifts to multiple departments associations.
         * @request POST:/WorkShiftDepartments/Multiple
         */
        multipleCreate: (data, params = {}) => this.request({
            path: `/WorkShiftDepartments/Multiple`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkShiftDepartments
         * @name MultipleDelete
         * @summary Delete work shifts from departments
         * @request DELETE:/WorkShiftDepartments/Multiple
         */
        multipleDelete: (query, params = {}) => this.request({
            path: `/WorkShiftDepartments/Multiple`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkShiftDepartments
         * @name WorkShiftDepartmentsList
         * @summary Gets work shifts and departments associations.
         * @request GET:/WorkShiftDepartments
         */
        workShiftDepartmentsList: (query, params = {}) => this.request({
            path: `/WorkShiftDepartments`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    workShifts = {
        /**
         * No description
         *
         * @tags WorkShifts
         * @name WorkShiftsList
         * @summary Returns work shifts
         * @request GET:/WorkShifts
         */
        workShiftsList: (query, params = {}) => this.request({
            path: `/WorkShifts`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkShifts
         * @name WorkShiftsCreate
         * @summary Creates work shift object
         * @request POST:/WorkShifts
         */
        workShiftsCreate: (data, params = {}) => this.request({
            path: `/WorkShifts`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkShifts
         * @name WorkShiftsUpdate
         * @summary Updates work shift object
         * @request PUT:/WorkShifts
         */
        workShiftsUpdate: (data, params = {}) => this.request({
            path: `/WorkShifts`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkShifts
         * @name WorkShiftsDelete
         * @summary Deletes work shift object
         * @request DELETE:/WorkShifts
         */
        workShiftsDelete: (query, params = {}) => this.request({
            path: `/WorkShifts`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkShifts
         * @name GetByDepartmentsList
         * @summary Returns work shifts
         * @request GET:/WorkShifts/GetByDepartments
         */
        getByDepartmentsList: (query, params = {}) => this.request({
            path: `/WorkShifts/GetByDepartments`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
    };
    worksites = {
        /**
         * No description
         *
         * @tags Worksites
         * @name WorksitesList
         * @summary Returns worksites
         * @request GET:/Worksites
         */
        worksitesList: (query, params = {}) => this.request({
            path: `/Worksites`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Worksites
         * @name WorksitesCreate
         * @summary Creates worksite object
         * @request POST:/Worksites
         */
        worksitesCreate: (data, params = {}) => this.request({
            path: `/Worksites`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Worksites
         * @name WorksitesUpdate
         * @summary Updates worksite object
         * @request PUT:/Worksites
         */
        worksitesUpdate: (data, params = {}) => this.request({
            path: `/Worksites`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Worksites
         * @name WorksitesDelete
         * @summary Soft deletes worksite object.
         * @request DELETE:/Worksites
         */
        worksitesDelete: (query, params = {}) => this.request({
            path: `/Worksites`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
    workTimeCalculationTypes = {
        /**
         * No description
         *
         * @tags WorkTimeCalculationTypes
         * @name WorkTimeCalculationTypesList
         * @summary Get stored work time calculation type values.
         * @request GET:/WorkTimeCalculationTypes
         */
        workTimeCalculationTypesList: (query, params = {}) => this.request({
            path: `/WorkTimeCalculationTypes`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkTimeCalculationTypes
         * @name WorkTimeCalculationTypesCreate
         * @summary Insert new work time calculation type
         * @request POST:/WorkTimeCalculationTypes
         */
        workTimeCalculationTypesCreate: (data, params = {}) => this.request({
            path: `/WorkTimeCalculationTypes`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkTimeCalculationTypes
         * @name WorkTimeCalculationTypesUpdate
         * @summary Update work time calculation type
         * @request PUT:/WorkTimeCalculationTypes
         */
        workTimeCalculationTypesUpdate: (data, params = {}) => this.request({
            path: `/WorkTimeCalculationTypes`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags WorkTimeCalculationTypes
         * @name WorkTimeCalculationTypesDelete
         * @summary Delete work time calculation type
         * @request DELETE:/WorkTimeCalculationTypes
         */
        workTimeCalculationTypesDelete: (query, params = {}) => this.request({
            path: `/WorkTimeCalculationTypes`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
    };
}
